import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import AsyncInspectionsPanel from './AsyncInspectionsPanel';
import { OFFLINE_FIELD_MODE } from '../../config/features';
import {
  Box,
  Paper,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel,
  TextField,
  Skeleton,
Button,
  Chip,
  CircularProgress,
  Snackbar,
  Alert,
  Tooltip,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  IconButton,
  LinearProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  Menu,
  ListItemIcon,
  ListItemText,
  Divider,
  Collapse,
  ToggleButtonGroup,
  ToggleButton,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Tab,
  Tabs,
  InputAdornment,
  Switch,
  FormControlLabel,
  Popover
} from '@mui/material';
import {
  Search,
  LocalShipping as LocalShippingIcon,
  FilterList,
  Download,
  CheckCircle,
  RadioButtonUnchecked,
  Assignment,
  PlayArrow,
  AttachFile,
  Description,
  Folder,
  Add as AddIcon,
  Delete as DeleteIcon,
  People as PeopleIcon,
  Edit,
  Save as SaveIcon,
  Assessment,
  MoreVert,
  NoteAdd,
  Refresh as RefreshIcon,
  Warning,
  Error as ErrorIcon,
  FactCheck,
  OpenInNew,
  ExpandMore as ExpandMoreIcon,
  FormatListBulleted as FormatListBulletedIcon,
  Person as PersonIcon,
  AccountBalance as AccountBalanceIcon,
  Store as StoreIcon,
  RemoveCircleOutline as RemoveCircleOutlineIcon,
  AccessTime as AccessTimeIcon,
  VerifiedUser as VerifiedUserIcon,
  StickyNote2 as StickyNote2Icon,
  Close as CloseIcon,
  Gavel as GavelIcon,
  Drafts as DraftsIcon,
  Lock as LockIcon,
  Timelapse as TimelapseIcon,
  Event as EventIcon
} from '@mui/icons-material';
import api from '../../config/axiosConfig';
import { FIELD_LIMITS } from '../../constants/fieldLimits';
import UploadDocumentosDialog from './UploadDocumentosDialog';
import PipcProgressDialog from './PipcProgressDialog';
import EntregaClienteDialog from './EntregaClienteDialog';
import { canManageDeliveries } from '../../utils/deliveryStages';
import { useDocumentCategories } from '../../constants/documentTypes';
import { getExpirationStatus } from '../../utils/documentExpiration';
import { localTodayIso } from '../../utils/localDate';
import { capitalizePersonName } from '../../utils/textCase';
import { buildWorkflowSteps, isPipComplete } from '../../utils/workflowSteps';
import ReturnToValidationBanner from '../common/ReturnToValidation';
import ServerUnavailable from '../common/ServerUnavailable';

const Programas = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [workOrders, setWorkOrders] = useState([]);
  const [filteredWorkOrders, setFilteredWorkOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  // Falla al cargar la pantalla: 'network' (backend abajo) | 'server' -> vista "Sin conexión"
  const [loadErrorKind, setLoadErrorKind] = useState(null);
  const [currentUser, setCurrentUser] = useState(null);
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'info' });
  const [genDialog, setGenDialog] = useState({ open: false, loading: false, results: null, error: null, docType: 'PIPC', progressPct: 0, totalEntities: 1 });
  const [riskLevelFilter, setRiskLevelFilter] = useState('');
  const [selectedWorkOrder, setSelectedWorkOrder] = useState(null);
  const [pipcFilePaths, setPipcFilePaths] = useState({}); // Guardar rutas de archivos PIPC generados
  const [pipCompletionStatus, setPipCompletionStatus] = useState({}); // Estado de completitud del PIP por quotationId 
  const [pipStatus, setPipStatus] = useState({});
  const [pipStatusLoaded, setPipStatusLoaded] = useState(false);
  // La tabla se muestra en cuanto llegan las órdenes; entes/asignación se llenan después
  const [entitiesLoaded, setEntitiesLoaded] = useState(false);
  
  // Estados para el popover de notas -- historial de notas por cotización (QuotationNote,
  // GET/POST /quotations/{id}/notes), mismo sistema y componente que Estadísticas de
  // Cotizaciones (antes esto era un solo campo WorkOrder.internalNotes que se sobreescribía).
  const [notesAnchorEl, setNotesAnchorEl] = useState(null);
  const [selectedWorkOrderForNotes, setSelectedWorkOrderForNotes] = useState(null);
  const [notesList, setNotesList] = useState([]);
  const [notesLoading, setNotesLoading] = useState(false);
  const [noteInput, setNoteInput] = useState('');
  const [notesSaving, setNotesSaving] = useState(false);

  // Estados para el popover de notas POR ENTE -- tabla compartida general_notes (note_type
  // 'ENTE'), GET/POST /work-order-details/{detailId}/notes. Independiente del popover de notas
  // de cotización de arriba (mismo componente/estilo, distinto backend y alcance).
  const [entityNotesAnchorEl, setEntityNotesAnchorEl] = useState(null);
  const [selectedEntityForNotes, setSelectedEntityForNotes] = useState(null);
  const [entityNotesList, setEntityNotesList] = useState([]);
  const [entityNotesLoading, setEntityNotesLoading] = useState(false);
  const [entityNoteInput, setEntityNoteInput] = useState('');
  const [entityNotesSaving, setEntityNotesSaving] = useState(false);

  // Estados para el modal de subir archivos
  const [uploadDialogOpen, setUploadDialogOpen] = useState(false);
  const [selectedQuotationForUpload, setSelectedQuotationForUpload] = useState(null);
  const [pipDialogOpen, setPipDialogOpen] = useState(false);
  const [pipFormData, setPipFormData] = useState({});
  const [terceroAcreditado, setTerceroAcreditado] = useState({ thirdPartyAccredited: '', registrationNumber: '', reviewedBy: '' });
  // "Aprobado por" = representante legal de la empresa -- se lee directo y en vivo de Company
  // (no de PipRelated.approvedBy, que quedaba desconectado y desactualizado).
  const [pipApprovedByLegalRep, setPipApprovedByLegalRep] = useState('');
  // Edición en línea de "Aprobó": null = no se está editando; se guarda en la empresa (fuente única)
  const [approverDraft, setApproverDraft] = useState(null);
  const [approverSaving, setApproverSaving] = useState(false);
  
  // Estados para UIPC (Unidad Interna de Protección Civil)
  const [uipcMembers, setUipcMembers] = useState([]);

  // Estados para UIPC por ente (por schedule)
  const [workOrderSchedules, setWorkOrderSchedules] = useState([]);
  const [entityUipcMembers, setEntityUipcMembers] = useState({});     // { scheduleId: [members] }
  const [newEntityUipcMember, setNewEntityUipcMember] = useState({}); // { scheduleId: { workerName, brigadePosition } }
  // Entes de cada orden tal como llegan del lote de la tabla -- "Captura UIPC" abre con ellos sin
  // esperar el /sync pesado. { workOrderId: [WorkOrderDetail] }
  const [workOrderDetailsById, setWorkOrderDetailsById] = useState({});
  const [uipcMembersLoading, setUipcMembersLoading] = useState(false);
  // "Editar PIPC" abre con los entes de la tabla mientras el /sync completo corre en segundo plano;
  // lo que depende de él (info de inspección del ente) queda bloqueado hasta que termina.
  const [pipSchedulesSyncing, setPipSchedulesSyncing] = useState(false);
  // Diálogo "Captura UIPC" -- saca la captura de miembros de brigada del tab UIPC de "Editar
  // PIPC" a un diálogo propio, más chico y enfocado. Reutiliza el mismo estado de siempre
  // (workOrderSchedules/entityUipcMembers/etc.) porque ambos operan sobre la misma orden.
  const [uipcCaptureDialogOpen, setUipcCaptureDialogOpen] = useState(false);
  const [expandedUipcEntity, setExpandedUipcEntity] = useState(false);

  // Info de perfil-riesgo/llenar-informacion (quotation_entities) editable también aquí --
  // { scheduleId: { inspectorContact, requiresPpe, ppeDetails, scheduledDate, scheduledTimeStart } }
  const [entityQuotationEdits, setEntityQuotationEdits] = useState({});
  const [savingQuotationInfo, setSavingQuotationInfo] = useState(null);
  const [cartaData, setCartaData] = useState({ loading: false, error: null, byDetail: {} });
  const [cartaEdits, setCartaEdits] = useState({});
  const [savingCarta, setSavingCarta] = useState(null);
  const [pendingCartaFocus, setPendingCartaFocus] = useState(null);
  // OT cuya "Validar Campos" abrió la sección de la Carta: al guardar se regresa a esa validación
  const [cartaReturnWorkOrder, setCartaReturnWorkOrder] = useState(null);

  // Estados para las pestañas "Datos del Inmueble" y "Seguro" por ente (mismo patrón que UIPC por
  // ente). Ambas pestañas comparten la misma data por ente (entityPropertyData) -- vienen del mismo
  // registro (Company/CompanyBranch) -- pero cada una controla su propio accordion expandido.
  // entityPropertyData: { [scheduleId]: { loading, saving, loaded, error, data: CompanyDTO|CompanyBranchDTO } }
  const [expandedInmuebleEntity, setExpandedInmuebleEntity] = useState(false);
  // Editar PIPC > Datos del Inmueble: sub-pestaña elegida por ente ({ [scheduleId]: 'CARTA' })
  const [pipEnteTab, setPipEnteTab] = useState({});
  // Editar PIPC: detalle del encabezado (las tarjetas de la OT) desplegado
  const [pipHeaderExpanded, setPipHeaderExpanded] = useState(false);
  const [expandedSeguroEntity, setExpandedSeguroEntity] = useState(false);
  const [entityPropertyData, setEntityPropertyData] = useState({});
  // Corrección en sitio de datos con los que se cotizó (bloqueados con la OT abierta): pide motivo
  // y avisa a Ventas/Administración para revisar el costo. { schedule, changes: [{label, from, to}], reason }
  const [correctionDialog, setCorrectionDialog] = useState(null);

  // Tab "Documentos" por ente -- resumen (subidos/total/vencidos) cargado bajo demanda al
  // expandir cada acordeón, mismo patrón lazy-load que Datos del Inmueble/Seguro.
  // { scheduleId: { loading, loaded, error, uploadedCount, expiredCount } }
  const [documentsSummaryByEntity, setDocumentsSummaryByEntity] = useState({});
  const [expandedDocumentosEntity, setExpandedDocumentosEntity] = useState(false);
  const [uploadDialogBranch, setUploadDialogBranch] = useState(null);
  // Representante legal y seguro de la matriz -- se usan como referencia de solo lectura en las
  // sucursales (CompanyBranch no tiene representante legal propio, y si insuranceSameForBranches
  // es true el seguro propio de la sucursal se ignora en todo el sistema).
  const [companyInsuranceInfo, setCompanyInsuranceInfo] = useState({});

  // Estados para avance PIPC
  const [progressData, setProgressData] = useState({});
  // "Listo para generar" por cotización (campos requeridos del PIPC + documentos, por ente).
  // Llega aparte y después del avance operativo porque es más pesado. undefined = cargando.
  const [readinessData, setReadinessData] = useState({});
  // Avance operativo por ente (quién va cómo): { quotationId: [ { entityName, assignedUserId,
  // assignedUserName, percentage, asignado, uipc, evaluacion, scheduledDate, estimatedCompletionDate, ... } ] }
  const [progressEntities, setProgressEntities] = useState({});
  const [expandedOrders, setExpandedOrders] = useState(() => new Set());
  const [onlyOverdue, setOnlyOverdue] = useState(false);
  const [progressDialogOpen, setProgressDialogOpen] = useState(false);
  const [selectedWorkOrderForProgress, setSelectedWorkOrderForProgress] = useState(null);
  

  // Estados para el menú de selección de ente al descargar PIPC/Reporte
  const [docsMenu, setDocsMenu] = useState({ anchorEl: null, items: [], docLabel: '' });

  // Estados para menú desplegable de acciones
  const [anchorEl, setAnchorEl] = useState(null);
  // Estado del flujo de la OT del menú (documentos generados, calidad, entrega, constancias, envío)
  const [workflowStatus, setWorkflowStatus] = useState(null);
  // Menú compacto de "Notas (N)" -- reemplaza la fila de chips (Nota OT + 1 por ente) que se
  // envolvía y desordenaba la columna Acciones cuando había varios entes. Se muestra siempre
  // (a diferencia del menú de Fase 1-4, que se oculta mientras el PIP no ha iniciado).
  const [notesMenuAnchor, setNotesMenuAnchor] = useState(null);
  const [notesMenuWorkOrder, setNotesMenuWorkOrder] = useState(null);
  const [selectedWorkOrderForMenu, setSelectedWorkOrderForMenu] = useState(null);
  // Ente que se está viendo en el menú de la OT (branchId o 'MATRIZ'); null = el primero
  const [menuEnteKey, setMenuEnteKey] = useState(null);
  const [deliveryWorkOrder, setDeliveryWorkOrder] = useState(null);

  // Estados para diálogo de validación de campos
  const [validationDialogOpen, setValidationDialogOpen] = useState(false);
  const [validationData, setValidationData] = useState(null);
  const [validationLoading, setValidationLoading] = useState(false);
  const [selectedWorkOrderForValidation, setSelectedWorkOrderForValidation] = useState(null);
  const [expandedEntities, setExpandedEntities] = useState({});
  // Pestaña de documento elegida por ente en Validar Campos ({ matriz: 'CARTA', branch_0: 'RIC' })
  const [validationDocTab, setValidationDocTab] = useState({});
  // Categorías de Documentos de Cumplimiento abiertas ("matriz|Protección Civil")
  const [openDocCategories, setOpenDocCategories] = useState(new Set());
  // Clave `${docType}-${entityId||'matriz'}` del botón "Generar" en curso dentro del diálogo de
  // Validación de Campos -- antes solo existía "generar para TODOS los entes" desde el menú ⋮;
  // esto genera un solo RIC/PIPC para el ente puntual que se está revisando.
  const [generatingEntityDoc, setGeneratingEntityDoc] = useState(null);

  // Estados para diálogo de confirmación previo a "Generar Constancias"
  const [constanciasSummaryDialogOpen, setConstanciasSummaryDialogOpen] = useState(false);
  const [constanciasSummaryLoading, setConstanciasSummaryLoading] = useState(false);
  const [constanciasSummary, setConstanciasSummary] = useState([]);
  const [constanciasSummaryWorkOrder, setConstanciasSummaryWorkOrder] = useState(null);
  const [constanciasSummaryDetailId, setConstanciasSummaryDetailId] = useState(null);
  const [constanciasGenerating, setConstanciasGenerating] = useState(false);
  // Barra de avance simulada mientras se generan (mismo patrón que RIC/PIPC)
  const [constanciasProgress, setConstanciasProgress] = useState({ progressPct: 0 });
  const [pipActiveTab, setPipActiveTab] = useState(0);
  const [workOrderEntityMap, setWorkOrderEntityMap] = useState({});
  const [workOrderAssignedMap, setWorkOrderAssignedMap] = useState({});
  // Desglose ente -> ejecutivo asignado para la columna "Asignado a"
  // ({ workOrderId: [{ entityName, assignedInspector }] }).
  const [workOrderAssignmentDetailsMap, setWorkOrderAssignmentDetailsMap] = useState({});
  const [readinessMap, setReadinessMap] = useState({});

  // Mismo catálogo que usan perfil-riesgo/llenar-informacion y Subir Archivos -- el total
  // requerido es igual para cualquier ente (matriz o sucursal).
  const { categories: docCategories } = useDocumentCategories();
  const totalDocsRequired = docCategories.flatMap(c => c.docs).length;

  const userRole = currentUser?.role?.name || currentUser?.role || '';
  const normalizedRole = userRole.toString().toUpperCase();
  const isAdmin = normalizedRole === 'ADMIN' || normalizedRole === 'ADMINISTRADOR';
  const canEditBasePip = isAdmin || normalizedRole === 'COORDINADOR_OPERACIONES' || normalizedRole === 'COORDINADOR DE OPERACIONES';
  const canEditUipcByEntity = isAdmin || normalizedRole === 'EJECUTIVO_OPERACIONES' || normalizedRole === 'EJECUTIVO DE OPERACIONES';
  const isExecutiveRole = normalizedRole === 'EJECUTIVO_OPERACIONES' || normalizedRole === 'EJECUTIVO DE OPERACIONES';
  // Datos del Inmueble, Seguro y Documentos por ente: también el Ejecutivo (los captura en sitio)
  const canEditEntityPip = canEditBasePip || canEditUipcByEntity;
  
  const [filters, setFilters] = useState({
    orderNumber: '',
    cliente: '',
    empresa: '',
    servicio: '',
    estado: '',
    asignado: ''
  });

  useEffect(() => {
    fetchCurrentUser();
    api.get('/pip-related/tercero-acreditado')
      .then((resp) => setTerceroAcreditado(resp.data))
      .catch((e) => console.warn('No se pudo cargar el tercero acreditado:', e));
  }, []);

  useEffect(() => {
    if (currentUser) {
      fetchWorkOrders();
      fetchPipcFilePaths();
    }
  }, [currentUser, riskLevelFilter]);

  // Debug: Verificar cuando cambian los miembros de UIPC
  useEffect(() => {
    console.log('🔄 Estado uipcMembers actualizado:', uipcMembers);
    console.log('📊 Cantidad de miembros:', uipcMembers.length);
  }, [uipcMembers]);

  const fetchCurrentUser = async () => {
    try {
      const response = await api.get('/users/me');
      setCurrentUser(response.data);
      console.log('👤 Usuario actual:', response.data);
    } catch (err) {
      console.error('Error al obtener usuario actual:', err);
      setError('Error al obtener información del usuario');
      setLoadErrorKind(err.response ? 'server' : 'network');
      setLoading(false);
    }
  };

  // Entes y ejecutivo asignado por orden. Antes era un POST /sync por fila (lento y escribía en
  // la BD en cada carga); ahora es una sola lectura para todas. Solo las órdenes que aún no tienen
  // entes creados pasan por /sync. El sync completo corre al abrir el diálogo de cada orden.
  // merge=true: actualiza solo esas órdenes sin tocar el resto (refresco de una fila).
  const fetchWorkOrderEntities = async (orders, isAdminOrCoordinator, merge = false) => {
    if (!orders || orders.length === 0) {
      if (!merge) {
        setWorkOrderEntityMap({});
        setWorkOrderAssignedMap({});
        setWorkOrderAssignmentDetailsMap({});
      }
      return;
    }

    const byOrder = {};
    try {
      const resp = await api.get('/work-order-details/by-work-order-ids', { params: { ids: orders.map((o) => o.id).join(',') } });
      (Array.isArray(resp.data) ? resp.data : []).forEach((d) => {
        if (!byOrder[d.workOrderId]) byOrder[d.workOrderId] = [];
        byOrder[d.workOrderId].push(d);
      });
    } catch (err) {
      console.error('Error cargando entes de las órdenes:', err);
    }
    await Promise.all(orders.filter((o) => !byOrder[o.id]).map(async (workOrder) => {
      try {
        const schedulesResp = await api.post(`/work-order-details/work-order/${workOrder.id}/sync`);
        byOrder[workOrder.id] = Array.isArray(schedulesResp.data) ? schedulesResp.data : [];
      } catch {
        byOrder[workOrder.id] = [];
      }
    }));

    const entries = orders.map((workOrder) => {
      const schedules = byOrder[workOrder.id] || [];
      const activeSchedules = schedules.filter((s) => s?.status !== 'CANCELADA');
      const visibleSchedules = isAdminOrCoordinator
        ? activeSchedules
        : activeSchedules.filter((s) => Number(s?.assignedUserId) === Number(currentUser?.id));

      const entityMap = new Map();
      visibleSchedules.forEach((s) => {
        if (s?.entityName && !entityMap.has(s.entityName)) {
          entityMap.set(s.entityName, { type: s.entityType, branchId: s.branchId ?? null, detailId: s.id });
        }
      });
      // detailId = WorkOrderDetail.id -- se usa para las notas por ente (general_notes).
      const entities = Array.from(entityMap.entries()).map(([name, info]) => ({ name, type: info.type, branchId: info.branchId, detailId: info.detailId }));
      const assignedNames = [...new Set(visibleSchedules.map((s) => s?.assignedInspector).filter(Boolean))];
      // Un renglón por ente (matriz/sucursal) con su ejecutivo -- para desglosar
      // "Asignado a" cuando la orden tiene varios entes con distinto responsable.
      const assignmentDetails = visibleSchedules.map((s) => ({
        entityName: s?.entityName || (s?.entityType === 'MATRIZ' ? 'Matriz' : 'Sucursal'),
        assignedInspector: s?.assignedInspector || null
      }));
      return [workOrder.id, entities, assignedNames, assignmentDetails];
    });

    const rawById = Object.fromEntries(orders.map((o) => [o.id, byOrder[o.id] || []]));
    setWorkOrderDetailsById(prev => (merge ? { ...prev, ...rawById } : rawById));
    const entityMapById = Object.fromEntries(entries.map(([id, entities]) => [id, entities]));
    const assignedById = Object.fromEntries(entries.map(([id, , names]) => [id, names]));
    const detailsById = Object.fromEntries(entries.map(([id, , , details]) => [id, details]));
    setWorkOrderEntityMap(prev => (merge ? { ...prev, ...entityMapById } : entityMapById));
    setWorkOrderAssignedMap(prev => (merge ? { ...prev, ...assignedById } : assignedById));
    setWorkOrderAssignmentDetailsMap(prev => (merge ? { ...prev, ...detailsById } : detailsById));
  };

  const fetchReadiness = async (orders, merge = false) => {
    const quotationIds = [...new Set((orders || []).map((wo) => wo.quotationId).filter(Boolean))];
    if (quotationIds.length === 0) return;
    if (!merge) setReadinessData({});
    try {
      const resp = await api.get('/pip-related/readiness', { params: { quotationIds: quotationIds.join(',') } });
      const data = Object.fromEntries(quotationIds.map((qid) => [qid, resp.data?.[qid] || null]));
      setReadinessData(prev => (merge ? { ...prev, ...data } : data));
    } catch (err) {
      console.error('Error cargando "listo para generar":', err);
      setReadinessData(prev => ({ ...prev, ...Object.fromEntries(quotationIds.map((qid) => [qid, null])) }));
    }
  };

  const isAdminOrCoordinatorRole = () => {
    const userRole = currentUser?.role?.name || currentUser?.role;
    return userRole === 'ADMINISTRADOR' ||
      userRole === 'ADMIN' ||
      userRole === 'Coordinador de operaciones' ||
      userRole === 'COORDINADOR_OPERACIONES' ||
      userRole === 'SUPERVISOR_CALIDAD';
  };

  // D) Refresca solo la fila de una orden (al cerrar su diálogo), sin recargar toda la tabla.
  // Estado del menú de acciones (pasos por ente). Solo se toca si el menú muestra esta orden.
  const reloadWorkflowStatus = (workOrder) => api.get(`/work-orders/${workOrder.id}/workflow-status`)
    .then((resp) => setWorkflowStatus(prev => (prev && prev.workOrderId !== workOrder.id ? prev : { workOrderId: workOrder.id, data: resp.data })))
    .catch(() => setWorkflowStatus(prev => (prev && prev.workOrderId !== workOrder.id ? prev : { workOrderId: workOrder.id, data: null })));

  const refreshWorkOrderRow = async (workOrder) => {
    if (!workOrder?.id) return;
    try {
      const resp = await api.get(`/work-orders/${workOrder.id}`);
      if (resp.data) setWorkOrders(prev => prev.map(wo => (wo.id === workOrder.id ? { ...wo, ...resp.data } : wo)));
    } catch (err) {
      console.error('Error refrescando la orden de trabajo:', err);
    }
    await Promise.all([
      fetchWorkOrderEntities([workOrder], isAdminOrCoordinatorRole(), true),
      fetchPipStatuses([workOrder], true),
      fetchReadiness([workOrder], true),
      // Lo que se acaba de generar/subir también debe verse en el menú sin recargar la página
      reloadWorkflowStatus(workOrder),
      refreshReadinessForWorkOrder(workOrder.id, { verifyDropbox: false }),
    ].map(p => Promise.resolve(p).catch(() => {})));
  };

  const fetchWorkOrders = async () => {
    try {
      setLoading(true);
      
      // Obtener todas las órdenes de trabajo
      const workOrdersResponse = await api.get('/work-orders');
      let allWorkOrders = workOrdersResponse.data.content || workOrdersResponse.data || [];
      
      // Filtrar por nivel de riesgo si se seleccionó uno
      if (riskLevelFilter) {
        const riskMap = {
          'bajo': ['bajo', 'low'],
          'medio': ['medio', 'medium', 'media'],
          'alto': ['alto', 'high', 'muy alto', 'alta']
        };
        const allowedValues = riskMap[riskLevelFilter] || [];
        allWorkOrders = allWorkOrders.filter(wo =>
          allowedValues.includes(wo.riskLevel?.toLowerCase())
        );
      }
      
      // Filtrar por usuario si no es Administrador, Coordinador de operaciones o Supervisor de
      // Calidad -- este último debe ver TODAS las órdenes para dar seguimiento, no solo las
      // asignadas a él (nunca aparece como ejecutivo asignado en ningún ente).
      const userRole = currentUser?.role?.name || currentUser?.role;
      const isAdminOrCoordinator =
        userRole === 'ADMINISTRADOR' ||
        userRole === 'ADMIN' ||
        userRole === 'Coordinador de operaciones' ||
        userRole === 'COORDINADOR_OPERACIONES' ||
        userRole === 'SUPERVISOR_CALIDAD';
      
      let filteredOrders = allWorkOrders;
      
      if (!isAdminOrCoordinator) {
        const idsResponse = await api.get(`/work-order-details/user/${currentUser.id}/work-order-ids`);
        const assignedWorkOrderIds = new Set(idsResponse.data);
        filteredOrders = allWorkOrders.filter(wo => assignedWorkOrderIds.has(wo.id));
        console.log(`🔍 Usuario ${currentUser.username} (${userRole}) - Órdenes asignadas: ${filteredOrders.length}/${allWorkOrders.length}`);
      } else {
        console.log(`👑 Usuario ${currentUser.username} (${userRole}) - Ver todas las órdenes: ${filteredOrders.length}`);
      }
      
      setWorkOrders(filteredOrders);
      // Mostrar la tabla ya: entes, asignación, estado del PIP y avance llegan en segundo plano
      setLoading(false);
      fetchPipStatuses(filteredOrders);
      fetchReadiness(filteredOrders);
      setEntitiesLoaded(false);
      fetchWorkOrderEntities(filteredOrders, isAdminOrCoordinator)
        .catch((err) => console.error('Error cargando entes de las órdenes:', err))
        .finally(() => setEntitiesLoaded(true));
    } catch (err) {
      console.error('Error al obtener órdenes de trabajo:', err);
      setError('Error al cargar las órdenes de trabajo');
      setLoadErrorKind(err.response ? 'server' : 'network');
      setWorkOrderEntityMap({});
      setWorkOrderAssignedMap({});
    } finally {
      setLoading(false);
    }
  };

  // Función para obtener las rutas de archivos PIPC existentes
  const fetchPipcFilePaths = async () => {
    try {
      console.log('📁 Cargando rutas de archivos PIPC y Reportes existentes...');
      
      // Obtener todos los documentos (PIPC y Reportes)
      const response = await api.get('/files/pipc/paths');
      const documentsData = response.data;

      console.log('📁 Datos de documentos obtenidos:', documentsData);

      // Actualizar el estado con los datos obtenidos
      // Ahora documentsData contiene: { quotationId: { pipc: {path, link, filename}, report: {path, link, filename} } }
      setPipcFilePaths(documentsData || {});

    } catch (error) {
      console.error('❌ Error cargando rutas de archivos:', error);
      // No mostrar error al usuario, solo loggear
    }
  };

  // /files/pipc/paths agrupa los documentos SOLO por quotationId (una cotización puede tener
  // varios entes: matriz + sucursales). Sin este filtro, si esa cotización solo tiene 1
  // documento generado -- aunque sea de OTRA sucursal -- se mostraba/descargaba como si fuera
  // el de la fila actual (branchId no se estaba comparando contra el ente real de la fila).
  const getEntityDocs = (workOrder, docType) => {
    const allDocs = pipcFilePaths[workOrder.quotationId]?.[docType] || [];
    const rowEntities = workOrderEntityMap[workOrder.id] || [];
    if (rowEntities.length === 0) return allDocs;
    const allowedBranchIds = new Set(rowEntities.map((e) => e.branchId ?? null));
    return allDocs.filter((d) => allowedBranchIds.has(d.branchId ?? null));
  };

  // Saca del estado local, al instante, el documento cuya ruta ya no existe en Dropbox --
  // así el chip pasa a "No generado" sin esperar el round-trip de fetchPipcFilePaths().
  const removeStaleDocByPath = (path) => {
    if (!path) return;
    setPipcFilePaths(prev => {
      const next = { ...prev };
      for (const qid of Object.keys(next)) {
        for (const docType of ['pipc', 'report']) {
          const list = next[qid]?.[docType];
          if (Array.isArray(list)) {
            const filtered = list.filter(d => d.path !== path);
            if (filtered.length !== list.length) {
              next[qid] = { ...next[qid], [docType]: filtered };
            }
          }
        }
      }
      return next;
    });
  };

  // Estado del PIP (existe / completo) y avance general de las órdenes mostradas, en una sola
  // llamada. Antes: GET /work-orders otra vez, y por cada fila GET del PIP y de UIPC una tras otra
  // (UIPC ni se usaba para la completitud), más otra llamada por fila para el avance.
  // merge=true: actualiza solo esas cotizaciones (refresco de una fila).
  const fetchPipStatuses = async (orders, merge = false) => {
    const quotationIds = [...new Set((orders || []).map((wo) => wo.quotationId).filter(Boolean))];
    try {
      if (quotationIds.length === 0) {
        if (!merge) {
          setPipStatus({});
          setPipCompletionStatus({});
          setProgressData({});
          setProgressEntities({});
        }
        return;
      }
      const resp = await api.get('/pip-related/summary', { params: { quotationIds: quotationIds.join(',') } });
      const statuses = {};
      const completionStatuses = {};
      const progress = {};
      const entities = {};
      quotationIds.forEach((qid) => {
        const entry = resp.data?.[qid] || {};
        entities[qid] = entry.porEnte || [];
        statuses[qid] = !!entry.exists;
        completionStatuses[qid] = entry.exists ? isPipComplete(entry.pip) : false;
        progress[qid] = entry.general || { percentage: 0, completedCount: 0, totalCount: 5, items: [] };
      });
      setPipStatus(prev => (merge ? { ...prev, ...statuses } : statuses));
      setPipCompletionStatus(prev => (merge ? { ...prev, ...completionStatuses } : completionStatuses));
      setProgressData(prev => (merge ? { ...prev, ...progress } : progress));
      setProgressEntities(prev => (merge ? { ...prev, ...entities } : entities));
    } catch (err) {
      console.error('Error al verificar estados PIP:', err);
    } finally {
      setPipStatusLoaded(true);
    }
  };

  // Filtrar órdenes de trabajo
  useEffect(() => {
    let filtered = workOrders;

    if (filters.orderNumber) {
      filtered = filtered.filter(wo => 
        wo.orderNumber?.toLowerCase().includes(filters.orderNumber.toLowerCase())
      );
    }

    if (filters.cliente) {
      filtered = filtered.filter(wo => 
        wo.clientName?.toLowerCase().includes(filters.cliente.toLowerCase())
      );
    }

    if (filters.empresa) {
      filtered = filtered.filter(wo => 
        wo.companyName?.toLowerCase().includes(filters.empresa.toLowerCase())
      );
    }

    if (filters.servicio) {
      filtered = filtered.filter(wo => 
        wo.serviceType?.toLowerCase().includes(filters.servicio.toLowerCase())
      );
    }

    if (filters.estado) {
      filtered = filtered.filter(wo =>
        wo.status?.toLowerCase() === filters.estado.toLowerCase()
      );
    }

    if (filters.asignado) {
      const term = filters.asignado.toLowerCase();
      filtered = filtered.filter(wo =>
        (workOrderAssignedMap[wo.id] || []).some(name => name?.toLowerCase().includes(term))
      );
    }

    if (onlyOverdue) {
      filtered = filtered.filter(wo => (progressEntities[wo.quotationId] || []).some(isEnteOverdue));
    }

    setFilteredWorkOrders(filtered);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters.orderNumber, filters.cliente, filters.empresa, filters.servicio, filters.estado, filters.asignado, workOrders, workOrderAssignedMap, onlyOverdue, progressEntities]);

  // ── Avance por ente / ejecutivo ────────────────────────────────────────
  const todayLocal = (() => {
    const d = new Date();
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
  })();
  // D) Atrasado: ya pasó su fecha estimada de fin (o la programada, si no hay) y aún no termina lo operativo
  const isEnteOverdue = (e) => {
    const due = e?.estimatedCompletionDate || e?.scheduledDate;
    return !!due && String(due).slice(0, 10) < todayLocal && (e.percentage ?? 0) < 100;
  };
  const readinessForEnte = (quotationId, branchId) => (readinessData[quotationId]?.entities || [])
    .find(r => String(r.branchId ?? null) === String(branchId ?? null));
  const progressColor = (pct) => (pct >= 100 ? '#2e7d32' : pct >= 50 ? '#1976d2' : '#ef6c00');
  // Links útiles de la tabla: llevan al registro y lo abren (cada destino ya sabe abrir el que
  // recibe en location.state). stopPropagation para no disparar el clic de la fila.
  const goToEntity = (event, workOrder, { type, branchId }) => {
    event.stopPropagation();
    if (type === 'MATRIZ' || !branchId) {
      navigate('/clientes/empresas', { state: { highlightEntityId: workOrder.companyId, entityType: 'MATRIZ' } });
    } else {
      navigate('/clientes/sucursales', { state: { highlightEntityId: branchId, entityType: 'SUCURSAL' } });
    }
  };
  const goToCompany = (event, workOrder) => goToEntity(event, workOrder, { type: 'MATRIZ' });
  const goToWorkOrder = (event, workOrder) => {
    event.stopPropagation();
    navigate('/servicios/ordenes-trabajo', { state: { highlightWorkOrderId: workOrder.id } });
  };
  // El catálogo de usuarios solo lo consulta Admin (GET /users); para los demás el nombre no es link.
  const goToUser = (event, userId) => {
    event.stopPropagation();
    navigate('/usuarios/catalogo', { state: { highlightUserId: userId } });
  };
  const openQuotationPdf = async (event, workOrder) => {
    event.stopPropagation();
    try {
      const response = await api.get(`/quotations/${workOrder.quotationId}/pdf`, { responseType: 'blob' });
      const url = URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
      window.open(url, '_blank', 'noopener');
      setTimeout(() => URL.revokeObjectURL(url), 60000);
    } catch (err) {
      setSnackbar({ open: true, message: 'No se pudo abrir el PDF de la cotización', severity: 'error' });
    }
  };
  const linkSx = { cursor: 'pointer', '&:hover': { textDecoration: 'underline' } };
  // Celda de la tabla por ente que lleva a donde se resuelve ese dato; si el usuario no puede hacer
  // la acción (mismas reglas que el menú de la OT), se muestra el contenido sin link.
  const CellLink = ({ enabled, title, onClick, children }) => (enabled ? (
    <Tooltip title={title}>
      <Box component="span" onClick={(ev) => { ev.stopPropagation(); onClick(); }}
        sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.5, cursor: 'pointer', borderRadius: 1, px: 0.5, mx: -0.5,
          '&:hover': { bgcolor: '#e3f2fd', textDecoration: 'underline' } }}>
        {children}
      </Box>
    </Tooltip>
  ) : children);
  const goToAgenda = (workOrder, ente) => navigate('/servicios/agenda', {
    state: { highlightWorkOrderId: workOrder.id, highlightEntityType: ente.entityType, highlightBranchId: ente.branchId ?? null,
      highlightFieldKey: 'NIVEL_RIESGO' },
  });
  const goToEvaluation = (workOrder) => navigate('/evaluaciones/inspeccion', {
    state: { quotationId: workOrder.quotationId, companyId: workOrder.companyId, companyName: workOrder.companyName },
  });

  const toggleExpanded = (id) => setExpandedOrders(prev => {
    const next = new Set(prev);
    if (next.has(id)) next.delete(id); else next.add(id);
    return next;
  });

  // Entes vigentes del usuario, para asignar inspecciones capturadas sin ente
  const asyncAssignCandidates = (() => {
    const role = currentUser?.role?.name || currentUser?.role;
    const seeAll = ['ADMINISTRADOR', 'ADMIN', 'Coordinador de operaciones', 'COORDINADOR_OPERACIONES', 'SUPERVISOR_CALIDAD'].includes(role);
    const byKey = new Map();
    workOrders.filter((wo) => !['COMPLETADA', 'CANCELADA'].includes(wo.status)).forEach((wo) => {
      (workOrderDetailsById[wo.id] || [])
        .filter((d) => d?.status !== 'CANCELADA' && (seeAll || Number(d?.assignedUserId) === Number(currentUser?.id)))
        .forEach((d) => {
          const key = `${wo.quotationId}_${d.branchId ?? 'M'}`;
          if (!byKey.has(key)) {
            byKey.set(key, {
              key, workOrderNumber: wo.orderNumber, quotationId: wo.quotationId, companyId: wo.companyId,
              companyName: wo.companyName, entityType: d.entityType, branchId: d.branchId ?? null,
              entityName: d.entityName || (d.entityType === 'MATRIZ' ? 'Matriz' : 'Sucursal')
            });
          }
        });
    });
    return [...byKey.values()];
  })();

  // Regreso desde Empresas/Sucursales/Evaluación: reabrir "Validar Campos" de esa OT con una
  // validación nueva (nunca la anterior), para ver que el campo ya quedó y seguir con el siguiente.
  useEffect(() => {
    const reopenId = location.state?.reopenValidationWorkOrderId;
    if (!reopenId || workOrders.length === 0) return;
    const workOrder = workOrders.find((wo) => String(wo.id) === String(reopenId));
    navigate(location.pathname + location.search, { replace: true, state: {} });
    if (workOrder) handleValidateFields(workOrder);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [workOrders, location.state]);

  const overdueOrderCount = workOrders.filter(wo => (progressEntities[wo.quotationId] || []).some(isEnteOverdue)).length;

  // Ordenamiento de la tabla (elegido por el usuario: N° Orden, Nombre Comercial,
  // Asignado a o Fecha Programada)
  const [sortField, setSortField] = useState(null);
  const [sortDirection, setSortDirection] = useState('asc');

  const handleSortRequest = (field) => {
    if (sortField === field) {
      setSortDirection(prev => (prev === 'asc' ? 'desc' : 'asc'));
    } else {
      setSortField(field);
      setSortDirection('asc');
    }
  };

  const getAssignedSortValue = (workOrder) =>
    (workOrderAssignedMap[workOrder.id] || []).join(', ').toLowerCase();

  const sortedWorkOrders = !sortField ? filteredWorkOrders : [...filteredWorkOrders].sort((a, b) => {
    let valueA, valueB;
    if (sortField === 'scheduledDate') {
      valueA = a.scheduledDate ? new Date(a.scheduledDate).getTime() : 0;
      valueB = b.scheduledDate ? new Date(b.scheduledDate).getTime() : 0;
    } else if (sortField === 'assignedTo') {
      valueA = getAssignedSortValue(a);
      valueB = getAssignedSortValue(b);
    } else {
      valueA = (a[sortField] || '').toString().toLowerCase();
      valueB = (b[sortField] || '').toString().toLowerCase();
    }
    if (valueA < valueB) return sortDirection === 'asc' ? -1 : 1;
    if (valueA > valueB) return sortDirection === 'asc' ? 1 : -1;
    return 0;
  });

  const handleFilterChange = (field, value) => {
    setFilters(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const getAvailableStatuses = () => {
    const statuses = new Set();
    workOrders.forEach(wo => {
      if (wo.status) {
        statuses.add(wo.status);
      }
    });
    return Array.from(statuses).sort();
  };

  // Si viene "YYYY-MM-DD" (LocalDate, sin hora) parseamos los componentes a mano -- `new
  // Date("YYYY-MM-DD")` lo interpreta como medianoche UTC y en huso horario de México (UTC-6)
  // se desplaza un día hacia atrás al convertir a local.
  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';

    const dateOnlyMatch = /^(\d{4})-(\d{2})-(\d{2})/.exec(dateString);
    const date = dateOnlyMatch
      ? new Date(Number(dateOnlyMatch[1]), Number(dateOnlyMatch[2]) - 1, Number(dateOnlyMatch[3]))
      : new Date(dateString);
    if (isNaN(date.getTime())) return 'N/A';

    return date.toLocaleDateString('es-MX', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  };

  const formatCurrency = (amount) => {
    if (!amount) return 'N/A';
    return new Intl.NumberFormat('es-MX', {
      style: 'currency',
      currency: 'MXN'
    }).format(amount);
  };

  const formatStatus = (status) => {
    const statusMap = {
      'PENDIENTE': 'Pendiente',
      'PROGRAMADA': 'Programada',
      'EN_PROGRESO': 'En Progreso',
      'LISTA_PARA_REVISION': 'Lista para Revisión',
      'COMPLETADA': 'Completada',
      'CANCELADA': 'Cancelada',
      'ACCEPTED': 'Aceptada',
      'PENDING': 'Pendiente',
      'REJECTED': 'Rechazada',
      'DRAFT': 'Borrador',
      'SENT': 'Enviada'
    };
    return statusMap[status] || status || 'N/A';
  };

  const isWorkOrderCompleted = (workOrder) => {
    console.log('🔍 [DEBUG] WorkOrder status:', workOrder?.status, 'isCompleted:', workOrder?.status === 'COMPLETADA');
    return workOrder?.status === 'COMPLETADA';
  };

  const getVisibleSchedulesForUser = (schedules = []) => {
    const activeSchedules = schedules.filter((s) => s?.status !== 'CANCELADA');
    if (canEditBasePip) return activeSchedules;
    return activeSchedules.filter((s) => Number(s?.assignedUserId) === Number(currentUser?.id));
  };

  const handleIniciarPIP = async (workOrder) => {
    console.log('=== INICIO PIP ===');
    console.log('[handleIniciarPIP] Iniciando carga de PIP para cotización:', workOrder.quotationId);

    if (!canEditBasePip && !canEditUipcByEntity) {
      setSnackbar({
        open: true,
        message: 'No cuentas con permisos para capturar información del PIPC.',
        severity: 'warning'
      });
      return;
    }

    setSelectedWorkOrder(workOrder);
    let liveLegalRep = '';

    // Limpiar estados previos
    setUipcMembers([]);
    setPipFormData({});
    setWorkOrderSchedules([]);
    setEntityUipcMembers({});
    setNewEntityUipcMember({});
    setEntityQuotationEdits({});
    setPipApprovedByLegalRep('');
    setApproverDraft(null);
    setEntityPropertyData({});
    setExpandedInmuebleEntity(false);
    setExpandedSeguroEntity(false);
    setCompanyInsuranceInfo({});
    setDocumentsSummaryByEntity({});
    setExpandedDocumentosEntity(false);

    // Las 3 cargas arrancan a la vez; antes iban una tras otra
    const companyPromise = workOrder.companyId ? api.get(`/companies/${workOrder.companyId}`) : null;
    const pipPromise = api.get(`/pip-related/quotation/${workOrder.quotationId}`);
    companyPromise?.catch(() => {});
    pipPromise.catch(() => {});
    const cachedDetails = workOrderDetailsById[workOrder.id];
    const hasCachedSchedules = Array.isArray(cachedDetails) && cachedDetails.length > 0;
    if (hasCachedSchedules) setWorkOrderSchedules(getVisibleSchedulesForUser(cachedDetails));
    setPipSchedulesSyncing(true);
    const schedulesPromise = loadWorkOrderSchedulesAndUipc(workOrder, { withUipc: false })
      .finally(() => setPipSchedulesSyncing(false));
    // Solo se espera si no hay entes en caché; sin esto, una falla de red queda sin manejar
    schedulesPromise.catch(() => {});

    // "Aprobado por" = representante legal de la empresa, en vivo (no la copia guardada en
    // WorkOrder.legalRepresentative, que puede haber quedado desactualizada).
    if (workOrder.companyId) {
      try {
        const companyResp = await companyPromise;
        liveLegalRep = companyResp.data?.legalRepresentative || '';
        setPipApprovedByLegalRep(liveLegalRep);
        setCompanyInsuranceInfo({
          legalRepresentative: companyResp.data?.legalRepresentative || '',
          insuranceSameForBranches: !!companyResp.data?.insuranceSameForBranches,
          insuranceCompany: companyResp.data?.insuranceCompany || '',
          insurancePolicyNumber: companyResp.data?.insurancePolicyNumber || '',
          insurancePolicyValidity: companyResp.data?.insurancePolicyValidity || ''
        });
      } catch (e) {
        console.warn('No se pudo cargar el representante legal de la empresa:', e);
      }
    }

    // Intentar cargar datos existentes del PIP
    try {
      const response = await pipPromise;
      
      if (response.data) {
        console.log('✅ PIP existente encontrado, cargando datos:', response.data);
        const pipData = {
          id: response.data.id,
          quotationId: workOrder.quotationId,
          preparedBy: response.data.preparedBy || terceroAcreditado.thirdPartyAccredited,
          reviewedBy: response.data.reviewedBy || terceroAcreditado.reviewedBy,
          approvedBy: response.data.approvedBy || workOrder.legalRepresentative || '',
          serviceScope: response.data.serviceScope || 'Elaboración del Programa Interno de Protección Civil (PIPC), conforme a la normatividad vigente, incluyendo diagnóstico de riesgos, subprogramas de prevención, auxilio y recuperación, y capacitación del personal.',
          methodology: response.data.methodology || 'Diagnóstico in situ mediante visita de inspección, recopilación de información documental y evaluación de condiciones de riesgo conforme a la Ley General de Protección Civil, su Reglamento y las Normas Oficiales Mexicanas aplicables.',
          deliverables: response.data.deliverables || '',
          estimatedDuration: response.data.estimatedDuration || '15 días hábiles',
          professionalLicense: response.data.professionalLicense || '',
          specialty: response.data.specialty || '',
          serviceSubtotal: response.data.serviceSubtotal || workOrder.totalAmount || 0,
          appliedTax: response.data.appliedTax || 0,
          totalQuotation: response.data.totalQuotation || workOrder.totalAmount || 0,
          paymentTerms: response.data.paymentTerms || '',
          quotationValidity: response.data.quotationValidity || 30,
          applicableStandards: response.data.applicableStandards || '',
          requiredCertifications: response.data.requiredCertifications || '',
          technicalObservations: response.data.technicalObservations || '',
          clientRequirements: response.data.clientRequirements || '',
          serviceLimitations: response.data.serviceLimitations || '',
          followUpContact: response.data.followUpContact || '',
          followUpPhone: response.data.followUpPhone || '',
          // Campos de acreditación (el backend siempre manda los vigentes)
          thirdPartyAccredited: response.data.thirdPartyAccredited || '',
          registrationNumber: response.data.registrationNumber || '',
          stateSecretaryFolio: response.data.stateSecretaryFolio || '',
          internalFolio: response.data.internalFolio || ''
        };
        
        setPipFormData(pipData);
        const outdated = !response.data.estimatedDuration
          || (workOrder.orderNumber && response.data.internalFolio !== workOrder.orderNumber)
          || (liveLegalRep && response.data.approvedBy !== liveLegalRep);
        if (outdated) syncPipRecord(pipData, workOrder, liveLegalRep);

        // Verificar si la base del PIP está completa
        const isComplete = checkPipCompletion(pipData);
        console.log('🔍 PIP completitud al cargar:', isComplete);
        
        // Actualizar estado de completitud
        setPipCompletionStatus(prev => ({
          ...prev,
          [workOrder.quotationId]: isComplete
        }));
        
        // Actualizar estado de PIP iniciado
        setPipStatus(prev => ({
          ...prev,
          [workOrder.quotationId]: true
        }));
      }
    } catch (error) {
      // Si no existe PIP, inicializar con valores predeterminados
      const defaultPip = {
        quotationId: workOrder.quotationId,
        preparedBy: terceroAcreditado.thirdPartyAccredited,
        reviewedBy: terceroAcreditado.reviewedBy,
        approvedBy: workOrder.legalRepresentative || '',
        serviceScope: 'Elaboración del Programa Interno de Protección Civil (PIPC), conforme a la normatividad vigente, incluyendo diagnóstico de riesgos, subprogramas de prevención, auxilio y recuperación, y capacitación del personal.',
        methodology: 'Diagnóstico in situ mediante visita de inspección, recopilación de información documental y evaluación de condiciones de riesgo conforme a la Ley General de Protección Civil, su Reglamento y las Normas Oficiales Mexicanas aplicables.',
        deliverables: '',
        estimatedDuration: '15 días hábiles',
        professionalLicense: '',
        specialty: '',
        serviceSubtotal: workOrder.totalAmount || 0,
        appliedTax: 0,
        totalQuotation: workOrder.totalAmount || 0,
        paymentTerms: '',
        quotationValidity: 30,
        applicableStandards: '',
        requiredCertifications: '',
        technicalObservations: '',
        clientRequirements: '',
        serviceLimitations: '',
        followUpContact: '',
        followUpPhone: ''
      };
      setPipFormData(defaultPip);
      syncPipRecord(defaultPip, workOrder, liveLegalRep);
      setUipcMembers([]);
    }
    
    // Cargar entes desde la misma fuente de Programación por Ente (work_order_details)
    // Con los entes de la tabla el diálogo abre ya; si no los hay, se espera al sync
    if (!hasCachedSchedules) await schedulesPromise;

    // Abrir el modal después de cargar todos los datos
    console.log('🎬 [handleIniciarPIP] Abriendo modal...');
    setPipActiveTab(canEditBasePip ? 0 : 1);
    setPipDialogOpen(true);
  };

  // Carga los entes de la orden (work_order_details) + sus miembros de UIPC ya capturados.
  // Extraído de handleIniciarPIP para poder reutilizarlo desde el diálogo "Captura UIPC", que
  // no necesita el resto de los datos del PIP (preparadoPor, alcance, etc.), solo esto.
  const loadWorkOrderSchedulesAndUipc = async (workOrder, { withUipc = true } = {}) => {
    try {
      const schedulesResp = await api.post(`/work-order-details/work-order/${workOrder.id}/sync`);
      const schedules = Array.isArray(schedulesResp.data) ? schedulesResp.data : [];
      const visibleSchedules = getVisibleSchedulesForUser(schedules);
      setWorkOrderSchedules(visibleSchedules);

      const qEdits = {};
      visibleSchedules.forEach(s => {
        qEdits[s.id] = {
          inspectorContact: s.quotationInspectorContact || '',
          requiresPpe: s.quotationRequiresPpe || false,
          ppeDetails: s.quotationPpeDetails || '',
          scheduledDate: s.scheduledDate || '',
          scheduledTimeStart: s.scheduledTimeStart || '',
          scheduledTimeEnd: s.scheduledTimeEnd || '',
        };
      });
      setEntityQuotationEdits(qEdits);
      if (!withUipc) return;

      const membersMap = {};
      const newMemberMap = {};
      await Promise.all(visibleSchedules.map(async (sched) => {
        newMemberMap[sched.id] = { workerName: '', brigadePosition: '' };
        try {
          const mResp = await api.get(`/uipc/schedule/${sched.id}`);
          membersMap[sched.id] = Array.isArray(mResp.data) ? mResp.data : [];
        } catch (uipcErr) {
          console.warn(`⚠️ No se pudo cargar UIPC para schedule ${sched.id}:`, uipcErr.message);
          membersMap[sched.id] = [];
        }
      }));
      setEntityUipcMembers(membersMap);
      setNewEntityUipcMember(newMemberMap);
      if (visibleSchedules.length > 0) setExpandedUipcEntity(`uipc-dialog-entity-${visibleSchedules[0].id}`);
    } catch (schedErr) {
      console.warn('⚠️ No se pudieron cargar los entes de la orden:', schedErr.message);
      setWorkOrderSchedules([]);
      setEntityUipcMembers({});
      setNewEntityUipcMember({});
    }
  };

  // Abre el diálogo "Captura UIPC" standalone -- mismo permiso y misma fuente de datos que
  // "Editar/Iniciar PIPC", pero sin cargar el resto del formulario del PIP.
  const handleOpenUipcCapture = async (workOrder) => {
    if (!canEditBasePip && !canEditUipcByEntity) {
      setSnackbar({
        open: true,
        message: 'No cuentas con permisos para capturar información de la UIPC.',
        severity: 'warning'
      });
      return;
    }
    setSelectedWorkOrder(workOrder);
    setEntityUipcMembers({});
    const cachedDetails = workOrderDetailsById[workOrder.id];
    if (!cachedDetails || cachedDetails.length === 0) {
      // La tabla aún no trae sus entes (o la orden nunca se sincronizó): camino completo de antes
      setWorkOrderSchedules([]);
      setNewEntityUipcMember({});
      await loadWorkOrderSchedulesAndUipc(workOrder);
      setUipcCaptureDialogOpen(true);
      return;
    }

    // Abre al instante con los entes que ya tiene la tabla; los miembros llegan en 1 sola llamada
    const schedules = getVisibleSchedulesForUser(cachedDetails);
    setWorkOrderSchedules(schedules);
    setNewEntityUipcMember(Object.fromEntries(schedules.map((sched) => [sched.id, { workerName: '', brigadePosition: '' }])));
    setExpandedUipcEntity(schedules.length > 0 ? `uipc-dialog-entity-${schedules[0].id}` : false);
    setUipcMembersLoading(true);
    setUipcCaptureDialogOpen(true);
    try {
      const resp = await api.get(`/uipc/quotation/${workOrder.quotationId}`);
      const members = Array.isArray(resp.data) ? resp.data : [];
      const byEntity = Object.fromEntries(schedules.map((sched) => [sched.id, []]));
      members.forEach((m) => {
        if (byEntity[m.workOrderScheduleId]) byEntity[m.workOrderScheduleId].push(m);
      });
      setEntityUipcMembers(byEntity);
    } catch (err) {
      console.error('Error cargando miembros UIPC:', err);
      setSnackbar({ open: true, message: 'No se pudieron cargar los miembros de la UIPC.', severity: 'error' });
    } finally {
      setUipcMembersLoading(false);
    }
  };



  // Descarga un documento (PIPC o Reporte) de un ente específico vía el proxy de Dropbox.
  const downloadQuotationDoc = async (doc) => {
    try {
      const response = await api.get('/dropbox/download-file', {
        params: { path: doc.path },
        responseType: 'blob'
      });
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const a = document.createElement('a');
      a.href = url;
      a.download = doc.filename || 'documento.docx';
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (e) {
      if (e.response?.status === 404) {
        setSnackbar({
          open: true,
          message: '⚠️ Ese archivo ya no está disponible en Dropbox (fue eliminado). Generalo de nuevo.',
          severity: 'warning'
        });
        removeStaleDocByPath(doc.path);
        fetchPipcFilePaths();
      } else {
        setSnackbar({ open: true, message: 'Error al descargar el archivo', severity: 'error' });
      }
    }
  };

  // Si solo hay un ente con documento, descarga directo; si hay varios (matriz + sucursales),
  // abre un menú para elegir cuál.
  const handleDocChipClick = (event, docs, docLabel) => {
    event.stopPropagation();
    if (!docs || docs.length === 0) return;
    if (docs.length === 1) {
      downloadQuotationDoc(docs[0]);
    } else {
      setDocsMenu({ anchorEl: event.currentTarget, items: docs, docLabel });
    }
  };

  const closeDocsMenu = () => setDocsMenu({ anchorEl: null, items: [], docLabel: '' });

  // Simulación visual de avance (no es real -- solo para no dejar un spinner ciego mientras
  // la petición síncrona hace su trabajo). Sube de a poco y se frena en 90% hasta que la
  // respuesta real llegue; ahí se completa a 100%.
  const startFakeProgress = (setDialogState, estimatedSeconds) => {
    const stepMs = 1500;
    let elapsed = 0;
    const interval = setInterval(() => {
      elapsed += stepMs / 1000;
      const pct = Math.min(90, Math.round((elapsed / estimatedSeconds) * 90));
      setDialogState(prev => ({ ...prev, progressPct: pct }));
    }, stepMs);
    return interval;
  };

  // Genera un documento de UN ente con el mismo diálogo de avance que antes usaba toda la OT
  const runEnteGenerationJob = async (workOrder, ente, docType) => {
    const entityName = (ente?.entityName || '').replace(/\s*\(Matriz\)\s*$/i, '') || 'Ente';
    setGenDialog({ open: true, loading: true, results: null, error: null, docType, progressPct: 0, totalEntities: 1 });
    const progressInterval = startFakeProgress(setGenDialog, docType === 'PIPC' ? 60 : 20);
    try {
      const resp = await api.post('/files/reports/generate', {
        quotationId: workOrder.quotationId, branchId: ente?.branchId ?? null, docType,
      }, { timeout: 300000 });
      const ok = !!resp.data.success;
      setGenDialog(prev => ({
        ...prev, loading: false, progressPct: 100,
        results: { total: 1, successCount: ok ? 1 : 0, errorCount: ok ? 0 : 1,
          results: [{ success: ok, entityName, error: ok ? null : (resp.data.error || resp.data.message) }] },
      }));
      if (ok) refreshWorkOrderRow(workOrder);
    } catch (err) {
      const isTimeout = err.code === 'ECONNABORTED' || err.message?.includes('timeout');
      setGenDialog(prev => ({
        ...prev,
        loading: false,
        error: isTimeout
          ? 'La generación tardó más de lo esperado. Verifica en Servicios > Gestión Documental si el archivo ya está disponible.'
          : (err.response?.data?.error || err.response?.data?.message || `Error al generar ${docType} de ${entityName}`)
      }));
    } finally {
      clearInterval(progressInterval);
    }
  };





  // El Acta Constitutiva se firma con el cliente, así que solo se habilita una vez que el PIPC
  // de al menos un ente de esta orden ya pasó (y quedó aprobado) su primera ronda de revisión de
  // calidad. getEntityDocs ya filtra por los entes reales de esta fila (matriz/sucursales), mismo
  // criterio que el resto del menú.
  // ── Acciones por ente (menú de cada renglón de ente) ──
  const enteDocument = (workOrder, ente, key) => (workflowStatus?.workOrderId === workOrder?.id
    ? (workflowStatus.data?.entities || []).find(x => String(x.branchId ?? 'MATRIZ') === String(ente?.branchId ?? 'MATRIZ'))?.documents?.[key]
    : null) || null;

  const generateDocForEnte = (workOrder, ente, docType) => runEnteGenerationJob(workOrder, ente, docType);

  const downloadEnteDocument = async (workOrder, ente, key, label) => {
    const doc = enteDocument(workOrder, ente, key);
    if (!doc?.dropboxPath) {
      setSnackbar({ open: true, message: `Este ente aún no tiene ${label} generado`, severity: 'warning' });
      return;
    }
    setSnackbar({ open: true, message: `⏳ Descargando ${label}…`, severity: 'info' });
    try {
      const response = await api.get('/dropbox/download-file', { params: { path: doc.dropboxPath }, responseType: 'blob', timeout: 300000 });
      const url = URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.download = doc.fileName || `${label}.docx`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      setTimeout(() => URL.revokeObjectURL(url), 60000);
      setSnackbar({ open: true, message: `${label} descargado`, severity: 'success' });
    } catch (err) {
      setSnackbar({ open: true, message: `No se pudo descargar ${label}`, severity: 'error' });
    }
  };

  const hasQaRound1Approved = (workOrder) => {
    if (!workOrder) return false;
    const pipcDocs = getEntityDocs(workOrder, 'pipc');
    return pipcDocs.some(d => d.qaStatus === 'REVISION_1_APROBADA' || d.qaStatus === 'REVISION_2_APROBADA');
  };

  const handleGenerateConstancias = async (workOrder, detailId = null) => {
    try {
      setSnackbar({ open: true, message: 'Generando constancias...', severity: 'info' });
      const resp = await api.post(`/constancias/work-order/${workOrder.id}/generate-all`, null, { params: detailId ? { detailId } : {} });
      const { message, count, entitiesWithoutTraining } = resp.data;
      // "warning" (no "success") si no se generó nada nuevo o si algún ente no tenía
      // capacitación registrada -- el mensaje ya lo detalla, pero el color debe reflejarlo.
      const severity = (count === 0 || (entitiesWithoutTraining && entitiesWithoutTraining.length > 0))
        ? 'warning' : 'success';
      // Mensaje más largo que el resto (incluye conteos y, si aplica, entes sin capacitación) --
      // más tiempo en pantalla que el default de 3.5s para que alcance a leerse.
      setSnackbar({ open: true, message: message || 'Constancias generadas exitosamente', severity, duration: 8000 });
    } catch (err) {
      setSnackbar({
        open: true,
        message: err.response?.data?.message || 'Error al generar constancias',
        severity: 'error',
        duration: 6000
      });
    }
  };

  // "Generar Constancias" ahora abre primero un diálogo de confirmación con el resumen de qué
  // entes lo recibirán (mismo filtrado por rol que el backend aplicará al generar de verdad) --
  // antes se generaba directo al hacer clic en el menú, sin visibilidad previa.
  const handleOpenConstanciasSummary = async (workOrder, detailId = null) => {
    setConstanciasSummaryWorkOrder(workOrder);
    setConstanciasSummaryDetailId(detailId);
    setConstanciasSummaryDialogOpen(true);
    setConstanciasSummaryLoading(true);
    setConstanciasSummary([]);
    try {
      const resp = await api.get(`/constancias/work-order/${workOrder.id}/generation-summary`, { params: detailId ? { detailId } : {} });
      setConstanciasSummary(resp.data || []);
    } catch (err) {
      setConstanciasSummaryDialogOpen(false);
      setSnackbar({
        open: true,
        message: err.response?.data?.message || 'Error al obtener el resumen de constancias a generar',
        severity: 'error'
      });
    } finally {
      setConstanciasSummaryLoading(false);
    }
  };

  const handleCloseConstanciasSummary = () => {
    setConstanciasSummaryDialogOpen(false);
    setConstanciasSummaryWorkOrder(null);
    setConstanciasSummary([]);
  };

  const handleConfirmGenerateConstancias = async () => {
    const workOrder = constanciasSummaryWorkOrder;
    const members = constanciasSummary.filter(i => i.included).reduce((sum, i) => sum + (i.memberCount || 0), 0);
    setConstanciasProgress({ progressPct: 0 });
    setConstanciasGenerating(true);
    const progressInterval = startFakeProgress(setConstanciasProgress, 8 + members * 4);
    try {
      await handleGenerateConstancias(workOrder, constanciasSummaryDetailId);
      setConstanciasProgress({ progressPct: 100 });
      refreshWorkOrderRow(workOrder);
    } finally {
      clearInterval(progressInterval);
      setConstanciasGenerating(false);
      handleCloseConstanciasSummary();
    }
  };


  // Funciones para manejar el menú desplegable
  const handleOpenMenu = (event, workOrder, enteKey = null) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
    setSelectedWorkOrderForMenu(workOrder);
    setMenuEnteKey(enteKey);
    setWorkflowStatus(null);
    reloadWorkflowStatus(workOrder);
    // Asegura que readinessMap esté fresco antes de mostrar "Generar RIC/PIPC" -- si esta orden
    // nunca se validó antes, el menú se abriría con el alcance (matriz/sucursales) en blanco.
    refreshReadinessForWorkOrder(workOrder.id, { verifyDropbox: false });
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
    setSelectedWorkOrderForMenu(null);
  };

  // Ente elegido en el menú (o el primero de la OT)
  const menuSelectedEnte = (workOrder) => {
    const entes = progressEntities[workOrder?.quotationId] || [];
    return entes.find((e) => String(e.branchId ?? 'MATRIZ') === String(menuEnteKey)) || entes[0] || null;
  };

  const handleMenuAction = (action) => {
    if (!selectedWorkOrderForMenu) return;
    const ente = menuSelectedEnte(selectedWorkOrderForMenu);
    
    handleCloseMenu();
    
    // Ejecutar la acción correspondiente
    switch(action) {
      case 'edit':
        handleIniciarPIP(selectedWorkOrderForMenu);
        break;
      case 'captureUipc':
        handleOpenUipcCapture(selectedWorkOrderForMenu);
        break;
      case 'assigned':
        // A la Agenda, en el ente que se está viendo en el menú
        goToAgenda(selectedWorkOrderForMenu, ente || { entityType: 'MATRIZ', branchId: null });
        break;
      case 'download':
        downloadEnteDocument(selectedWorkOrderForMenu, ente, 'PIPC', 'el PIPC');
        break;
      case 'downloadReport':
        downloadEnteDocument(selectedWorkOrderForMenu, ente, 'REPORTE_INSPECCION', 'el Reporte de Inspección');
        break;
      case 'files':
        handleOpenUploadDialog(selectedWorkOrderForMenu, ente?.branchId
          ? { id: ente.branchId, branchName: ente.entityName, companyId: selectedWorkOrderForMenu.companyId } : null);
        break;
      case 'evaluation':
        navigate('/evaluaciones/inspeccion', {
          state: {
            quotationId: selectedWorkOrderForMenu.quotationId,
            companyId: selectedWorkOrderForMenu.companyId,
            companyName: selectedWorkOrderForMenu.companyName,
            branchId: ente?.branchId ?? null,
            entityType: ente?.branchId ? 'SUCURSAL' : 'MATRIZ'
          }
        });
        break;
      case 'validate':
        handleValidateFields(selectedWorkOrderForMenu);
        break;
      case 'generateRic':
        generateDocForEnte(selectedWorkOrderForMenu, ente, 'RIC');
        break;
      case 'generatePipc':
        generateDocForEnte(selectedWorkOrderForMenu, ente, 'PIPC');
        break;
      case 'generateActa':
        generateDocForEnte(selectedWorkOrderForMenu, ente, 'ACTA');
        break;
      case 'generateCarta':
        generateDocForEnte(selectedWorkOrderForMenu, ente, 'CARTA');
        break;
      case 'generateConstancias':
        handleOpenConstanciasSummary(selectedWorkOrderForMenu, ente?.workOrderDetailId ?? null);
        break;
      case 'delivery':
        setDeliveryWorkOrder(selectedWorkOrderForMenu);
        break;
      default:
        break;
    }
  };

  // Refresca readinessMap para una orden puntual sin abrir el diálogo de validación. La API ya
  // devuelve matriz/branches filtrados por el ente asignado al usuario actual (Ejecutivo de
  // Operaciones restringido) -- guardamos hasMatriz/branchCount para que el menú de "Generar
  // RIC/PIPC" describa el alcance real (sus entes), no siempre "matriz + todas las sucursales".
  // Validaciones EN CURSO por orden: abrir el menú ⋮ ya lanza una, y "Validar Campos" justo después
  // lanzaba otra idéntica que competía con la primera. Solo se comparte la que todavía está en
  // curso (misma orden, mismo modo de Dropbox); un resultado terminado nunca se reutiliza, así que
  // cada validación nueva lee los datos al momento.
  const validationsInFlightRef = useRef(new Map());
  // Modo de Dropbox que usa el servidor cuando no se indica (lo dice cada respuesta en dropboxVerified)
  const serverDefaultVerifyRef = useRef(null);

  const fetchWorkOrderValidation = (workOrderId, verifyDropbox) => {
    const effective = verifyDropbox === undefined ? (serverDefaultVerifyRef.current ?? 'default') : verifyDropbox;
    const key = `${workOrderId}|${effective}`;
    const inFlight = validationsInFlightRef.current.get(key);
    if (inFlight) return inFlight;
    const params = verifyDropbox === undefined ? {} : { verifyDropbox };
    const promise = api.get(`/files/work-order/${workOrderId}/validate`, { params })
      .then((response) => {
        if (verifyDropbox === undefined) serverDefaultVerifyRef.current = !!response.data?.dropboxVerified;
        return response;
      })
      .finally(() => validationsInFlightRef.current.delete(key));
    validationsInFlightRef.current.set(key, promise);
    return promise;
  };

  const refreshReadinessForWorkOrder = async (workOrderId, { verifyDropbox } = {}) => {
    try {
      const response = await fetchWorkOrderValidation(workOrderId, verifyDropbox);
      const allEntities = [response.data.matriz, ...(response.data.branches || [])].filter(Boolean);
      // La generación de RIC/PIPC es por ente (generateReportForAllEntities recorre cada uno de
      // forma independiente) -- por eso la habilitación del menú también debe serlo: que a un ente
      // le falten campos no debe bloquear la generación de los entes que SÍ están completos.
      const ricReadyCount = allEntities.filter(e => Object.keys(e.ric?.missingRequiredBySection || {}).length === 0).length;
      const pipcReadyCount = allEntities.filter(e => Object.keys(e.pipc?.missingRequiredBySection || {}).length === 0).length;
      const ricReady = ricReadyCount > 0;
      const pipcReady = pipcReadyCount > 0;
      const hasMatriz = !!response.data.matriz;
      const branchCount = (response.data.branches || []).length;
      setReadinessMap(prev => ({
        ...prev,
        [workOrderId]: { ricReady, pipcReady, ricReadyCount, pipcReadyCount, totalEntities: allEntities.length, hasMatriz, branchCount }
      }));
      return response.data;
    } catch (e) {
      return null;
    }
  };

  // Texto de alcance para "Generar RIC/PIPC" en el menú de acciones -- refleja cuántos de los
  // entes visibles para el usuario actual ya están listos para ESE tipo de documento (no todos
  // los entes visibles están necesariamente listos, ya que la generación es por ente).
  const getGenerationScopeLabel = (workOrderId, docType) => {
    const info = readinessMap[workOrderId];
    if (!info) return '';
    const readyCount = docType === 'pipc' ? info.pipcReadyCount : info.ricReadyCount;
    const total = info.totalEntities || 0;
    if (!total) return 'Sin entes asignados';
    if (readyCount === total) return `Para los ${total} entes asignados`;
    return `Para ${readyCount} de ${total} entes (los demás faltan por completar)`;
  };

  // Función para validar campos de una orden de trabajo (matriz + sucursales)
  const handleValidateFields = async (workOrder, { verifyDropbox } = {}) => {
    setSelectedWorkOrderForValidation(workOrder);
    setValidationDialogOpen(true);
    setValidationLoading(true);
    setValidationData(null);
    setExpandedEntities({});
    setValidationDocTab({});
    setOpenDocCategories(new Set());
    try {
      const data = await refreshReadinessForWorkOrder(workOrder.id, { verifyDropbox });
      if (!data) throw new Error('No se pudo validar la orden');
      const response = { data };
      setValidationData(response.data);
      // Auto-expandir todas las entidades
      const expanded = { matriz: true };
      (response.data.branches || []).forEach((_, idx) => {
        expanded[`branch_${idx}`] = true;
      });
      setExpandedEntities(expanded);
    } catch (err) {
      console.error('Error validando campos:', err);
      setSnackbar({ open: true, message: 'Error al validar campos de la orden de trabajo', severity: 'error' });
      setValidationDialogOpen(false);
    } finally {
      setValidationLoading(false);
    }
  };

  // Genera RIC/PIPC para UN solo ente (a diferencia de "Generar RIC/PIPC" del menú ⋮, que siempre
  // genera para todos los entes de la OT) -- usa el endpoint de un solo ente que el backend ya
  // tenía (FileController POST /files/reports/generate) pero que hasta ahora no estaba conectado
  // a ningún botón del frontend.
  const handleGenerateSingleEntity = async (docType, entityType, entityId, entityLabel) => {
    const workOrder = selectedWorkOrderForValidation;
    if (!workOrder) return;
    const key = `${docType}-${entityType === 'SUCURSAL' ? entityId : 'matriz'}`;
    setGeneratingEntityDoc(key);
    try {
      const isMatriz = entityType !== 'SUCURSAL';
      const resp = await api.post('/files/reports/generate', {
        quotationId: workOrder.quotationId,
        branchId: isMatriz ? null : entityId,
        docType
      });
      if (resp.data.success) {
        setSnackbar({ open: true, message: `${DOC_SHORT_NAMES[docType] || docType} generado para ${entityLabel}`, severity: 'success' });
        await handleValidateFields(workOrder);
      } else {
        setSnackbar({ open: true, message: resp.data.error || `No se pudo generar ${docType}`, severity: 'error' });
      }
    } catch (err) {
      setSnackbar({ open: true, message: err.response?.data?.error || `Error al generar ${docType} de ${entityLabel}`, severity: 'error' });
    } finally {
      setGeneratingEntityDoc(null);
    }
  };

  const toggleEntityExpanded = (key) => {
    setExpandedEntities(prev => ({ ...prev, [key]: !prev[key] }));
  };

  const getReadinessIcon = (percentage) => {
    if (percentage >= 100) return <CheckCircle sx={{ color: '#4caf50' }} />;
    if (percentage >= 60) return <Warning sx={{ color: '#ff9800' }} />;
    return <ErrorIcon sx={{ color: '#f44336' }} />;
  };

  const getReadinessColor = (percentage) => {
    if (percentage >= 100) return '#4caf50';
    if (percentage >= 60) return '#ff9800';
    return '#f44336';
  };

  // Convierte la key cruda del placeholder ({GIRO_EMPRESA}) a su forma "pelada" (GIRO_EMPRESA).
  // Por default, el id="field-XXX" de cada pantalla usa exactamente este nombre -- así, un
  // placeholder nuevo con id="field-<NOMBRE>" ya funciona sin tener que tocar este archivo.
  // Solo entra a un mapa de OVERRIDES si el campo real vive bajo otro nombre de id (porque el
  // formulario lo renombra, lo combina con otro, o la key cruda no es el nombre del campo).
  const stripBraces = (key) => key.replace(/^\{|\}$/g, '');

  // Catálogo de Empresas (MATRIZ).
  const COMPANY_FIELD_OVERRIDES = {
    '{LATITUD}': 'GEOREFERENCIA',
    '{LONGITUD}': 'GEOREFERENCIA',
    '{empresa_imagen}': 'IMAGEN_INMUEBLE',
    '{HORARIO_TRABAJO}': 'HORARIO_OPERATIVO',
    // En MATRIZ, RESPONSABLE/TELEFONO/EMAIL_SUCURSAL caen al contacto corporativo de la empresa
    // (mismo criterio que ya usa el backend en buildCurrentValuesMap), así que apuntan a esos
    // campos del formulario de Catálogo de Empresas, no a un campo propio de "sucursal".
    '{RESPONSABLE_SUCURSAL}': 'CONTACTO_CORPORATIVO',
    '{TELEFONO_SUCURSAL}': 'TELEFONO_CORPORATIVO',
    '{EMAIL_SUCURSAL}': 'EMAIL_CORPORATIVO',
  };
  // Todas las keys crudas que se editan en Catálogo de Empresas. Si un campo falta y su key no
  // está aquí, no se ofrece salto directo (se muestra como texto plano).
  const COMPANY_FIELD_KEYS = new Set([
    '{NOMBRE_EMPRESA}', '{RAZON_SOCIAL}', '{RFC}', '{GIRO_EMPRESA}', '{CONTACTO_CORPORATIVO}',
    '{EMAIL_CORPORATIVO}', '{TELEFONO_CORPORATIVO}', '{LOGO_EMPRESA}', '{COMPANIA_SEGUROS}',
    '{NUMERO_POLIZA}', '{VIGENCIA_POLIZA}', '{MUNICIPIO}', '{LOCALIDAD}', '{ESTADO}', '{GEOREFERENCIA}', '{LATITUD}', '{LONGITUD}',
    '{AREA_CONSTRUCCION}', '{AREA_TERRENO}', '{NIVELES_CONSTRUCCION}', '{empresa_imagen}',
    '{REGIMEN_PROPIEDAD}', '{NUMERO_EMPLEADOS}', '{POBLACION_FLOTANTE}', '{HORARIO_TRABAJO}',
    '{HORARIO_ADMINISTRATIVO}', '{CAPACIDAD_MAXIMA}', '{ACTIVIDADES_PRINCIPALES}',
    '{RESPONSABLE_SUCURSAL}', '{TELEFONO_SUCURSAL}', '{EMAIL_SUCURSAL}',
  ]);
  const getCompanyDomFieldKey = (fieldKey) => COMPANY_FIELD_OVERRIDES[fieldKey] || stripBraces(fieldKey);

  // Gestión de Sucursales (SUCURSAL) -- mismo criterio.
  const BRANCH_FIELD_OVERRIDES = {
    '{LATITUD}': 'GEOREFERENCIA',
    '{LONGITUD}': 'GEOREFERENCIA',
    '{DIRECCION_INMUEBLE}': 'DIRECCION_FISICA_SUCURSAL',
    '{empresa_imagen}': 'IMAGEN_INMUEBLE',
  };
  const BRANCH_FIELD_KEYS = new Set([
    '{GIRO_EMPRESA}', '{MUNICIPIO}', '{GEOREFERENCIA}', '{LATITUD}', '{LONGITUD}',
    '{DIRECCION_FISICA_SUCURSAL}', '{DIRECCION_INMUEBLE}', '{RESPONSABLE_SUCURSAL}',
    '{TELEFONO_SUCURSAL}', '{EMAIL_SUCURSAL}', '{COMPANIA_SEGUROS}', '{NUMERO_POLIZA}',
    '{VIGENCIA_POLIZA}', '{AREA_CONSTRUCCION}', '{AREA_TERRENO}', '{NIVELES_CONSTRUCCION}',
    '{REGIMEN_PROPIEDAD}', '{NUMERO_EMPLEADOS}', '{CAPACIDAD_MAXIMA}', '{POBLACION_FLOTANTE}',
    '{HORARIO_TRABAJO}', '{HORARIO_ADMINISTRATIVO}', '{ACTIVIDADES_PRINCIPALES}', '{empresa_imagen}',
  ]);
  const getBranchDomFieldKey = (fieldKey) => BRANCH_FIELD_OVERRIDES[fieldKey] || stripBraces(fieldKey);

  // Evaluación de Inspección: campos "de sitio", iguales para MATRIZ y SUCURSAL (solo cambia qué
  // branchId se manda). Todos usan field-<KEY_SIN_LLAVES>, no hay excepciones hoy.
  const EVALUATION_FIELD_KEYS = new Set([
    '{SUSTANCIAS_PELIGROSAS}', '{CAPACIDAD_GAS}', '{vb}', '{TRABAJADORES_DISCAPACIDAD}',
  ]);

  // Agenda de Servicios (WorkOrderDetailManager, por ente dentro de la orden de trabajo) --
  // hoy solo Nivel de Riesgo. Todos usan field-<KEY_SIN_LLAVES>-<detailId>.
  const AGENDA_FIELD_KEYS = new Set(['{NIVEL_RIESGO}']);
  // Dictámenes capturados en la Evaluación de Inspección ({SECCION_campo}): opcionales
  const EVALUATION_DICTAMEN_KEY = /^\{(ESTRUCTURAL|EQUIPO_ESPECIFICO|INSTALACION_ELECTRICA|INSTALACION_GAS|RECIPIENTES_PRESION)_/;
  const CARTA_DATA_FIELD_KEYS = new Set(['{DESTINATARIO_NOMBRE}', '{DESTINATARIO_CARGO}', '{FOLIO_SECRETARIA_ESTATAL}']);
  const INSPECCION_DATA_FIELD_KEYS = new Set(['{PERSONA_ACOMPANA_RECORRIDO}']);

  const openCartaSection = (entityType, entityId, tab = 'CARTA') => {
    const workOrder = selectedWorkOrderForValidation;
    if (!workOrder) return;
    setValidationDialogOpen(false);
    setPendingCartaFocus({ entityType, branchId: entityType === 'SUCURSAL' ? entityId : null, tab });
    setCartaReturnWorkOrder(workOrder);
    handleIniciarPIP(workOrder);
  };

  // Regreso desde la Carta (Editar PIPC) a "Validar Campos" de la misma OT, con validación nueva
  const returnFromCartaToValidation = () => {
    const workOrder = cartaReturnWorkOrder;
    setCartaReturnWorkOrder(null);
    setPipDialogOpen(false);
    setPipActiveTab(0);
    if (selectedWorkOrder) refreshWorkOrderRow(selectedWorkOrder);
    if (workOrder) handleValidateFields(workOrder);
  };

  // Campo que falta para generar un documento: borde y etiqueta en naranja (mismo criterio que
  // Empresas/Sucursales)
  const missingFieldSx = (value) => (!String(value ?? '').trim() ? {
    '& .MuiOutlinedInput-notchedOutline': { borderColor: '#ed6c02', borderWidth: 2 },
    '& .MuiInputLabel-root': { color: '#ed6c02' },
  } : {});

  // Dado un campo faltante (con su key cruda) y el tipo/id de la entidad, arma la ruta +
  // highlightFieldKey a usar para saltar directo al campo (si ya existe mapeo para él).
  const getFieldJumpTarget = (fieldKey, entityType, entityId) => {
    if (CARTA_DATA_FIELD_KEYS.has(fieldKey)) {
      return {
        label: 'Iniciar Programa → Datos del Inmueble',
        action: () => openCartaSection(entityType, entityId),
      };
    }
    if (INSPECCION_DATA_FIELD_KEYS.has(fieldKey)) {
      return {
        label: 'Iniciar Programa → Datos del Inmueble → Inspección',
        action: () => openCartaSection(entityType, entityId, 'INSPECCION'),
      };
    }
    if (AGENDA_FIELD_KEYS.has(fieldKey)) {
      return {
        path: '/servicios/agenda',
        label: 'Agenda de Servicios',
        state: {
          highlightWorkOrderId: selectedWorkOrderForValidation?.id,
          highlightEntityType: entityType,
          highlightBranchId: entityType === 'SUCURSAL' ? entityId : null,
          highlightFieldKey: stripBraces(fieldKey),
        },
      };
    }
    if (EVALUATION_FIELD_KEYS.has(fieldKey) || EVALUATION_DICTAMEN_KEY.test(fieldKey)) {
      return {
        path: '/evaluaciones/inspeccion',
        label: 'Evaluación de Inspección',
        state: {
          quotationId: selectedWorkOrderForValidation?.quotationId,
          companyId: selectedWorkOrderForValidation?.companyId,
          companyName: selectedWorkOrderForValidation?.companyName,
          branchId: entityType === 'SUCURSAL' ? entityId : null,
          entityType,
          highlightFieldKey: stripBraces(fieldKey),
        },
      };
    }
    if (entityType === 'SUCURSAL' && BRANCH_FIELD_KEYS.has(fieldKey)) {
      return {
        path: '/clientes/sucursales',
        label: 'Gestión de Sucursales',
        state: { highlightEntityId: entityId, entityType, highlightFieldKey: getBranchDomFieldKey(fieldKey) },
      };
    }
    // Fallback: campos que solo existen a nivel Empresa y nunca tienen valor propio de sucursal
    // (Nombre Comercial, RFC, Contacto Corporativo, etc. -- no están en BRANCH_FIELD_KEYS). Si
    // estamos viendo una Sucursal y el campo no vive en Gestión de Sucursales, el arreglo real
    // está en Catálogo de Empresas, sobre la EMPRESA (no la sucursal) -- por eso usamos companyId
    // en vez del id de la sucursal, y forzamos entityType MATRIZ para que CatalogoEmpresas.jsx
    // abra el diálogo correcto.
    if (COMPANY_FIELD_KEYS.has(fieldKey)) {
      return {
        path: '/clientes/empresas',
        label: 'Catálogo de Empresas',
        state: {
          highlightEntityId: entityType === 'SUCURSAL' ? selectedWorkOrderForValidation?.companyId : entityId,
          entityType: 'MATRIZ',
          highlightFieldKey: getCompanyDomFieldKey(fieldKey),
        },
      };
    }
    return null;
  };

  // Pantallas que saben regresar a esta validación (ver ReturnToValidation.jsx)
  const VALIDATION_RETURN_PATHS = ['/clientes/empresas', '/clientes/sucursales', '/evaluaciones/inspeccion'];
  const withValidationReturn = (target) => (VALIDATION_RETURN_PATHS.includes(target.path) && selectedWorkOrderForValidation
    ? { ...target.state, returnToValidation: { workOrderId: selectedWorkOrderForValidation.id, orderNumber: selectedWorkOrderForValidation.orderNumber } }
    : target.state);

  // Mapeo de sección → ruta de navegación
  const getSectionRoute = (sectionName, entityType, entityId) => {
    const sectionMap = {
      'Información de la Empresa': { path: '/clientes/empresas', label: 'Catálogo de Empresas' },
      'Información del Inmueble': entityType === 'SUCURSAL'
        ? { path: '/clientes/sucursales', label: 'Gestión de Sucursales' }
        : { path: '/clientes/empresas', label: 'Catálogo de Empresas' },
      'Información Operativa': entityType === 'SUCURSAL'
        ? { path: '/clientes/sucursales', label: 'Gestión de Sucursales' }
        : { path: '/clientes/empresas', label: 'Catálogo de Empresas' },
      'Información del Documento': { path: '/estadisticas', label: 'Gestión de Cotizaciones' },
      'Información del PIPC': { path: null, label: 'Editar PIPC en esta pantalla' },
      'Tablas Dinámicas': { path: null, label: 'Editar en esta pantalla' },
    };
    return sectionMap[sectionName] || null;
  };

  // Renderiza el encabezado de sección con link de navegación. Preferimos saltar directo al
  // primer campo faltante de la sección (mismo destino + resaltado que ya usan los links por
  // campo) en vez de la ruta genérica de sección: una sección como "Información Operativa"
  // mezcla campos de Catálogo/Gestión de Sucursales con campos de Evaluación de Inspección
  // (Sustancias peligrosas, Capacidad de gas, Visto bueno), así que la ruta genérica podía
  // mandar a la pantalla equivocada y nunca resaltaba nada. getSectionRoute solo se usa como
  // fallback para secciones sin mapeo de campo individual (ej. "Información del Documento").
  const renderSectionHeader = (sectionName, entityType, entityId, color, fields) => {
    const firstFieldJump = fields && fields.length > 0
      ? getFieldJumpTarget(fields[0].key, entityType, entityId)
      : null;
    const route = getSectionRoute(sectionName, entityType, entityId);
    const target = firstFieldJump
      ? { path: firstFieldJump.path, state: firstFieldJump.state, action: firstFieldJump.action, label: firstFieldJump.label || sectionName }
      : (route && route.path ? { path: route.path, state: { highlightEntityId: entityId, entityType }, label: route.label } : null);
    return (
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
        <Typography variant="caption" fontWeight={600} color="text.secondary">{sectionName}:</Typography>
        {target && (
          <Tooltip title={`Ir a ${target.label}`}>
            <IconButton
              size="small"
              onClick={() => {
                if (target.action) {
                  target.action();
                  return;
                }
                setValidationDialogOpen(false);
                navigate(target.path, { state: withValidationReturn(target) });
              }}
              sx={{ p: 0.2, color: color || '#1976d2' }}
            >
              <OpenInNew sx={{ fontSize: 14 }} />
            </IconButton>
          </Tooltip>
        )}
      </Box>
    );
  };

  // Agrupa la lista plana (missingRequired/missingOptional, con key) por sección,
  // conservando cada key individual para poder ofrecer el salto directo al campo.
  const groupMissingFieldsBySection = (fields) => {
    const bySection = {};
    (fields || []).forEach((f) => {
      if (!bySection[f.section]) bySection[f.section] = [];
      bySection[f.section].push(f);
    });
    return bySection;
  };

  // Renderiza una lista de campos faltantes de una sección; si existe un salto directo
  // (Grupo 1: Catálogo de Empresas) el campo se muestra como link, si no como texto plano.
  const renderMissingFieldsList = (fields, entityType, entityId, color) => (
    fields.map((f, i) => {
      const jumpTarget = getFieldJumpTarget(f.key, entityType, entityId);
      if (jumpTarget) {
        return (
          <Typography
            key={i}
            variant="caption"
            display="block"
            onClick={() => {
              if (jumpTarget.action) {
                jumpTarget.action();
                return;
              }
              setValidationDialogOpen(false);
              navigate(jumpTarget.path, { state: withValidationReturn(jumpTarget) });
            }}
            sx={{ ml: 1, color, cursor: 'pointer', textDecoration: 'underline', '&:hover': { opacity: 0.75 } }}
          >
            • {f.description}
          </Typography>
        );
      }
      return (
        <Typography key={i} variant="caption" display="block" sx={{ ml: 1, color }}>• {f.description}</Typography>
      );
    })
  );

  // Renderiza la sección de validación de un documento (RIC o PIPC) para una entidad
  const DOC_SHORT_NAMES = { RIC: 'RIC', PIPC: 'PIPC', CARTA: 'Carta', ACTA: 'Acta' };
  const cartaActaBlockedReason = selectedWorkOrderForValidation && !hasQaRound1Approved(selectedWorkOrderForValidation)
    ? 'Se habilita después de la primera ronda de revisión de calidad del PIPC'
    : null;

  const renderDocValidation = (docData, docLabel, entityType, entityId, docType, entityLabel, blockedReason) => {
    if (!docData) return null;
    const pct = docData.completionPercentage || 0;
    const missingReq = groupMissingFieldsBySection(docData.missingRequired);
    const missingOpt = groupMissingFieldsBySection(docData.missingOptional);
    const hasReqMissing = Object.keys(missingReq).length > 0;
    const hasOptMissing = Object.keys(missingOpt).length > 0;
    const generateKey = docType ? `${docType}-${entityType === 'SUCURSAL' ? entityId : 'matriz'}` : null;
    const isGeneratingThis = generateKey && generatingEntityDoc === generateKey;

    return (
      <Box sx={{ mb: 2 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.5 }}>
          {getReadinessIcon(pct)}
          <Typography variant="subtitle2" fontWeight={700}>{docLabel}</Typography>
          <Chip label={`${pct}%`} size="small" sx={{ bgcolor: getReadinessColor(pct), color: '#fff', fontWeight: 700 }} />
        </Box>
        <LinearProgress
          variant="determinate"
          value={pct}
          sx={{ height: 6, borderRadius: 3, mb: 1, bgcolor: '#e0e0e0',
            '& .MuiLinearProgress-bar': { bgcolor: getReadinessColor(pct), borderRadius: 3 }
          }}
        />
        {docType && (
          <Tooltip title={blockedReason || (pct === 100 ? '' : 'Completa los campos requeridos para poder generarlo')}>
            <span>
              <Button
                size="small"
                variant="outlined"
                startIcon={isGeneratingThis ? <CircularProgress size={14} /> : <Description fontSize="small" />}
                disabled={pct !== 100 || isGeneratingThis || Boolean(blockedReason)}
                onClick={() => handleGenerateSingleEntity(docType, entityType, entityId, entityLabel)}
                sx={{ textTransform: 'none', mb: 1, fontSize: '0.72rem', py: 0.3 }}
              >
                {isGeneratingThis ? 'Generando...' : `Generar ${DOC_SHORT_NAMES[docType] || docType} de este ente`}
              </Button>
            </span>
          </Tooltip>
        )}
        {hasReqMissing && (
          <Box sx={{ mb: 1, p: 1, bgcolor: '#ffebee', borderRadius: 1 }}>
            <Typography variant="caption" fontWeight={700} color="error">Obligatorios faltantes (no se puede generar sin ellos):</Typography>
            {Object.entries(missingReq).map(([section, fields]) => (
              <Box key={section} sx={{ ml: 1, mt: 0.5 }}>
                {renderSectionHeader(section, entityType, entityId, '#d32f2f', fields)}
                {renderMissingFieldsList(fields, entityType, entityId, '#d32f2f')}
              </Box>
            ))}
          </Box>
        )}
        {hasOptMissing && (
          <Box sx={{ p: 1, bgcolor: '#fff3e0', borderRadius: 1 }}>
            <Typography variant="caption" fontWeight={700} sx={{ color: '#e65100' }}>Quedarán vacíos en el documento (opcionales):</Typography>
            {(docData.missingOptional || []).some(f => f.optional) && (
              <Typography variant="caption" display="block" sx={{ color: '#8d6e63', ml: 1 }}>
                Los dictámenes de la Evaluación de Inspección <strong>no son obligatorios</strong>: si se capturan salen en el PIPC; si no, quedan en blanco y no impiden generarlo.
              </Typography>
            )}
            {Object.entries(missingOpt).map(([section, fields]) => (
              <Box key={section} sx={{ ml: 1, mt: 0.5 }}>
                {renderSectionHeader(section, entityType, entityId, '#ef6c00', fields)}
                {renderMissingFieldsList(fields, entityType, entityId, '#ef6c00')}
              </Box>
            ))}
          </Box>
        )}
        {!hasReqMissing && !hasOptMissing && (
          <Typography variant="caption" sx={{ color: '#4caf50', fontWeight: 600 }}>Todos los campos completos</Typography>
        )}
      </Box>
    );
  };

  // Renderiza la sección de documentos de cumplimiento (Subir Archivos) de una entidad
  // Validar Campos: una pestaña por documento del ente (RIC, PIPC, Carta, Acta, Documentos) para
  // que ninguno quede perdido al fondo del scroll. Color: rojo = faltan requeridos, naranja =
  // solo opcionales, verde = completo. Abre en el primero con pendientes.
  const docTabStatus = (tab) => {
    if (tab.key === 'DOCS') {
      return (tab.data?.missingDocuments || []).length === 0 ? 'ok' : 'required';
    }
    if ((tab.data?.missingRequired || []).length > 0) return 'required';
    return (tab.data?.completionPercentage ?? 0) < 100 ? 'optional' : 'ok';
  };
  const DOC_TAB_COLORS = {
    required: { bg: '#ffebee', border: '#e57373', text: '#c62828' },
    optional: { bg: '#fff3e0', border: '#ffb74d', text: '#e65100' },
    ok: { bg: '#e8f5e9', border: '#81c784', text: '#2e7d32' }
  };
  const renderEntityDocTabs = (e, entityKey) => {
    const tabs = [
      { key: 'RIC', label: 'RIC', data: e.ric, render: () => renderDocValidation(e.ric, 'RIC — Reporte de Inspección', e.entityType, e.entityId, 'RIC', e.entityName) },
      { key: 'PIPC', label: 'PIPC', data: e.pipc, render: () => renderDocValidation(e.pipc, 'PIPC — Programa Interno PC', e.entityType, e.entityId, 'PIPC', e.entityName) },
      { key: 'CARTA', label: 'Carta', data: e.carta, render: () => renderDocValidation(e.carta, 'Carta de Corresponsabilidad', e.entityType, e.entityId, 'CARTA', e.entityName, cartaActaBlockedReason) },
      { key: 'ACTA', label: 'Acta', data: e.acta, render: () => renderDocValidation(e.acta, 'Acta Constitutiva de la UIPC', e.entityType, e.entityId, 'ACTA', e.entityName, cartaActaBlockedReason) },
      { key: 'DOCS', label: 'Documentos', data: e.documentos, render: () => renderDocumentosValidation(e.documentos, entityKey) }
    ].filter(t => t.data);
    if (tabs.length === 0) return null;
    const firstPending = tabs.find(t => docTabStatus(t) === 'required') || tabs.find(t => docTabStatus(t) === 'optional') || tabs[0];
    const selected = tabs.find(t => t.key === validationDocTab[entityKey]) || firstPending;
    return (
      <Box>
        <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', mb: 2 }}>
          {tabs.map(t => {
            const c = DOC_TAB_COLORS[docTabStatus(t)];
            const active = t.key === selected.key;
            const value = t.key === 'DOCS'
              ? `${t.data.uploadedCount || 0}/${t.data.totalRequired || 0}`
              : `${t.data.completionPercentage ?? 0}%`;
            return (
              <Box key={t.key} onClick={() => setValidationDocTab(prev => ({ ...prev, [entityKey]: t.key }))}
                sx={{ px: 1.5, py: 0.75, borderRadius: 2, cursor: 'pointer', bgcolor: active ? c.text : c.bg,
                  border: `2px solid ${active ? c.text : c.border}`, color: active ? '#fff' : c.text,
                  display: 'flex', alignItems: 'center', gap: 0.75, transition: 'all 0.15s', '&:hover': { borderColor: c.text } }}>
                <Typography variant="body2" sx={{ fontWeight: 700, color: 'inherit' }}>{t.label}</Typography>
                <Typography variant="caption" sx={{ fontWeight: 700, color: 'inherit', opacity: 0.9 }}>{value}</Typography>
              </Box>
            );
          })}
        </Box>
        {selected.render()}
      </Box>
    );
  };

  const renderDocumentosValidation = (docsData, entityKey = 'ente') => {
    if (!docsData) return null;
    const pct = docsData.completionPercentage || 0;
    const missingByCategory = docsData.missingDocumentsByCategory || {};
    const hasMissing = Object.keys(missingByCategory).length > 0;

    return (
      <Box sx={{ mb: 2 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.5 }}>
          {getReadinessIcon(pct)}
          <Typography variant="subtitle2" fontWeight={700}>Documentos de Cumplimiento</Typography>
          <Chip label={`${pct}%`} size="small" sx={{ bgcolor: getReadinessColor(pct), color: '#fff', fontWeight: 700 }} />
        </Box>
        <LinearProgress
          variant="determinate"
          value={pct}
          sx={{ height: 6, borderRadius: 3, mb: 1, bgcolor: '#e0e0e0',
            '& .MuiLinearProgress-bar': { bgcolor: getReadinessColor(pct), borderRadius: 3 }
          }}
        />
        <Typography variant="caption" color="text.secondary" display="block" sx={{ mb: 0.5 }}>
          {docsData.uploadedCount || 0} de {docsData.totalRequired || 0} subidos
        </Typography>
        {hasMissing ? (
          <Box sx={{ p: 1, bgcolor: '#ffebee', borderRadius: 1 }}>
            <Typography variant="caption" fontWeight={700} color="error">Documentos Faltantes (clic en cada categoría para ver cuáles):</Typography>
            {Object.entries(missingByCategory).map(([category, labels]) => {
              const catKey = `${entityKey}|${category}`;
              const open = openDocCategories.has(catKey);
              return (
                <Box key={category} sx={{ ml: 1, mt: 0.5 }}>
                  <Box onClick={() => setOpenDocCategories(prev => {
                      const next = new Set(prev);
                      if (next.has(catKey)) next.delete(catKey); else next.add(catKey);
                      return next;
                    })}
                    sx={{ display: 'flex', alignItems: 'center', gap: 0.5, cursor: 'pointer', '&:hover': { opacity: 0.8 } }}>
                    <Typography variant="caption" sx={{ color: 'text.secondary', width: 12 }}>{open ? '▾' : '▸'}</Typography>
                    <Typography variant="caption" fontWeight={600} color="text.secondary">{category}</Typography>
                    <Chip label={`faltan ${labels.length}`} size="small" sx={{ height: 18, fontSize: '0.65rem', bgcolor: '#ffcdd2', color: '#b71c1c', fontWeight: 700 }} />
                  </Box>
                  <Collapse in={open}>
                    {labels.map((l, i) => (
                      <Typography key={i} variant="caption" display="block" sx={{ ml: 3, color: '#d32f2f' }}>• {l}</Typography>
                    ))}
                  </Collapse>
                </Box>
              );
            })}
            <Button
              size="small"
              startIcon={<AttachFile sx={{ fontSize: 14 }} />}
              onClick={() => {
                setValidationDialogOpen(false);
                handleOpenUploadDialog(selectedWorkOrderForValidation);
              }}
              sx={{ mt: 1, textTransform: 'none', fontSize: '0.72rem' }}
            >
              Subir documentos
            </Button>
          </Box>
        ) : (
          <Typography variant="caption" sx={{ color: '#4caf50', fontWeight: 600 }}>Todos los documentos subidos</Typography>
        )}
      </Box>
    );
  };

  // Funciones para manejar notas -- historial por cotización (mismo endpoint que Estadísticas
  // de Cotizaciones: GET/POST /quotations/{quotationId}/notes), no un solo campo que se pisa.
  const fetchWorkOrderNotes = async (quotationId) => {
    setNotesLoading(true);
    try {
      const res = await api.get(`/quotations/${quotationId}/notes`);
      setNotesList(res.data || []);
    } catch (err) {
      setNotesList([]);
    } finally {
      setNotesLoading(false);
    }
  };

  const handleOpenNotesMenu = (event, workOrder) => {
    event.stopPropagation();
    setNotesMenuAnchor(event.currentTarget);
    setNotesMenuWorkOrder(workOrder);
  };

  const handleCloseNotesMenu = () => {
    setNotesMenuAnchor(null);
    setNotesMenuWorkOrder(null);
  };

  const handleOpenNotesDialog = async (workOrder, anchorElement) => {
    if (!workOrder?.quotationId) return;
    setNotesAnchorEl(anchorElement);
    setSelectedWorkOrderForNotes(workOrder);
    setNoteInput('');
    await fetchWorkOrderNotes(workOrder.quotationId);
  };

  const handleCloseNotesDialog = () => {
    setNotesAnchorEl(null);
    setSelectedWorkOrderForNotes(null);
    setNotesList([]);
    setNoteInput('');
  };

  const handleSaveNote = async () => {
    if (!noteInput.trim() || !selectedWorkOrderForNotes?.quotationId) return;
    setNotesSaving(true);
    try {
      await api.post(`/quotations/${selectedWorkOrderForNotes.quotationId}/notes`, {
        content: noteInput.trim()
      });
      setNoteInput('');
      await fetchWorkOrderNotes(selectedWorkOrderForNotes.quotationId);
      setSnackbar({ open: true, message: '✅ Nota agregada exitosamente', severity: 'success' });
    } catch (error) {
      console.error('Error guardando nota:', error);
      setSnackbar({ open: true, message: '❌ Error al guardar la nota', severity: 'error' });
    } finally {
      setNotesSaving(false);
    }
  };

  // Notas POR ENTE -- general_notes (note_type='ENTE'), keyed por WorkOrderDetail.id, no por
  // quotationId. `entity` viene de workOrderEntityMap: { name, type, branchId, detailId }.
  const fetchEntityNotes = async (detailId) => {
    setEntityNotesLoading(true);
    try {
      const res = await api.get(`/work-order-details/${detailId}/notes`);
      setEntityNotesList(res.data || []);
    } catch (err) {
      setEntityNotesList([]);
    } finally {
      setEntityNotesLoading(false);
    }
  };

  const handleOpenEntityNotes = async (entity, anchorElement) => {
    if (!entity?.detailId) return;
    setEntityNotesAnchorEl(anchorElement);
    setSelectedEntityForNotes(entity);
    setEntityNoteInput('');
    await fetchEntityNotes(entity.detailId);
  };

  const handleCloseEntityNotes = () => {
    setEntityNotesAnchorEl(null);
    setSelectedEntityForNotes(null);
    setEntityNotesList([]);
    setEntityNoteInput('');
  };

  const handleSaveEntityNote = async () => {
    if (!entityNoteInput.trim() || !selectedEntityForNotes?.detailId) return;
    setEntityNotesSaving(true);
    try {
      await api.post(`/work-order-details/${selectedEntityForNotes.detailId}/notes`, {
        content: entityNoteInput.trim()
      });
      setEntityNoteInput('');
      await fetchEntityNotes(selectedEntityForNotes.detailId);
      setSnackbar({ open: true, message: '✅ Nota agregada exitosamente', severity: 'success' });
    } catch (error) {
      console.error('Error guardando nota de ente:', error);
      setSnackbar({ open: true, message: '❌ Error al guardar la nota', severity: 'error' });
    } finally {
      setEntityNotesSaving(false);
    }
  };

  // Datos Generales es de solo lectura (valores institucionales + representante legal en vivo), así
  // que ya no hay botón para guardarlo: al abrir "Editar PIPC" se crea o actualiza el registro del
  // PIP en silencio para que el documento y "Validación de Campos" tengan los mismos valores que
  // se ven en pantalla. Cada pestaña de datos por ente guarda con su propio botón.
  const syncPipRecord = async (pipData, workOrder, legalRep) => {
    if (!canEditBasePip) return;
    const payload = {
      ...pipData,
      approvedBy: legalRep || pipData.approvedBy || '',
      internalFolio: workOrder.orderNumber || pipData.internalFolio || '',
    };
    try {
      if (pipData.id) {
        await api.put(`/pip-related/${pipData.id}`, payload);
      } else {
        const resp = await api.post('/pip-related', payload);
        if (resp.data?.id) setPipFormData(prev => ({ ...prev, id: resp.data.id }));
      }
      setPipStatus(prev => ({ ...prev, [workOrder.quotationId]: true }));
      setPipCompletionStatus(prev => ({ ...prev, [workOrder.quotationId]: checkPipCompletion(payload) }));
    } catch (err) {
      console.error('No se pudo sincronizar el registro del PIP:', err);
    }
  };

  const handlePipFormChange = (field, value) => {
    setPipFormData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const getPipAvailableTabs = () => {
    const tabs = [];
    if (canEditBasePip) {
      tabs.push(0);
    }
    // Datos del Inmueble/Seguro/Documentos los editan Coordinador, Administrador y Ejecutivo
    // (este último los captura en sitio).
    // UIPC (antes tab 3) ya no vive aquí -- tiene su propia entrada "Captura UIPC" fuera de
    // esta pantalla.
    if (canEditBasePip || canEditUipcByEntity) {
      tabs.push(1);
      tabs.push(2);
      tabs.push(4);
    }
    return tabs;
  };

  const goToNextPipTab = () => {
    const available = getPipAvailableTabs();
    const currentIdx = available.indexOf(pipActiveTab);
    if (currentIdx >= 0 && currentIdx < available.length - 1) {
      setPipActiveTab(available[currentIdx + 1]);
    }
  };

  const goToPreviousPipTab = () => {
    const available = getPipAvailableTabs();
    const currentIdx = available.indexOf(pipActiveTab);
    if (currentIdx > 0) {
      setPipActiveTab(available[currentIdx - 1]);
    }
  };

  // Función para verificar si el PIP está completado
  const isPipCompleted = (quotationId) => {
    // Primero verificar si tenemos el estado en memoria
    if (pipCompletionStatus[quotationId] !== undefined) {
      const isComplete = pipCompletionStatus[quotationId] === true;
      console.log('🔍 isPipCompleted (desde estado) - quotationId:', quotationId, 'isComplete:', isComplete);
      return isComplete;
    }
    
    // Si no está en memoria, verificar si el PIP está iniciado
    // Si está iniciado, asumimos que está completo (ya que se guardó)
    const isStarted = pipStatus[quotationId] === true;
    console.log('🔍 isPipCompleted (desde pipStatus) - quotationId:', quotationId, 'isStarted:', isStarted);
    return isStarted;
  };

  // Función para verificar si los campos esenciales del PIP están completos
  // Mismo criterio que el Tablero de Seguimiento (utils/workflowSteps.isPipComplete)
  const checkPipCompletion = (pipData) => isPipComplete(pipData);

  // ── Funciones UIPC por ente ────────────────────────────────────────────

  const handleEntityUipcMemberChange = (scheduleId, field, value) => {
    setNewEntityUipcMember(prev => ({
      ...prev,
      [scheduleId]: { ...(prev[scheduleId] || {}), [field]: value }
    }));
  };

  // Cada alta/baja guarda solo ese miembro (POST /uipc o DELETE /uipc/{id}); antes se reenviaba y
  // reescribía la lista completa del ente en cada cambio. La captura no se bloquea: el miembro
  // aparece al instante como "guardando" y, si falla, queda marcado para reintentar.
  const patchUipcMember = (scheduleId, memberId, patch) => {
    setEntityUipcMembers(prev => ({
      ...prev,
      [scheduleId]: (prev[scheduleId] || []).map(m => (m.id === memberId ? (typeof patch === 'function' ? patch(m) : { ...m, ...patch }) : m))
    }));
  };

  const persistUipcMember = async (scheduleId, draft) => {
    patchUipcMember(scheduleId, draft.id, { _pending: true, _error: false });
    try {
      const resp = await api.post('/uipc', {
        quotationId: selectedWorkOrder.quotationId,
        workOrderScheduleId: scheduleId,
        workerName: draft.workerName,
        brigadePosition: draft.brigadePosition,
      });
      patchUipcMember(scheduleId, draft.id, () => resp.data);
    } catch (err) {
      console.error('Error guardando miembro UIPC:', err);
      patchUipcMember(scheduleId, draft.id, { _pending: false, _error: true });
      setSnackbar({ open: true, message: `No se pudo guardar a ${draft.workerName}. Toca "Reintentar".`, severity: 'error' });
    }
  };

  const handleAddEntityUipcMember = (scheduleId) => {
    const member = newEntityUipcMember[scheduleId] || {};
    if (!member.workerName?.trim() || !member.brigadePosition?.trim()) {
      setSnackbar({ open: true, message: 'Complete nombre y puesto del miembro', severity: 'warning' });
      return;
    }
    const draft = {
      id: `tmp-${Date.now()}-${Math.random().toString(36).slice(2, 7)}`,
      workerName: member.workerName.trim(),
      brigadePosition: member.brigadePosition,
      _pending: true,
    };
    setEntityUipcMembers(prev => ({ ...prev, [scheduleId]: [...(prev[scheduleId] || []), draft] }));
    setNewEntityUipcMember(prev => ({ ...prev, [scheduleId]: { workerName: '', brigadePosition: '' } }));
    persistUipcMember(scheduleId, draft);
  };

  const handleRemoveEntityUipcMember = async (scheduleId, member) => {
    const current = entityUipcMembers[scheduleId] || [];
    const index = current.findIndex(m => m.id === member.id);
    setEntityUipcMembers(prev => ({ ...prev, [scheduleId]: (prev[scheduleId] || []).filter(m => m.id !== member.id) }));
    // Si nunca llegó a guardarse no hay nada que borrar en el servidor
    if (String(member.id).startsWith('tmp-')) return;
    try {
      await api.delete(`/uipc/${member.id}`);
    } catch (err) {
      console.error('Error eliminando miembro UIPC:', err);
      setEntityUipcMembers(prev => {
        const list = [...(prev[scheduleId] || [])];
        list.splice(Math.max(0, index), 0, member);
        return { ...prev, [scheduleId]: list };
      });
      setSnackbar({ open: true, message: `No se pudo quitar a ${member.workerName}.`, severity: 'error' });
    }
  };

  const handleQuotationEditChange = (scheduleId, field, value) => {
    setEntityQuotationEdits(prev => ({
      ...prev,
      [scheduleId]: { ...(prev[scheduleId] || {}), [field]: value }
    }));
  };

  // Guarda contacto/EPP (quotation_entities) y fecha/hora (work_order_details, vía el mismo
  // endpoint) en un solo PUT -- así queda igual sin importar si se editó aquí o en
  // perfil-riesgo/llenar-informacion.
  const handleSaveEntityQuotationInfo = async (schedule) => {
    if (!schedule.quotationEntityId) {
      setSnackbar({ open: true, message: 'No se encontró la cotización asociada a este ente.', severity: 'error' });
      return;
    }
    setSavingQuotationInfo(schedule.id);
    try {
      const edits = entityQuotationEdits[schedule.id] || {};
      if (!(edits.inspectorContact || '').trim()) {
        setSnackbar({ open: true, message: 'Indica la persona que acompañará en el recorrido (campo obligatorio).', severity: 'warning' });
        return;
      }
      await api.put(`/quotations/entities/${schedule.quotationEntityId}/inspection-info`, edits);
      setSnackbar({ open: true, message: 'Información guardada correctamente.', severity: 'success' });
    } catch (err) {
      setSnackbar({
        open: true,
        message: `Error al guardar: ${err.response?.data?.message || err.message}`,
        severity: 'error'
      });
    } finally {
      setSavingQuotationInfo(null);
    }
  };

  const fetchCartaData = async () => {
    if (!selectedWorkOrder?.id) return;
    setCartaData(prev => ({ ...prev, loading: true, error: null }));
    try {
      const resp = await api.get(`/carta-data/work-order/${selectedWorkOrder.id}`);
      const byDetail = {};
      const edits = {};
      (resp.data?.entities || []).forEach(e => {
        byDetail[e.detailId] = e;
        edits[e.detailId] = {
          stateSecretaryFolio: e.stateSecretaryFolio || '',
          holderName: e.holderName || '',
          holderTitle: e.holderTitle || '',
        };
      });
      setCartaData({ loading: false, error: null, byDetail });
      setCartaEdits(edits);
    } catch (err) {
      setCartaData(prev => ({ ...prev, loading: false, error: 'No se pudieron cargar los datos de la Carta de Corresponsabilidad.' }));
    }
  };

  const handleCartaEditChange = (detailId, field, value) => {
    setCartaEdits(prev => ({ ...prev, [detailId]: { ...(prev[detailId] || {}), [field]: value } }));
  };

  const handleSaveCartaData = async (schedule) => {
    const current = cartaData.byDetail[schedule.id] || {};
    const edits = cartaEdits[schedule.id] || {};
    const folioChanged = (edits.stateSecretaryFolio || '').trim() !== (current.stateSecretaryFolio || '');
    const holderChanged = (edits.holderName || '').trim() !== (current.holderName || '')
      || (edits.holderTitle || '').trim() !== (current.holderTitle || '');
    if (!folioChanged && !holderChanged) {
      setSnackbar({ open: true, message: 'No hay cambios por guardar.', severity: 'info' });
      return;
    }
    setSavingCarta(schedule.id);
    try {
      if (folioChanged) {
        await api.put(`/carta-data/detail/${schedule.id}/folio`, { folio: edits.stateSecretaryFolio });
      }
      if (holderChanged) {
        await api.put('/carta-data/authority', {
          state: current.state,
          municipality: current.municipality,
          holderName: edits.holderName,
          holderTitle: edits.holderTitle,
        });
      }
      await fetchCartaData();
      setSnackbar({ open: true, message: 'Datos de la Carta guardados correctamente.', severity: 'success' });
      if (cartaReturnWorkOrder) {
        returnFromCartaToValidation();
      }
    } catch (err) {
      setSnackbar({
        open: true,
        message: `Error al guardar: ${err.response?.data?.error || err.response?.data?.message || err.message}`,
        severity: 'error'
      });
    } finally {
      setSavingCarta(null);
    }
  };

  // Resumen de documentos de cumplimiento por ente (tab "Documentos") -- lazy-load al
  // expandir, mismo patrón que fetchEntityPropertyData. El detalle/subida real vive en
  // UploadDocumentosDialog, que se abre con el ente ya preseleccionado.
  const fetchDocumentsSummary = async (schedule, force = false) => {
    const scheduleId = schedule.id;
    if (!force && (documentsSummaryByEntity[scheduleId]?.loaded || documentsSummaryByEntity[scheduleId]?.loading)) return;
    setDocumentsSummaryByEntity(prev => ({ ...prev, [scheduleId]: { ...(prev[scheduleId] || {}), loading: true, error: null } }));
    try {
      const isMatriz = schedule.entityType === 'MATRIZ';
      const url = isMatriz
        ? `/branch-documents/company/${selectedWorkOrder.companyId}/matriz`
        : `/branch-documents/branch/${schedule.branchId}`;
      const resp = await api.get(url);
      const catalogKeys = new Set(docCategories.flatMap(c => c.docs).map(d => d.key));
      const latestByType = new Map();
      (Array.isArray(resp.data) ? resp.data : [])
        .filter(d => catalogKeys.size === 0 || catalogKeys.has(d.documentType))
        .forEach(d => latestByType.set(d.documentType, d));
      const uploaded = [...latestByType.values()];
      const expiredCount = uploaded.filter(d => getExpirationStatus(d.expirationDate).isExpired).length;
      setDocumentsSummaryByEntity(prev => ({
        ...prev,
        [scheduleId]: { loading: false, loaded: true, error: null, uploadedCount: uploaded.length, expiredCount }
      }));
    } catch (err) {
      console.error('Error cargando resumen de documentos:', err);
      setDocumentsSummaryByEntity(prev => ({
        ...prev,
        [scheduleId]: { ...(prev[scheduleId] || {}), loading: false, error: 'No se pudo cargar el resumen de documentos.' }
      }));
    }
  };

  // Datos del Inmueble y Seguro por ente (pestaña nueva, mismo patrón que UIPC por ente):
  // matriz -> Company, sucursal -> CompanyBranch. Ninguno de los dos PUT hace merge null-safe
  // completo en el backend, así que siempre se trae el objeto completo primero y se manda de
  // vuelta completo al guardar (nunca un payload parcial).
  const fetchEntityPropertyData = async (schedule) => {
    const scheduleId = schedule.id;
    if (entityPropertyData[scheduleId]?.loaded || entityPropertyData[scheduleId]?.loading) return;
    setEntityPropertyData(prev => ({ ...prev, [scheduleId]: { ...(prev[scheduleId] || {}), loading: true, error: null } }));
    try {
      const isMatriz = !schedule.branchId;
      const url = isMatriz ? `/companies/${selectedWorkOrder.companyId}` : `/company-branches/${schedule.branchId}`;
      const resp = await api.get(url);
      setEntityPropertyData(prev => ({
        ...prev,
        [scheduleId]: { loading: false, saving: false, loaded: true, error: null, data: resp.data, original: resp.data }
      }));
    } catch (err) {
      console.error('Error cargando datos de inmueble/seguro:', err);
      setEntityPropertyData(prev => ({
        ...prev,
        [scheduleId]: { ...(prev[scheduleId] || {}), loading: false, error: 'No se pudo cargar la información.' }
      }));
    }
  };

  // La barra de avance mide los datos de TODOS los entes de la pestaña activa, así que al entrar
  // a Inmueble/Seguro/Documentos se cargan todos (antes solo se cargaban al expandir cada ente).
  useEffect(() => {
    if (!pipDialogOpen || workOrderSchedules.length === 0) return;
    if (pipActiveTab === 1 || pipActiveTab === 2) workOrderSchedules.forEach(fetchEntityPropertyData);
    if (pipActiveTab === 1) fetchCartaData();
    if (pipActiveTab === 4) workOrderSchedules.forEach(fetchDocumentsSummary);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pipDialogOpen, pipActiveTab, workOrderSchedules]);

  useEffect(() => {
    if (!pendingCartaFocus || !pipDialogOpen || workOrderSchedules.length === 0) return;
    const target = workOrderSchedules.find(s => pendingCartaFocus.entityType === 'SUCURSAL'
      ? String(s.branchId) === String(pendingCartaFocus.branchId)
      : s.entityType === 'MATRIZ');
    setPendingCartaFocus(null);
    if (!target) return;
    setPipActiveTab(1);
    setExpandedInmuebleEntity(`inmueble-${target.id}`);
    const tab = pendingCartaFocus.tab || 'CARTA';
    setPipEnteTab(prev => ({ ...prev, [target.id]: tab }));
    setTimeout(() => {
      document.getElementById(`${tab === 'INSPECCION' ? 'inspeccion' : 'carta'}-${target.id}`)?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }, 400);
  }, [pendingCartaFocus, pipDialogOpen, workOrderSchedules]);

  // Mismos rangos realistas que en NewQuotation.jsx (Datos del Inmueble por ente) -- aquí se
  // edita el mismo dato (companies/company_branches) desde Agenda de Servicios, así que debe
  // validar igual para no colar por este lado lo que ya se bloquea en la cotización.
  const PROPERTY_FIELD_LIMITS = {
    employeesCount:     { ...FIELD_LIMITS.employeesCount, label: 'empleados' },
    constructionArea:   { ...FIELD_LIMITS.constructionArea, label: 'm² de construcción' },
    landArea:           { ...FIELD_LIMITS.landArea, label: 'm² de terreno' },
    constructionLevels: { ...FIELD_LIMITS.constructionLevels, label: 'niveles' },
    floatingPopulation: { ...FIELD_LIMITS.floatingPopulation, label: 'personas' },
    maximumCapacity:    { ...FIELD_LIMITS.maximumCapacity, label: 'personas' },
  };

  const PRICED_PROPERTY_FIELDS = {
    employeesCount: 'Número de Empleados',
    constructionArea: 'M² Construcción',
    landArea: 'M² Terreno',
    constructionLevels: 'Niveles de Construcción',
  };

  const getPropertyFieldError = (field, rawValue) => {
    const limits = PROPERTY_FIELD_LIMITS[field];
    if (!limits || rawValue === '' || rawValue == null) return null;
    const value = Number(rawValue);
    if (Number.isNaN(value)) return 'Debe ser un número';
    if (value < limits.min) return `Mínimo ${limits.min} ${limits.label}`;
    if (value > limits.max) return `Máximo ${limits.max.toLocaleString('es-MX')} ${limits.label}`;
    return null;
  };

  // Mismo hint (rango permitido) que CatalogoEmpresas.jsx muestra siempre debajo del campo --
  // aquí se combina con el error puntual (getPropertyFieldError) cuando el valor está fuera de
  // rango, para que "Editar PIPC" luzca y valide igual que "Datos del Inmueble" de Editar Empresa.
  const propertyFieldHelperText = (field, rawValue) => {
    const limits = PROPERTY_FIELD_LIMITS[field];
    if (!limits) return null;
    return getPropertyFieldError(field, rawValue) || `Entre ${limits.min} y ${limits.max.toLocaleString('es-MX')} ${limits.label}`;
  };

  const handlePropertyFieldChange = (scheduleId, field, value) => {
    const limits = PROPERTY_FIELD_LIMITS[field];
    let sanitized = value;
    if (limits) {
      // Enteros para empleados/niveles; decimales para m² de construcción/terreno
      const allowDecimal = field === 'constructionArea' || field === 'landArea';
      sanitized = value.replace(allowDecimal ? /[^0-9.]/g : /[^0-9]/g, '');
      if (allowDecimal) {
        // Solo un punto decimal
        const firstDot = sanitized.indexOf('.');
        if (firstDot !== -1) {
          sanitized = sanitized.slice(0, firstDot + 1) + sanitized.slice(firstDot + 1).replace(/\./g, '');
        }
      }
      // No dejar teclear más allá del máximo permitido
      if (sanitized !== '' && sanitized !== '.' && Number(sanitized) > limits.max) {
        return;
      }
    }
    setEntityPropertyData(prev => ({
      ...prev,
      [scheduleId]: { ...prev[scheduleId], data: { ...prev[scheduleId].data, [field]: sanitized } }
    }));
  };

  // "Aprobó" = representante legal de la empresa. Se guarda en la empresa (no en el PIP) para que
  // PIPC, RIC y Carta usen el mismo dato; se manda la empresa completa porque la edición la reemplaza.
  const handleSaveApprover = async () => {
    const name = capitalizePersonName(approverDraft || '');
    if (!name) {
      setSnackbar({ open: true, message: 'Escribe el nombre del representante legal', severity: 'warning' });
      return;
    }
    if (!/^[\p{L}\s.'-]+$/u.test(name)) {
      setSnackbar({ open: true, message: 'El nombre solo puede tener letras, espacios, punto (.), apóstrofo y guion (-)', severity: 'warning' });
      return;
    }
    if (!selectedWorkOrder?.companyId) return;
    setApproverSaving(true);
    try {
      const { data: company } = await api.get(`/companies/${selectedWorkOrder.companyId}`);
      await api.put(`/companies/${selectedWorkOrder.companyId}`, { ...company, legalRepresentative: name });
      setPipApprovedByLegalRep(name);
      setCompanyInsuranceInfo((prev) => ({ ...prev, legalRepresentative: name }));
      setApproverDraft(null);
      setSnackbar({ open: true, message: 'Representante legal guardado en la empresa. Se usará en todos sus documentos.', severity: 'success' });
    } catch (err) {
      setSnackbar({ open: true, message: err.response?.data?.message || err.response?.data?.error || 'No se pudo guardar el representante legal', severity: 'error' });
    } finally {
      setApproverSaving(false);
    }
  };

  const handleSaveEntityPropertyData = async (schedule, correctionReason = null) => {
    const scheduleId = schedule.id;
    const entry = entityPropertyData[scheduleId];
    if (!entry?.data) return;
    const isMatriz = !schedule.branchId;

    const fieldErrors = Object.keys(PROPERTY_FIELD_LIMITS)
      .map(field => getPropertyFieldError(field, entry.data[field]))
      .filter(Boolean);
    if (fieldErrors.length > 0) {
      setSnackbar({ open: true, message: `⚠️ Datos del inmueble fuera de rango -- ${fieldErrors.join('; ')}`, severity: 'warning' });
      return;
    }

    // Empleados, m² y niveles se usaron para cotizar: si cambian, es una corrección en sitio
    // (pide motivo y Ventas revisa el costo) en lugar de un guardado normal.
    const original = entry.original || {};
    const changes = Object.keys(PRICED_PROPERTY_FIELDS)
      .filter(field => String(original[field] ?? '') !== String(entry.data[field] ?? ''))
      .map(field => ({ label: PRICED_PROPERTY_FIELDS[field], from: original[field], to: entry.data[field] }));
    if (changes.length > 0 && !correctionReason) {
      setCorrectionDialog({ schedule, changes, reason: '' });
      return;
    }

    setEntityPropertyData(prev => ({ ...prev, [scheduleId]: { ...prev[scheduleId], saving: true } }));
    try {
      const url = isMatriz ? `/companies/${selectedWorkOrder.companyId}` : `/company-branches/${schedule.branchId}`;
      const params = changes.length > 0
        ? { correctionWorkOrderId: selectedWorkOrder.id, correctionReason: correctionReason.trim() }
        : undefined;
      const resp = await api.put(url, entry.data, { params });
      setEntityPropertyData(prev => ({ ...prev, [scheduleId]: { ...prev[scheduleId], saving: false, data: resp.data, original: resp.data } }));
      setSnackbar({
        open: true,
        message: changes.length > 0
          ? 'Corrección guardada. Se avisó a Ventas y Administración para revisar el costo.'
          : 'Datos del inmueble y seguro guardados.',
        severity: 'success'
      });
      return true;
    } catch (err) {
      console.error('Error guardando datos de inmueble/seguro:', err);
      setEntityPropertyData(prev => ({ ...prev, [scheduleId]: { ...prev[scheduleId], saving: false } }));
      setSnackbar({
        open: true,
        message: `Error al guardar: ${err.response?.data?.message || err.response?.data?.error || err.message}`,
        severity: 'error'
      });
      return false;
    }
  };

  const handleConfirmCorrection = async () => {
    if (!correctionDialog?.reason?.trim()) return;
    const saved = await handleSaveEntityPropertyData(correctionDialog.schedule, correctionDialog.reason);
    if (saved) setCorrectionDialog(null);
  };

  // Funciones para el modal de subir archivos
  const handleOpenUploadDialog = (workOrder, branch = null) => {
    setSelectedQuotationForUpload(workOrder);
    setUploadDialogBranch(branch);
    setUploadDialogOpen(true);
  };

  const handleCloseUploadDialog = () => {
    // Lo subido cuenta para "Subir Archivos" en el menú y en el avance de la fila
    if (selectedQuotationForUpload?.id) refreshWorkOrderRow(selectedQuotationForUpload);
    if (pipDialogOpen) workOrderSchedules.forEach(s => fetchDocumentsSummary(s, true));
    setUploadDialogOpen(false);
    setSelectedQuotationForUpload(null);
    setUploadDialogBranch(null);
  };

  // Sin señal la pantalla no carga, pero la captura sin ente debe seguir a la mano
  if (loading) {
    return (
      <Box p={3}>
        {OFFLINE_FIELD_MODE && <AsyncInspectionsPanel />}
        <Box display="flex" justifyContent="center" alignItems="center" minHeight="300px">
          <CircularProgress />
        </Box>
      </Box>
    );
  }

  if (loadErrorKind) {
    return (
      <Box p={3}>
        {OFFLINE_FIELD_MODE && <AsyncInspectionsPanel />}
        <ServerUnavailable kind={loadErrorKind} onRetry={() => {
          setLoadErrorKind(null);
          setError(null);
          setLoading(true);
          if (currentUser) fetchWorkOrders(); else fetchCurrentUser();
        }} />
      </Box>
    );
  }

  if (error) {
    return (
      <Box p={3}>
        {OFFLINE_FIELD_MODE && <AsyncInspectionsPanel />}
        <Alert severity="error">
          {error}
        </Alert>
      </Box>
    );
  }

  return (
    <Box p={3}>
      <Snackbar
        open={snackbar.open}
        autoHideDuration={snackbar.duration || 3500}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        message={snackbar.message}
        ContentProps={{
          sx: {
            bgcolor: snackbar.severity === 'success' 
              ? '#388e3c' 
              : snackbar.severity === 'info' 
                ? '#1976d2' 
                : snackbar.severity === 'warning'
                  ? '#f57c00'
                  : '#d32f2f',
            color: '#fff',
            fontWeight: 'bold',
            fontSize: '1rem',
            borderRadius: 2,
            boxShadow: 3
          }
        }}
      />

      {/* Dialog resultado de generación RIC/PIPC por ente */}
      <Dialog
        open={genDialog.open}
        onClose={() => !genDialog.loading && setGenDialog(prev => ({ ...prev, open: false }))}
        maxWidth="xs"
        fullWidth
        PaperProps={{ sx: { borderRadius: 2 } }}
      >
        <DialogTitle sx={{ pb: 1, fontWeight: 700 }}>
          {(() => {
            const n = genDialog.loading ? genDialog.totalEntities : (genDialog.results?.total ?? genDialog.totalEntities);
            const archivoWord = `archivo${n > 1 ? 's' : ''}`;
            if (genDialog.loading) return `Generando ${archivoWord} ${genDialog.docType}…`;
            if (genDialog.error) return `❌ Error al generar ${genDialog.docType}`;
            if (genDialog.results?.errorCount > 0) {
              return genDialog.results.successCount > 0
                ? `⚠️ ${archivoWord[0].toUpperCase()}${archivoWord.slice(1)} ${genDialog.docType} generado${n > 1 ? 's' : ''} con errores`
                : `❌ Error al generar ${genDialog.docType}`;
            }
            return `✅ ${archivoWord[0].toUpperCase()}${archivoWord.slice(1)} ${genDialog.docType} generado${n > 1 ? 's' : ''}`;
          })()}
        </DialogTitle>
        <DialogContent>
          {genDialog.loading && (
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2, py: 2, width: '100%' }}>
              <Typography variant="body2" textAlign="center" color="text.secondary">
                {genDialog.totalEntities > 1
                  ? `Generando y subiendo los archivos ${genDialog.docType} a Dropbox por cada ente de la orden (matriz + sucursales).`
                  : `Generando y subiendo el archivo ${genDialog.docType} a Dropbox para el ente de la orden.`}
              </Typography>
              <Box sx={{ width: '100%' }}>
                <LinearProgress
                  variant="determinate"
                  value={genDialog.progressPct}
                  sx={{ height: 8, borderRadius: 4 }}
                />
              </Box>
              <Typography variant="caption" textAlign="center" color="text.secondary">
                Esto puede tomar unos minutos…
              </Typography>
            </Box>
          )}
          {!genDialog.loading && genDialog.results && (
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
              {genDialog.results.total === 0 ? (
                <Alert severity="warning">No se encontraron entes registrados en la cotización.</Alert>
              ) : (
                <>
                  <Alert severity={genDialog.results.errorCount > 0 ? 'warning' : 'success'}>
                    {genDialog.results.successCount} de {genDialog.results.total} archivo{genDialog.results.total !== 1 ? 's' : ''} {genDialog.docType} subido{genDialog.results.total !== 1 ? 's' : ''} a Dropbox correctamente.
                    {genDialog.results.errorCount > 0 && ` ${genDialog.results.errorCount} con error.`}
                  </Alert>
                  {genDialog.results.results?.map((r, i) => (
                    <Box key={i} sx={{ display: 'flex', flexDirection: 'column', gap: 0.2 }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <Typography variant="caption" sx={{ color: r.success ? '#2e7d32' : '#c62828' }}>
                          {r.success ? '✅' : '❌'}
                        </Typography>
                        <Typography variant="caption" color="text.secondary" noWrap>{r.entityName}</Typography>
                      </Box>
                      {!r.success && r.error && (
                        <Typography variant="caption" sx={{ color: '#c62828', pl: 3 }}>
                          {r.error}
                        </Typography>
                      )}
                    </Box>
                  ))}
                </>
              )}
              {genDialog.results.successCount > 0 && (
                <Alert severity="info" sx={{ mt: 0.5 }}>
                  Los archivos quedan disponibles en <strong>Servicios → Gestión Documental</strong>.
                </Alert>
              )}
            </Box>
          )}
          {!genDialog.loading && genDialog.error && (
            <Alert severity="error">{genDialog.error}</Alert>
          )}
        </DialogContent>
        {!genDialog.loading && (
          <DialogActions>
            <Button onClick={() => setGenDialog(prev => ({ ...prev, open: false }))} variant="contained" size="small">
              Cerrar
            </Button>
          </DialogActions>
        )}
      </Dialog>

      {/* Backdrop para indicar generación de documento */}

      {/* Header */}
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <Box>
          <Typography variant="h4" sx={{ fontWeight: 'bold', color: '#1976d2' }}>
            Programas{riskLevelFilter ? ` - Riesgo ${riskLevelFilter.charAt(0).toUpperCase() + riskLevelFilter.slice(1)}` : ''}
          </Typography>
          <Typography variant="body1" sx={{ color: '#666' }}>
            Visualiza las órdenes de trabajo{riskLevelFilter ? ` con riesgo "${riskLevelFilter.charAt(0).toUpperCase() + riskLevelFilter.slice(1)}"` : ''} asignadas a ti y accede al documento PIPC correspondiente.
          </Typography>
        </Box>
        <IconButton
          onClick={fetchWorkOrders}
          disabled={loading}
          sx={{ 
            bgcolor: 'primary.main',
            color: 'white',
            boxShadow: 2,
            '&:hover': {
              bgcolor: 'primary.dark',
              transform: 'rotate(180deg)',
              transition: 'all 0.3s ease-in-out'
            },
            '&:disabled': {
              bgcolor: '#ccc',
              color: '#666'
            }
          }}
        >
          <RefreshIcon />
        </IconButton>
      </Box>

      {OFFLINE_FIELD_MODE && <AsyncInspectionsPanel candidates={asyncAssignCandidates} />}

      {/* Selector de Nivel de Riesgo */}
      <Box sx={{ mb: 2, display: 'flex', alignItems: 'center', gap: 2 }}>
        <Typography variant="body2" sx={{ fontWeight: 600, color: '#555' }}>Nivel de Riesgo:</Typography>
        <ToggleButtonGroup
          value={riskLevelFilter}
          exclusive
          onChange={(e, newValue) => setRiskLevelFilter(newValue || '')}
          size="small"
          sx={{
            '& .MuiToggleButton-root': {
              textTransform: 'none',
              fontWeight: 600,
              px: 2,
              '&.Mui-selected': { color: '#fff' }
            }
          }}
        >
          <ToggleButton value="" sx={{ '&.Mui-selected': { bgcolor: '#1976d2', '&:hover': { bgcolor: '#1565c0' } } }}>
            Todos
          </ToggleButton>
          <ToggleButton value="bajo" sx={{ '&.Mui-selected': { bgcolor: '#4caf50', '&:hover': { bgcolor: '#388e3c' } } }}>
            Bajo
          </ToggleButton>
          <ToggleButton value="medio" sx={{ '&.Mui-selected': { bgcolor: '#ff9800', '&:hover': { bgcolor: '#f57c00' } } }}>
            Medio
          </ToggleButton>
          <ToggleButton value="alto" sx={{ '&.Mui-selected': { bgcolor: '#f44336', '&:hover': { bgcolor: '#d32f2f' } } }}>
            Alto
          </ToggleButton>
        </ToggleButtonGroup>
      </Box>

      {/* Tabla de Órdenes de Trabajo */}
      <Paper elevation={3}>
        <Box p={2}>
          <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold' }}>
            Órdenes de Trabajo{riskLevelFilter ? ` - Riesgo ${riskLevelFilter.charAt(0).toUpperCase() + riskLevelFilter.slice(1)}` : ''} ({filteredWorkOrders.length})
          </Typography>
          
          {/* Filtros */}
          <Box sx={{ mb: 3, display: 'flex', gap: 2, flexWrap: 'wrap' }}>
            <TextField
              size="small"
              label="Filtrar por N° Orden"
              value={filters.orderNumber}
              onChange={(e) => handleFilterChange('orderNumber', e.target.value)}
              variant="outlined"
              sx={{ minWidth: 150 }}
            />
            <TextField
              size="small"
              label="Filtrar por Cliente"
              value={filters.cliente}
              onChange={(e) => handleFilterChange('cliente', e.target.value)}
              variant="outlined"
              sx={{ minWidth: 150 }}
            />
            <TextField
              size="small"
              label="Filtrar por Empresa"
              value={filters.empresa}
              onChange={(e) => handleFilterChange('empresa', e.target.value)}
              variant="outlined"
              sx={{ minWidth: 150 }}
            />
            <TextField
              size="small"
              label="Filtrar por Servicio"
              value={filters.servicio}
              onChange={(e) => handleFilterChange('servicio', e.target.value)}
              variant="outlined"
              sx={{ minWidth: 150 }}
            />
            <TextField
              size="small"
              label="Filtrar por Asignado a"
              value={filters.asignado}
              onChange={(e) => handleFilterChange('asignado', e.target.value)}
              variant="outlined"
              sx={{ minWidth: 150 }}
            />
            <FormControl size="small" sx={{ minWidth: 150 }}>
              <InputLabel>Estado</InputLabel>
              <Select
                value={filters.estado}
                label="Estado"
                onChange={(e) => handleFilterChange('estado', e.target.value)}
              >
                <MenuItem value="">Todos</MenuItem>
                {getAvailableStatuses().map(status => (
                  <MenuItem key={status} value={status}>
                    {formatStatus(status)}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            {/* Entes cuya fecha estimada de fin ya pasó sin terminar lo operativo */}
            <Chip
              icon={<Warning sx={{ fontSize: '16px !important' }} />}
              label={`Solo atrasados (${overdueOrderCount})`}
              color={onlyOverdue ? 'error' : 'default'}
              variant={onlyOverdue ? 'filled' : 'outlined'}
              onClick={() => setOnlyOverdue(v => !v)}
              sx={{ fontWeight: 600, alignSelf: 'center' }}
            />
          </Box>
        </Box>
        
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow sx={{ bgcolor: '#f5f5f5' }}>
                <TableCell sx={{ fontWeight: 'bold' }}>
                  <TableSortLabel
                    active={sortField === 'orderNumber'}
                    direction={sortField === 'orderNumber' ? sortDirection : 'asc'}
                    onClick={() => handleSortRequest('orderNumber')}
                  >
                    N° Orden
                  </TableSortLabel>
                </TableCell>
                <TableCell sx={{ fontWeight: 'bold' }}>
                  <TableSortLabel
                    active={sortField === 'companyName'}
                    direction={sortField === 'companyName' ? sortDirection : 'asc'}
                    onClick={() => handleSortRequest('companyName')}
                  >
                    Nombre Comercial
                  </TableSortLabel>
                </TableCell>
                <TableCell sx={{ fontWeight: 'bold' }}>Cliente</TableCell>
                <TableCell sx={{ fontWeight: 'bold' }}>Ente asignado</TableCell>
                <TableCell sx={{ fontWeight: 'bold' }}>Servicio</TableCell>
                <TableCell sx={{ fontWeight: 'bold' }}>Nivel Riesgo</TableCell>
                <TableCell sx={{ fontWeight: 'bold' }}>Estado</TableCell>
                <TableCell sx={{ fontWeight: 'bold' }}>Prioridad</TableCell>
                <TableCell sx={{ fontWeight: 'bold' }}>
                  <TableSortLabel
                    active={sortField === 'assignedTo'}
                    direction={sortField === 'assignedTo' ? sortDirection : 'asc'}
                    onClick={() => handleSortRequest('assignedTo')}
                  >
                    Asignado a
                  </TableSortLabel>
                </TableCell>
                <TableCell sx={{ fontWeight: 'bold' }}>
                  <TableSortLabel
                    active={sortField === 'scheduledDate'}
                    direction={sortField === 'scheduledDate' ? sortDirection : 'asc'}
                    onClick={() => handleSortRequest('scheduledDate')}
                  >
                    Fecha Programada
                  </TableSortLabel>
                </TableCell>
                <TableCell sx={{ fontWeight: 'bold' }}>Archivo PIPC</TableCell>
                <TableCell sx={{ fontWeight: 'bold' }}>Reporte Inspección</TableCell>
                <TableCell sx={{ fontWeight: 'bold' }}>Avance</TableCell>
                <TableCell sx={{ fontWeight: 'bold' }}>Acciones</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {sortedWorkOrders.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={14} align="center" sx={{ py: 4 }}>
                    <Typography variant="body1" color="text.secondary">
                      No se encontraron órdenes de trabajo{riskLevelFilter ? ` con riesgo ${riskLevelFilter}` : ''} asignadas a usted
                    </Typography>
                  </TableCell>
                </TableRow>
              ) : (
                sortedWorkOrders.map((workOrder) => (
                  <React.Fragment key={workOrder.id}>
                  <TableRow
                    data-workorder-id={workOrder.id}
                    hover
                    sx={{
                      ...(readinessMap[workOrder.id]?.ricReady || readinessMap[workOrder.id]?.pipcReady ? {
                        borderLeft: '3px solid #4caf50',
                        bgcolor: 'rgba(76, 175, 80, 0.04)',
                      } : {})
                    }}
                  >
                    <TableCell>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                        <Tooltip title={expandedOrders.has(workOrder.id) ? 'Ocultar el avance por ente' : 'Ver el avance por ente'}>
                          <Button size="small" variant={expandedOrders.has(workOrder.id) ? 'contained' : 'outlined'}
                            onClick={(e) => { e.stopPropagation(); toggleExpanded(workOrder.id); }}
                            startIcon={<ExpandMoreIcon sx={{ transform: expandedOrders.has(workOrder.id) ? 'rotate(180deg)' : 'none', transition: 'transform .2s' }} />}
                            sx={{ minWidth: 0, px: 1, py: 0.25, mr: 0.5, textTransform: 'none', fontWeight: 700, fontSize: '0.72rem',
                              borderRadius: 2, whiteSpace: 'nowrap', lineHeight: 1.4 }}>
                            {(progressEntities[workOrder.quotationId] || workOrderEntityMap[workOrder.id] || []).length || ''} {
                              (progressEntities[workOrder.quotationId] || workOrderEntityMap[workOrder.id] || []).length === 1 ? 'ente' : 'entes'}
                          </Button>
                        </Tooltip>
                        <Box>
                          <Tooltip title="Abrir la orden de trabajo">
                            <Typography variant="body2" onClick={(e) => goToWorkOrder(e, workOrder)}
                              sx={{ fontWeight: 'bold', color: '#1976d2', ...linkSx }}>
                              {workOrder.orderNumber || workOrder.order_number || `OT-${localTodayIso().replace(/-/g, '')}-${String(workOrder.id).padStart(4, '0')}`}
                            </Typography>
                          </Tooltip>
                          {workOrder.quotationId && (
                            <Tooltip title="Ver el PDF de la cotización">
                              <Typography variant="caption" display="block" onClick={(e) => openQuotationPdf(e, workOrder)}
                                sx={{ color: '#5c6bc0', whiteSpace: 'nowrap', ...linkSx }}>
                                {workOrder.quotationFolio || `Cotización #${workOrder.quotationId}`}
                              </Typography>
                            </Tooltip>
                          )}
                        </Box>
                      </Box>
                    </TableCell>
                    <TableCell>
                      {workOrder.companyId ? (
                        <Tooltip title="Abrir la empresa">
                          <Typography variant="body2" onClick={(e) => goToCompany(e, workOrder)} sx={{ color: '#1976d2', ...linkSx }}>
                            {workOrder.companyName || 'N/A'}
                          </Typography>
                        </Tooltip>
                      ) : (workOrder.companyName || 'N/A')}
                    </TableCell>
                    <TableCell>
                      <Typography variant="body2" fontWeight="medium">
                        {workOrder.clientName || 'N/A'}
                      </Typography>
                      <Typography variant="caption" color="textSecondary" display="block">
                        {workOrder.clientEmail || ''}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      {(workOrderEntityMap[workOrder.id] || []).length > 0 ? (
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                          {(workOrderEntityMap[workOrder.id] || []).slice(0, 2).map((entity) => {
                            const isMatriz = entity.type === 'MATRIZ';
                            const displayName = isMatriz ? entity.name.replace(/\s*\(Matriz\)\s*$/i, '') : entity.name;
                            return (
                              <Box key={`${workOrder.id}-${entity.name}`} sx={{ display: 'flex', alignItems: 'center', gap: 0.3 }}>
                                <Tooltip title={isMatriz ? 'Abrir la matriz (empresa)' : 'Abrir la sucursal'}>
                                  <Chip
                                    onClick={(e) => goToEntity(e, workOrder, entity)}
                                    icon={isMatriz
                                      ? <AccountBalanceIcon sx={{ fontSize: '14px !important' }} />
                                      : <StoreIcon sx={{ fontSize: '14px !important' }} />}
                                    label={displayName}
                                    size="small"
                                    sx={{
                                      bgcolor: isMatriz ? '#ede7f6' : '#e1f5fe',
                                      color: isMatriz ? '#4527a0' : '#01579b',
                                      fontWeight: 600, fontSize: '0.7rem', height: 22, maxWidth: 190,
                                      justifyContent: 'flex-start',
                                      '& .MuiChip-label': { overflow: 'hidden', textOverflow: 'ellipsis' },
                                    }}
                                  />
                                </Tooltip>
                              </Box>
                            );
                          })}
                          {(workOrderEntityMap[workOrder.id] || []).length > 2 && (
                            <Typography variant="caption" color="text.secondary">
                              +{(workOrderEntityMap[workOrder.id] || []).length - 2} más
                            </Typography>
                          )}
                        </Box>
                      ) : !entitiesLoaded ? (
                        <Skeleton variant="text" width={110} />
                      ) : (
                        <Typography variant="caption" color="text.secondary">Sin ente asignado</Typography>
                      )}
                    </TableCell>
                    <TableCell>
                      <Typography variant="body2" sx={{ fontSize: '0.85rem' }}>
                        {workOrder.serviceType || 'N/A'}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Chip
                        label={workOrder.riskLevel || 'N/A'}
                        size="small"
                        sx={{
                          fontWeight: 600,
                          bgcolor: workOrder.riskLevel?.toLowerCase() === 'bajo' || workOrder.riskLevel?.toLowerCase() === 'low' ? '#e8f5e9' :
                                   workOrder.riskLevel?.toLowerCase() === 'medio' || workOrder.riskLevel?.toLowerCase() === 'medium' ? '#fff3e0' :
                                   workOrder.riskLevel?.toLowerCase() === 'alto' || workOrder.riskLevel?.toLowerCase() === 'high' ? '#ffebee' : '#f5f5f5',
                          color: workOrder.riskLevel?.toLowerCase() === 'bajo' || workOrder.riskLevel?.toLowerCase() === 'low' ? '#2e7d32' :
                                 workOrder.riskLevel?.toLowerCase() === 'medio' || workOrder.riskLevel?.toLowerCase() === 'medium' ? '#e65100' :
                                 workOrder.riskLevel?.toLowerCase() === 'alto' || workOrder.riskLevel?.toLowerCase() === 'high' ? '#c62828' : '#666',
                        }}
                      />
                    </TableCell>
                    <TableCell>
                      <Chip
                        label={formatStatus(workOrder.status)}
                        color={
                          workOrder.status === 'COMPLETADA' ? 'success' :
                          workOrder.status === 'LISTA_PARA_REVISION' ? 'secondary' :
                          workOrder.status === 'EN_PROGRESO' ? 'primary' :
                          workOrder.status === 'PROGRAMADA' ? 'info' :
                          workOrder.status === 'PENDIENTE' ? 'warning' :
                          'default'
                        }
                        size="small"
                        variant="outlined"
                      />
                      {/* Estado del WorkOrder (arriba) es distinto de si ya se inició el Programa
                          (PipRelated) -- esto último gatea Evaluación/Validar/Generar RIC-PIPC-
                          Constancias en el menú de acciones, por eso se muestra aquí explícito. */}
                      {pipStatusLoaded && (
                        <Typography
                          variant="caption"
                          display="block"
                          sx={{ mt: 0.5, fontWeight: 600, color: pipStatus[workOrder.quotationId] ? '#2e7d32' : '#9e9e9e' }}
                        >
                          {pipStatus[workOrder.quotationId] ? '✓ Programa iniciado' : 'Programa sin iniciar'}
                        </Typography>
                      )}
                    </TableCell>
                    <TableCell>
                      <Chip
                        label={workOrder.priority || 'MEDIA'}
                        color={
                          workOrder.priority === 'URGENTE' ? 'error' :
                          workOrder.priority === 'ALTA' ? 'warning' :
                          workOrder.priority === 'MEDIA' ? 'info' :
                          'success'
                        }
                        size="small"
                      />
                    </TableCell>
                    <TableCell>
                      {(progressEntities[workOrder.quotationId] || []).length > 0 ? (
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.75, minWidth: 220 }}>
                          {progressEntities[workOrder.quotationId].map((e) => {
                            const r = readinessForEnte(workOrder.quotationId, e.branchId);
                            const overdue = isEnteOverdue(e);
                            return (
                              <Box key={e.workOrderDetailId}>
                                <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 0.5, flexWrap: 'wrap' }}>
                                  <Typography variant="caption" sx={{ fontWeight: 700, color: '#1e293b' }}>
                                    {(e.entityName || '').replace(/\s*\(Matriz\)\s*$/i, '')}:
                                  </Typography>
                                  <Typography variant="caption"
                                    onClick={isAdmin && e.assignedUserId ? (ev) => goToUser(ev, e.assignedUserId) : undefined}
                                    sx={{ color: e.assignedUserName ? '#1976d2' : '#94a3b8', fontWeight: e.assignedUserName ? 600 : 400,
                                      ...(isAdmin && e.assignedUserId ? linkSx : {}) }}>
                                    {e.assignedUserName || 'Sin asignar'}
                                  </Typography>
                                  {overdue && <Typography variant="caption" sx={{ color: '#c62828', fontWeight: 700 }}>⚠ Atrasado</Typography>}
                                </Box>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
                                  <LinearProgress variant="determinate" value={e.percentage ?? 0}
                                    sx={{ width: 70, height: 5, borderRadius: 3, bgcolor: '#eceff1', '& .MuiLinearProgress-bar': { bgcolor: progressColor(e.percentage ?? 0) } }} />
                                  <Typography variant="caption" color="text.secondary">
                                    {e.completedCount}/{e.totalCount}
                                    {r && ` · Campos ${r.pipcReady ? '✓' : `${r.pipcPercentage ?? 0}%`} · Docs ${r.docsUploaded ?? 0}/${r.docsRequired ?? 0}`}
                                  </Typography>
                                </Box>
                              </Box>
                            );
                          })}
                        </Box>
                      ) : (workOrderAssignmentDetailsMap[workOrder.id] || []).length > 0 ? (
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                          {(workOrderAssignmentDetailsMap[workOrder.id] || []).map((d, i) => (
                            <Box key={`${d.entityName}-${i}`} sx={{ display: 'flex', alignItems: 'baseline', gap: 0.5, flexWrap: 'wrap' }}>
                              <Typography variant="caption" sx={{ fontWeight: 700, color: '#1e293b' }}>
                                {d.entityName.replace(/\s*\(Matriz\)\s*$/i, '')}:
                              </Typography>
                              <Typography variant="caption" sx={{
                                color: d.assignedInspector ? '#1976d2' : '#94a3b8',
                                fontWeight: d.assignedInspector ? 600 : 400
                              }}>
                                {d.assignedInspector || 'Sin asignar'}
                              </Typography>
                            </Box>
                          ))}
                        </Box>
                      ) : !entitiesLoaded ? (
                        <Skeleton variant="text" width={90} />
                      ) : (
                        <Typography variant="caption" color="text.secondary">Sin asignar</Typography>
                      )}
                    </TableCell>
                    <TableCell>
                      <Typography variant="body2" color="textSecondary">
                        {workOrder.scheduledDate ?
                          formatDate(workOrder.scheduledDate) :
                          'Sin programar'
                        }
                      </Typography>
                      {workOrder.scheduledTimeStart && (
                        <Typography variant="caption" color="textSecondary" display="block">
                          {workOrder.scheduledTimeStart}
                        </Typography>
                      )}
                    </TableCell>
                    <TableCell align="center">
                      {(() => {
                        const pipcDocs = getEntityDocs(workOrder, 'pipc');
                        return pipcDocs.length > 0 ? (
                          <Tooltip title={
                            pipcDocs.length === 1
                              ? (pipcDocs[0].filename || 'PIPC')
                              : `${pipcDocs.length} entes — clic para elegir`
                          } arrow>
                            <Chip
                              icon={<Download sx={{ fontSize: '16px !important' }} />}
                              label={pipcDocs.length > 1 ? `Descargar (${pipcDocs.length})` : 'Descargar'}
                              size="small"
                              onClick={(e) => handleDocChipClick(e, pipcDocs, 'PIPC')}
                              sx={{
                                bgcolor: '#e3f2fd', color: '#0d47a1', fontWeight: 700, cursor: 'pointer',
                                '&:hover': { bgcolor: '#bbdefb' },
                              }}
                            />
                          </Tooltip>
                        ) : (
                          <Typography variant="caption" color="text.secondary">
                            No generado
                          </Typography>
                        );
                      })()}
                    </TableCell>
                    <TableCell align="center">
                      {(() => {
                        const reportDocs = getEntityDocs(workOrder, 'report');
                        return reportDocs.length > 0 ? (
                          <Tooltip title={
                            reportDocs.length === 1
                              ? (reportDocs[0].filename || 'Reporte de Inspección')
                              : `${reportDocs.length} entes — clic para elegir`
                          } arrow>
                            <Chip
                              icon={<Download sx={{ fontSize: '16px !important' }} />}
                              label={reportDocs.length > 1 ? `Descargar (${reportDocs.length})` : 'Descargar'}
                              size="small"
                              onClick={(e) => handleDocChipClick(e, reportDocs, 'Reporte de Inspección')}
                              sx={{
                                bgcolor: '#e8f5e9', color: '#2e7d32', fontWeight: 700, cursor: 'pointer',
                                '&:hover': { bgcolor: '#c8e6c9' },
                              }}
                            />
                          </Tooltip>
                        ) : (
                          <Typography variant="caption" color="text.secondary">
                            No generado
                          </Typography>
                        );
                      })()}
                    </TableCell>
                    <TableCell sx={{ minWidth: 190 }}>
                      {!workOrder.quotationId ? (
                        <Typography variant="caption" color="text.secondary">N/A</Typography>
                      ) : !pipStatusLoaded ? (
                        <Skeleton variant="rounded" width={160} height={48} />
                      ) : (() => {
                        // Dos preguntas distintas, cada una con su propia línea:
                        // 1) ¿Ya se hizo el trabajo de campo? (asignado, UIPC, evaluación)
                        // 2) ¿Ya se puede generar el PIPC? (campos requeridos + documentos por ente)
                        const general = progressData[workOrder.quotationId] || {};
                        const pct = general.percentage ?? 0;
                        const completed = general.completedCount ?? 0;
                        const total = general.totalCount ?? 3;
                        const readiness = readinessData[workOrder.quotationId];
                        const missing = readiness && !readiness.ready
                          ? [readiness.pipcReadyCount < readiness.total && 'campos', readiness.docsReadyCount < readiness.total && 'documentos'].filter(Boolean)
                          : [];
                        const openDetail = (e) => {
                          e.stopPropagation();
                          setSelectedWorkOrderForProgress(workOrder);
                          setProgressDialogOpen(true);
                        };
                        return (
                          <Tooltip arrow title="Ver detalle del avance">
                            <Box onClick={openDetail} sx={{
                              cursor: 'pointer', p: 1, borderRadius: 1.5, border: '1px solid #e3e8f0', bgcolor: '#fff',
                              display: 'flex', flexDirection: 'column', gap: 0.75, '&:hover': { borderColor: '#90caf9', bgcolor: '#f8fbff' },
                            }}>
                              <Box>
                                <Box sx={{ display: 'flex', justifyContent: 'space-between', gap: 1 }}>
                                  <Typography variant="caption" sx={{ fontWeight: 700, color: '#37474f' }}>Trabajo de campo</Typography>
                                  <Typography variant="caption" sx={{ fontWeight: 700, color: progressColor(pct) }}>{completed}/{total}</Typography>
                                </Box>
                                <LinearProgress variant="determinate" value={pct}
                                  sx={{ height: 6, borderRadius: 3, bgcolor: '#eceff1', '& .MuiLinearProgress-bar': { bgcolor: progressColor(pct) } }} />
                              </Box>
                              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 1 }}>
                                <Typography variant="caption" sx={{ fontWeight: 700, color: '#37474f' }}>PIPC</Typography>
                                {readiness === undefined ? (
                                  <Skeleton variant="text" width={90} />
                                ) : !readiness || readiness.total === 0 ? (
                                  <Typography variant="caption" color="text.secondary">—</Typography>
                                ) : readiness.ready ? (
                                  <Typography variant="caption" sx={{ fontWeight: 700, color: '#2e7d32' }}>✓ Listo para generar</Typography>
                                ) : (
                                  <Typography variant="caption" sx={{ fontWeight: 700, color: '#e65100', textAlign: 'right' }}>
                                    {readiness.readyCount}/{readiness.total} entes listos · faltan {missing.join(' y ')}
                                  </Typography>
                                )}
                              </Box>
                            </Box>
                          </Tooltip>
                        );
                      })()}
                    </TableCell>
                    <TableCell align="center">
                      <Box display="flex" alignItems="center" justifyContent="center" gap={1}>
                        {/* Notas: 1 chip compacto con badge de cantidad (OT + 1 por ente) en vez
                            de un chip por nota -- antes se envolvía y desordenaba la columna con
                            4-5 chips truncados. Al hacer clic despliega el detalle en un menú. */}
                        <Tooltip title="Notas" arrow>
                          <Chip
                            icon={<StickyNote2Icon sx={{ fontSize: '14px !important' }} />}
                            label={`Notas (${1 + (workOrderEntityMap[workOrder.id] || []).filter((entity) => entity.detailId).length})`}
                            size="small"
                            onClick={(e) => handleOpenNotesMenu(e, workOrder)}
                            sx={{
                              bgcolor: '#fff3e0', color: '#e65100', fontWeight: 700, cursor: 'pointer',
                              '&:hover': { bgcolor: '#ffe0b2' },
                            }}
                          />
                        </Tooltip>

                        {/* Captura UIPC -- entrada directa al diálogo de UIPC, sin pasar por
                            "Editar PIPC" completo. */}
                        <Tooltip title="Captura UIPC" arrow>
                          <IconButton
                            size="small"
                            onClick={(e) => {
                              e.stopPropagation();
                              handleOpenUipcCapture(workOrder);
                            }}
                            sx={{
                              color: '#1976d2',
                              '&:hover': { bgcolor: 'rgba(25, 118, 210, 0.08)' }
                            }}
                          >
                            <PeopleIcon fontSize="small" />
                          </IconButton>
                        </Tooltip>

                        {/* Botón de acción principal */}
                        {pipStatusLoaded && !pipStatus[workOrder.quotationId] && canEditBasePip ? (
                          <Tooltip 
                            title={
                              workOrder.status === 'COMPLETADA' 
                                ? "No se puede iniciar PIPC en órdenes completadas"
                                : workOrder.status === 'CANCELADA'
                                ? "No se puede iniciar PIPC en órdenes canceladas"
                                : !workOrder.scheduledDate
                                ? "Debe programar la fecha antes de iniciar el PIPC"
                                : "Iniciar PIPC"
                            } 
                            arrow
                          >
                            <span>
                              <IconButton
                                size="small"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleIniciarPIP(workOrder);
                                }}
                                disabled={
                                  !workOrder.scheduledDate || 
                                  workOrder.status === 'COMPLETADA' || 
                                  workOrder.status === 'CANCELADA'
                                }
                                sx={{
                                  color: (!workOrder.scheduledDate || workOrder.status === 'COMPLETADA' || workOrder.status === 'CANCELADA') ? '#bdbdbd' : '#4caf50',
                                  '&:hover': {
                                    bgcolor: 'rgba(76, 175, 80, 0.08)',
                                    color: '#388e3c'
                                  },
                                  '&:disabled': {
                                    color: '#bdbdbd',
                                    cursor: 'not-allowed'
                                  }
                                }}
                              >
                                <PlayArrow />
                              </IconButton>
                            </span>
                          </Tooltip>
                        ) : (progressEntities[workOrder.quotationId] || []).length > 0 ? (
                          <Tooltip title="Las acciones están en cada ente: expande la orden (botón de entes)">
                            <IconButton size="small" onClick={(e) => { e.stopPropagation(); toggleExpanded(workOrder.id); }}
                              sx={{ color: '#1565c0', '&:hover': { bgcolor: 'rgba(21, 101, 192, 0.08)' } }}>
                              <ExpandMoreIcon />
                            </IconButton>
                          </Tooltip>
                        ) : (
                          <IconButton
                            size="small"
                            onClick={(e) => handleOpenMenu(e, workOrder)}
                            sx={{
                              color: '#666',
                              '&:hover': { bgcolor: 'rgba(0, 0, 0, 0.04)' }
                            }}
                          >
                            <MoreVert />
                          </IconButton>
                        )}
                      </Box>
                    </TableCell>
                  </TableRow>
                  {expandedOrders.has(workOrder.id) && (() => {
                    const entes = progressEntities[workOrder.quotationId] || [];
                    const check = (ok) => (ok
                      ? <CheckCircle sx={{ fontSize: 18, color: '#2e7d32' }} />
                      : <RadioButtonUnchecked sx={{ fontSize: 18, color: '#bdbdbd' }} />);
                    return (
                      <TableRow>
                        <TableCell colSpan={14} sx={{ bgcolor: '#f8fafc', py: 1.5 }}>
                          {entes.length === 0 ? (
                            <Typography variant="caption" color="text.secondary">Sin entes visibles para esta orden.</Typography>
                          ) : (
                            <Table size="small" sx={{ bgcolor: '#fff', border: '1px solid #e3e8f0', borderRadius: 1 }}>
                              <TableHead>
                                <TableRow>
                                  {['Ente', 'Ejecutivo', 'Programado', 'Fin estimado', 'UIPC', 'Evaluación', 'Operativo', 'Campos PIPC', 'Documentos', 'Estado', 'Acciones'].map(h => (
                                    <TableCell key={h} sx={{ fontWeight: 700, fontSize: '0.75rem', color: '#546e7a' }}>{h}</TableCell>
                                  ))}
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {entes.map((e) => {
                                  const r = readinessForEnte(workOrder.quotationId, e.branchId);
                                  const overdue = isEnteOverdue(e);
                                  const ready = r && r.pipcReady && r.docsReady;
                                  const status = ready ? { label: 'Listo para generar', color: '#2e7d32', bg: '#e8f5e9' }
                                    : overdue ? { label: 'Atrasado', color: '#c62828', bg: '#ffebee' }
                                    : (e.percentage ?? 0) >= 100 ? { label: 'Falta documentación', color: '#e65100', bg: '#fff3e0' }
                                    : { label: 'En proceso', color: '#1565c0', bg: '#e3f2fd' };
                                  return (
                                    <TableRow key={e.workOrderDetailId}>
                                      <TableCell sx={{ fontWeight: 600 }}>
                                        <Typography variant="body2" component="span" sx={{ fontWeight: 600, ...linkSx }}
                                          onClick={(ev) => goToEntity(ev, workOrder, { type: e.entityType, branchId: e.branchId })}>
                                          {(e.entityName || '').replace(/\s*\(Matriz\)\s*$/i, '')}
                                        </Typography>
                                      </TableCell>
                                      <TableCell sx={{ color: e.assignedUserName ? '#1976d2' : '#94a3b8' }}>
                                        <Typography variant="body2" component="span"
                                          onClick={isAdmin && e.assignedUserId ? (ev) => goToUser(ev, e.assignedUserId) : undefined}
                                          sx={{ color: 'inherit', ...(isAdmin && e.assignedUserId ? linkSx : {}) }}>
                                          {e.assignedUserName || 'Sin asignar'}
                                        </Typography>
                                      </TableCell>
                                      <TableCell>
                                        <CellLink enabled title="Abrir la programación de este ente en la Agenda" onClick={() => goToAgenda(workOrder, e)}>
                                          {e.scheduledDate ? formatDate(e.scheduledDate) : 'Programar'}
                                        </CellLink>
                                      </TableCell>
                                      <TableCell sx={{ color: overdue ? '#c62828' : undefined, fontWeight: overdue ? 700 : 400 }}>
                                        <CellLink enabled title="Abrir la programación de este ente en la Agenda" onClick={() => goToAgenda(workOrder, e)}>
                                          {e.estimatedCompletionDate ? formatDate(e.estimatedCompletionDate) : '—'}
                                        </CellLink>
                                      </TableCell>
                                      <TableCell>
                                        <CellLink enabled={canEditBasePip || canEditUipcByEntity} title="Capturar la UIPC"
                                          onClick={() => handleOpenUipcCapture(workOrder)}>
                                          {check(e.uipc)}
                                        </CellLink>
                                      </TableCell>
                                      <TableCell>
                                        <CellLink enabled={!!pipStatus[workOrder.quotationId]} title="Abrir la evaluación de inspección"
                                          onClick={() => goToEvaluation(workOrder)}>
                                          {check(e.evaluacion)}
                                        </CellLink>
                                      </TableCell>
                                      <TableCell sx={{ minWidth: 110 }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                          <LinearProgress variant="determinate" value={e.percentage ?? 0}
                                            sx={{ flexGrow: 1, height: 6, borderRadius: 3, bgcolor: '#eceff1', '& .MuiLinearProgress-bar': { bgcolor: progressColor(e.percentage ?? 0) } }} />
                                          <Typography variant="caption" sx={{ fontWeight: 700 }}>{e.completedCount}/{e.totalCount}</Typography>
                                        </Box>
                                      </TableCell>
                                      <TableCell>
                                        {r ? (
                                          <CellLink enabled={!!pipStatus[workOrder.quotationId]} title="Ver qué campos faltan (Validar Campos)"
                                            onClick={() => handleValidateFields(workOrder)}>
                                            {r.pipcReady ? check(true) : `${r.pipcPercentage ?? 0}%`}
                                          </CellLink>
                                        ) : <Skeleton width={30} />}
                                      </TableCell>
                                      <TableCell>
                                        {r ? (
                                          <CellLink enabled title="Subir o revisar los documentos de este ente" onClick={() => handleOpenUploadDialog(workOrder,
                                            e.branchId ? { id: e.branchId, branchName: e.entityName, companyId: workOrder.companyId } : null)}>
                                            {`${r.docsUploaded ?? 0}/${r.docsRequired ?? 0}`}
                                          </CellLink>
                                        ) : <Skeleton width={40} />}
                                      </TableCell>
                                      <TableCell>
                                        <Chip size="small" label={status.label} sx={{ fontWeight: 700, fontSize: '0.7rem', color: status.color, bgcolor: status.bg }} />
                                      </TableCell>
                                      <TableCell align="center">
                                        <Tooltip title={`Acciones de ${(e.entityName || '').replace(/\s*\(Matriz\)\s*$/i, '')}`}>
                                          <IconButton size="small" onClick={(ev) => { ev.stopPropagation(); handleOpenMenu(ev, workOrder, String(e.branchId ?? 'MATRIZ')); }}
                                            sx={{ color: '#455a64', '&:hover': { bgcolor: 'rgba(0, 0, 0, 0.06)' } }}>
                                            <MoreVert />
                                          </IconButton>
                                        </Tooltip>
                                      </TableCell>
                                    </TableRow>
                                  );
                                })}
                              </TableBody>
                            </Table>
                          )}
                        </TableCell>
                      </TableRow>
                    );
                  })()}
                  </React.Fragment>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>

      {/* PIP Dialog */}
      <Dialog 
        open={pipDialogOpen} 
        onClose={() => { setPipDialogOpen(false); setPipActiveTab(0); setCartaReturnWorkOrder(null); refreshWorkOrderRow(selectedWorkOrder); }}
        maxWidth="lg"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 3,
            boxShadow: '0 20px 40px rgba(0,0,0,0.15)'
          }
        }}
      >
        <DialogTitle sx={{ 
          background: 'linear-gradient(135deg, #1976d2 0%, #1565c0 100%)',
          color: 'white',
          fontWeight: 'bold',
          fontSize: '1.3rem',
          p: 3,
          display: 'flex',
          alignItems: 'center',
          gap: 2,
          '&::before': {
            content: '"📋"',
            fontSize: '1.5em'
          }
        }}>
          {pipFormData.id ? 'Editar' : 'Iniciar'} PIPC - {selectedWorkOrder?.companyName || selectedWorkOrder?.clientName}
        </DialogTitle>
        <DialogContent
          dividers
          sx={{
            p: 0,
            maxHeight: '78vh',
            overflowY: 'auto',
            '&::-webkit-scrollbar': { width: '6px' },
            '&::-webkit-scrollbar-track': { background: '#f1f1f1' },
            '&::-webkit-scrollbar-thumb': { background: '#bbb', borderRadius: '4px' },
            '&::-webkit-scrollbar-thumb:hover': { background: '#888' },
          }}
        >
          {/* Resumen de la OT: una línea compacta; el detalle (tarjetas) se despliega a pedido */}
          <Box sx={{ px: 3, py: 1.25, backgroundColor: '#f0f4ff', borderBottom: '2px solid #c7d7fd' }}>
            <Box onClick={() => setPipHeaderExpanded(v => !v)}
              sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap', cursor: 'pointer' }}>
              <Typography variant="body2" sx={{ fontWeight: 700, color: '#1976d2' }}>
                {selectedWorkOrder?.orderNumber || `OT-${String(selectedWorkOrder?.id || 0).padStart(4,'0')}`}
              </Typography>
              <Typography variant="body2" color="text.secondary">·</Typography>
              <Typography variant="body2" sx={{ fontWeight: 600 }}>{selectedWorkOrder?.companyName || selectedWorkOrder?.clientName || 'N/A'}</Typography>
              <Typography variant="body2" color="text.secondary">·</Typography>
              <Typography variant="body2" sx={{ color: selectedWorkOrder?.scheduledDate ? '#2e7d32' : '#e65100', fontWeight: 600 }}>
                {selectedWorkOrder?.scheduledDate ? formatDate(selectedWorkOrder.scheduledDate) : 'Sin programar'}
              </Typography>
              <Typography variant="body2" color="text.secondary">·</Typography>
              <Typography variant="body2" sx={{ fontWeight: 600 }}>Riesgo {selectedWorkOrder?.riskLevel || 'N/D'}</Typography>
              <Typography variant="body2" color="text.secondary" sx={{ display: { xs: 'none', md: 'inline' } }}>·</Typography>
              <Typography variant="body2" noWrap sx={{ color: '#1565c0', maxWidth: 360, display: { xs: 'none', md: 'inline' } }}>
                {selectedWorkOrder?.serviceType || ''}
              </Typography>
              <Box sx={{ flexGrow: 1 }} />
              <Typography variant="caption" sx={{ color: '#1976d2', fontWeight: 600, whiteSpace: 'nowrap' }}>
                {pipHeaderExpanded ? 'Ocultar detalle ▲' : 'Ver detalle ▼'}
              </Typography>
            </Box>
            <Collapse in={pipHeaderExpanded}>
            <Box sx={{
              mt: 1.5,
              display: 'grid',
              gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr', md: '1fr 1.1fr 1.2fr 0.8fr 1.8fr 1.6fr' },
              gap: 1.5,
            }}>
              <Box sx={{ minWidth: 0, p: 1.5, backgroundColor: '#fff', borderRadius: 2, border: '1px solid #dbe4ff', textAlign: 'center' }}>
                <Typography variant="caption" color="text.secondary" display="block">N° Orden</Typography>
                <Typography variant="body2" sx={{ fontWeight: 700, color: '#1976d2' }}>
                  {selectedWorkOrder?.orderNumber || `OT-${String(selectedWorkOrder?.id || 0).padStart(4,'0')}`}
                </Typography>
              </Box>
              <Box sx={{ minWidth: 0, p: 1.5, backgroundColor: '#fff', borderRadius: 2, border: '1px solid #dbe4ff', textAlign: 'center' }}>
                <Typography variant="caption" color="text.secondary" display="block">Empresa</Typography>
                <Typography variant="body2" sx={{ fontWeight: 700, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                  {selectedWorkOrder?.companyName || selectedWorkOrder?.clientName || 'N/A'}
                </Typography>
              </Box>
              <Box sx={{ minWidth: 0, p: 1.5, backgroundColor: '#fff', borderRadius: 2, border: '1px solid #dbe4ff', textAlign: 'center' }}>
                <Typography variant="caption" color="text.secondary" display="block">Fecha Programada</Typography>
                <Typography variant="body2" sx={{ fontWeight: 700, color: selectedWorkOrder?.scheduledDate ? '#2e7d32' : '#e65100' }}>
                  {selectedWorkOrder?.scheduledDate
                    ? formatDate(selectedWorkOrder.scheduledDate)
                    : 'Sin programar'}
                </Typography>
              </Box>
              <Box sx={{ minWidth: 0, p: 1.5, backgroundColor: '#fff', borderRadius: 2, border: '1px solid #dbe4ff', textAlign: 'center' }}>
                <Typography variant="caption" color="text.secondary" display="block">Nivel de Riesgo</Typography>
                <Chip
                  label={selectedWorkOrder?.riskLevel || 'N/D'}
                  size="small"
                  sx={{
                    mt: 0.3, fontWeight: 700,
                    backgroundColor: selectedWorkOrder?.riskLevel?.toLowerCase().includes('alto') ? '#fdecea' : selectedWorkOrder?.riskLevel?.toLowerCase().includes('medio') ? '#fff8e1' : '#e8f5e9',
                    color: selectedWorkOrder?.riskLevel?.toLowerCase().includes('alto') ? '#c62828' : selectedWorkOrder?.riskLevel?.toLowerCase().includes('medio') ? '#e65100' : '#2e7d32',
                  }}
                />
              </Box>
              <Box sx={{ minWidth: 0, p: 1.5, backgroundColor: '#fff', borderRadius: 2, border: '1px solid #dbe4ff' }}>
                <Typography variant="caption" color="text.secondary" display="block">Entes y ejecutivo asignado</Typography>
                {workOrderSchedules.length === 0 ? (
                  <Typography variant="caption" sx={{ fontWeight: 600, color: '#6a1b9a' }}>
                    Sin entes activos programados
                  </Typography>
                ) : (
                  <Box sx={{ mt: 0.4, maxHeight: 92, overflowY: 'auto' }}>
                    {workOrderSchedules.map((schedule) => {
                        const assignedLabel =
                          schedule.assignedInspector ||
                          schedule.assignedUserName ||
                          schedule.assignedUserFullName ||
                          schedule.assignedTo ||
                          schedule.assignedUser?.fullName ||
                          schedule.assignedUser?.name ||
                          (schedule.assignedUserId ? `Usuario #${schedule.assignedUserId}` : 'Sin asignar');

                        return (
                          <Typography key={schedule.id} variant="caption" sx={{ display: 'block', color: '#4a148c' }}>
                            {schedule.entityName || 'Ente'}: {assignedLabel}
                          </Typography>
                        );
                      })}
                  </Box>
                )}
              </Box>
              <Box sx={{ minWidth: 0, p: 1.5, backgroundColor: '#fff', borderRadius: 2, border: '1px solid #dbe4ff' }}>
                <Typography variant="caption" color="text.secondary" display="block">Servicio</Typography>
                <Typography variant="body2" sx={{ fontWeight: 600, color: '#1565c0' }}>{selectedWorkOrder?.serviceType || 'N/A'}</Typography>
              </Box>
            </Box>
            </Collapse>
          </Box>

          {/* Barra de progreso: mide los campos requeridos reales de la pestaña activa */}
          {(() => {
            const has = (v) => v != null && v.toString().trim() !== '';
            let filled = 0;
            let reqTotal = 0;
            let unit = 'campos requeridos';
            let pending = 0;

            if (pipActiveTab === 0) {
              const values = [pipFormData.preparedBy, pipFormData.reviewedBy, pipApprovedByLegalRep,
                pipFormData.serviceScope, pipFormData.methodology, pipFormData.estimatedDuration];
              reqTotal = values.length;
              filled = values.filter(has).length;
            } else if (pipActiveTab === 1 || pipActiveTab === 2) {
              const propertyFields = ['employeesCount', 'constructionArea', 'landArea', 'constructionLevels', 'operatingHoursStart', 'operatingHoursEnd'];
              workOrderSchedules.forEach((schedule) => {
                const entry = entityPropertyData[schedule.id];
                const form = entry?.data || {};
                const isMatriz = !schedule.branchId;
                let values;
                if (pipActiveTab === 1) {
                  values = propertyFields.map(f => form[f]);
                } else {
                  const fromCompany = !isMatriz && companyInsuranceInfo.insuranceSameForBranches;
                  values = [
                    fromCompany? companyInsuranceInfo.insuranceCompany : form.insuranceCompany,
                    fromCompany ? companyInsuranceInfo.insurancePolicyNumber : form.insurancePolicyNumber,
                    fromCompany ? companyInsuranceInfo.insurancePolicyValidity : form.insurancePolicyValidity,
                  ];
                }
                reqTotal += values.length;
                if (!entry?.loaded) { pending += 1; return; }
                filled += values.filter(has).length;
              });
            } else if (pipActiveTab === 4) {
              unit = 'documentos';
              workOrderSchedules.forEach((schedule) => {
                const summary = documentsSummaryByEntity[schedule.id];
                reqTotal += totalDocsRequired;
                if (!summary?.loaded) { pending += 1; return; }
                filled += Math.min(totalDocsRequired, Math.max(0, (summary.uploadedCount || 0) - (summary.expiredCount || 0)));
              });
            }

            const pct = reqTotal > 0 ? Math.round((filled / reqTotal) * 100) : 0;
            return (
              <Box sx={{ px: 3, py: 1.5, backgroundColor: '#fafafa', borderBottom: '1px solid #e9ecef' }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
                  <Typography variant="caption" sx={{ fontWeight: 600, color: '#555' }}>Completitud del formulario</Typography>
                  <Typography variant="caption" sx={{ fontWeight: 700, color: pending > 0 ? '#757575' : pct === 100 ? '#2e7d32' : pct >= 50 ? '#e65100' : '#c62828' }}>
                    {pending > 0
                      ? `Calculando... (${pending} ente${pending === 1 ? '' : 's'} por cargar)`
                      : reqTotal === 0
                        ? 'Sin entes en esta orden'
                        : `${filled} / ${reqTotal} ${unit}${workOrderSchedules.length > 1 && pipActiveTab !== 0 ? ` en ${workOrderSchedules.length} entes` : ''} (${pct}%)`}
                  </Typography>
                </Box>
                <LinearProgress variant="determinate" value={pct} sx={{
                  height: 8, borderRadius: 4, backgroundColor: '#e0e0e0',
                  '& .MuiLinearProgress-bar': { backgroundColor: pct === 100 ? '#2e7d32' : pct >= 50 ? '#ed6c02' : '#d32f2f', borderRadius: 4 }
                }} />
              </Box>
            );
          })()}

          {/* Tabs de navegación */}
          <Box sx={{ borderBottom: '2px solid #e9ecef', backgroundColor: '#fff' }}>
            <Tabs value={pipActiveTab} onChange={(_, v) => setPipActiveTab(v)}
              sx={{ px: 2, '& .MuiTab-root': { textTransform: 'none', fontWeight: 600, minHeight: 52 }, '& .Mui-selected': { color: '#1976d2' }, '& .MuiTabs-indicator': { backgroundColor: '#1976d2', height: 3 } }}
            >
              <Tab value={0} label={
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <span>👥 Datos Generales</span>
                  {(pipFormData.preparedBy || pipFormData.reviewedBy) && <Chip label="✓" size="small" color="success" sx={{ height: 18, fontSize: '0.65rem' }} />}
                </Box>
              } />
              {(canEditBasePip || canEditUipcByEntity) && <Tab value={1} label={
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <span>🏠 Datos del Inmueble</span>
                </Box>
              } />}
              {(canEditBasePip || canEditUipcByEntity) && <Tab value={2} label={
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <span>📄 Seguro</span>
                </Box>
              } />}
              {/* UIPC ya no vive aquí -- se removió este tab porque ya existe la entrada directa
                  "Captura UIPC" fuera de esta pantalla (mismo estado, ver Dialog uipcCaptureDialogOpen). */}
              {(canEditBasePip || canEditUipcByEntity) && <Tab value={4} label={
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <span>📁 Documentos</span>
                </Box>
              } />}
            </Tabs>
          </Box>

          {/* Contenido de tabs */}
          <Box sx={{ p: 3 }}>
            {/* TAB 0: Datos Generales */}
            {pipActiveTab === 0 && (() => {
              const INK = '#1f2d3d';
              const MUTED = '#6b778c';
              const LINE = '#e3e8f0';

              const Section = ({ icon, title, subtitle, children }) => (
                <Paper variant="outlined" sx={{ borderRadius: 3, borderColor: LINE, overflow: 'hidden' }}>
                  <Box sx={{ px: 3, py: 2, display: 'flex', alignItems: 'center', gap: 1.5, borderBottom: `1px solid ${LINE}`, bgcolor: '#fafbfd' }}>
                    <Box sx={{ width: 32, height: 32, borderRadius: '8px', bgcolor: '#e8f0fe', color: '#1565c0', display: 'flex', alignItems: 'center', justifyContent: 'center', '& svg': { fontSize: 18 } }}>
                      {icon}
                    </Box>
                    <Box sx={{ minWidth: 0 }}>
                      <Typography sx={{ fontWeight: 700, color: INK, fontSize: '0.95rem', lineHeight: 1.3 }}>{title}</Typography>
                      {subtitle && <Typography variant="caption" sx={{ color: MUTED }}>{subtitle}</Typography>}
                    </Box>
                  </Box>
                  <Box sx={{ p: 3 }}>{children}</Box>
                </Paper>
              );

              const Row = ({ label, children, last }) => (
                <Box sx={{
                  display: 'grid', gridTemplateColumns: { xs: '1fr', md: '220px 1fr' }, gap: { xs: 0.5, md: 3 },
                  py: 1.75, borderBottom: last ? 'none' : `1px solid ${LINE}`,
                }}>
                  <Typography variant="body2" sx={{ color: MUTED, fontWeight: 600 }}>{label}</Typography>
                  <Box sx={{ minWidth: 0, color: INK }}>{children}</Box>
                </Box>
              );

              const NotPrinted = ({ text }) => (
                <Typography variant="caption" sx={{ color: MUTED, display: 'block', mt: 0.5 }}>{text}</Typography>
              );

              const Pending = ({ children }) => (
                <Typography variant="body2" sx={{ color: '#9aa5b1', fontStyle: 'italic' }}>{children}</Typography>
              );

              // "Aprobó" (representante legal de la empresa): Admin, Coordinador, o el Ejecutivo asignado a la
              // MATRIZ de esta OT -- misma regla que el backend (CompanyAccessGuard.canEditCompany).
              const canEditApprover = canEditBasePip || (isExecutiveRole && workOrderSchedules.some(
                (sch) => !sch?.branchId && Number(sch?.assignedUserId) === Number(currentUser?.id)));

              const signers = [
                { role: 'Elaboró', name: pipFormData.preparedBy, position: 'Tercero acreditado' },
                { role: 'Revisó', name: terceroAcreditado.reviewedBy || pipFormData.reviewedBy, position: 'Representante técnico' },
                { role: 'Aprobó', name: pipApprovedByLegalRep, position: 'Representante legal de la empresa', fromClient: true },
              ];

              return (
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2.5 }}>
                  <Alert severity="info" sx={{ borderRadius: 2, py: 0.5 }}>
                    Datos institucionales del Programa Interno de Protección Civil. Se llenan automáticamente y así aparecen en el documento.
                  </Alert>

                  <Section icon={<PeopleIcon />} title="Responsables del documento" subtitle="Firmas que aparecen en el PIPC">
                    <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: 'repeat(3, 1fr)' }, gap: 2 }}>
                      {signers.map((signer) => {
                        const missing = !signer.name;
                        return (
                          <Box key={signer.role} sx={{
                            p: 2, borderRadius: 2, minWidth: 0,
                            border: `1px solid ${missing ? '#f5c2c0' : LINE}`, bgcolor: missing ? '#fff6f5' : '#fff',
                            display: 'flex', flexDirection: 'column',
                          }}>
                            <Typography variant="overline" sx={{ color: missing ? '#c62828' : '#1565c0', fontWeight: 700, lineHeight: 1.6, letterSpacing: 1 }}>
                              {signer.role}
                            </Typography>
                            {signer.fromClient && approverDraft !== null ? (
                              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, mt: 0.5 }}>
                                <TextField size="small" autoFocus fullWidth label="Nombre del representante legal"
                                  value={approverDraft}
                                  onChange={(e) => setApproverDraft(e.target.value)}
                                  onKeyDown={(e) => { if (e.key === 'Enter') handleSaveApprover(); }}
                                  inputProps={{ maxLength: 100 }}
                                  helperText="Se guarda en la empresa y se usa en todos sus documentos" />
                                <Box sx={{ display: 'flex', gap: 1, justifyContent: 'flex-end' }}>
                                  <Button size="small" onClick={() => setApproverDraft(null)} disabled={approverSaving}
                                    sx={{ textTransform: 'none' }}>Cancelar</Button>
                                  <Button size="small" variant="contained" onClick={handleSaveApprover} disabled={approverSaving}
                                    startIcon={approverSaving ? <CircularProgress size={14} color="inherit" /> : <SaveIcon sx={{ fontSize: 16 }} />}
                                    sx={{ textTransform: 'none' }}>Guardar</Button>
                                </Box>
                              </Box>
                            ) : missing ? (
                              <Pending>Sin representante legal registrado</Pending>
                            ) : (
                              <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 0.5 }}>
                                <Typography variant="body2" sx={{ fontWeight: 700, color: INK, wordBreak: 'break-word', flex: 1 }}>{signer.name}</Typography>
                                {signer.fromClient && canEditApprover && selectedWorkOrder?.companyId && (
                                  <Tooltip title="Corregir representante legal">
                                    <IconButton size="small" onClick={() => setApproverDraft(signer.name)} sx={{ mt: -0.5 }}>
                                      <Edit sx={{ fontSize: 16 }} />
                                    </IconButton>
                                  </Tooltip>
                                )}
                              </Box>
                            )}
                            <Box sx={{ mt: 'auto', pt: 1.5, borderTop: `1px dashed ${LINE}` }}>
                              <Typography variant="caption" sx={{ color: MUTED }}>{signer.position}</Typography>
                            </Box>
                            {missing && signer.fromClient && canEditApprover && approverDraft === null && selectedWorkOrder?.companyId && (
                              <Button size="small" variant="outlined" color="error" startIcon={<Edit sx={{ fontSize: 16 }} />}
                                sx={{ mt: 1.5, textTransform: 'none', alignSelf: 'flex-start' }}
                                onClick={() => setApproverDraft('')}>
                                Capturar representante legal
                              </Button>
                            )}
                            {missing && signer.fromClient && !canEditApprover && selectedWorkOrder?.companyId && (
                              <Button size="small" variant="outlined" color="error" startIcon={<Edit sx={{ fontSize: 16 }} />}
                                sx={{ mt: 1.5, textTransform: 'none', alignSelf: 'flex-start' }}
                                onClick={() => navigate('/clientes/empresas', { state: { highlightEntityId: selectedWorkOrder.companyId, entityType: 'MATRIZ' } })}>
                                Capturar en Catálogo de Empresas
                              </Button>
                            )}
                          </Box>
                        );
                      })}
                    </Box>
                  </Section>

                  <Section icon={<Assignment />} title="Alcance del servicio">
                    <Row label="Alcance del estudio">
                      {pipFormData.serviceScope
                        ? <Typography variant="body2" sx={{ lineHeight: 1.7 }}>{pipFormData.serviceScope}</Typography>
                        : <Pending>Sin definir</Pending>}
                      <NotPrinted text="Solo aparece en el PIPC de riesgo medio." />
                    </Row>
                    <Row label="Metodología">
                      {pipFormData.methodology
                        ? <Typography variant="body2" sx={{ lineHeight: 1.7 }}>{pipFormData.methodology}</Typography>
                        : <Pending>Sin definir</Pending>}
                      <NotPrinted text="No aparece en el PIPC; es referencia interna." />
                    </Row>
                    <Row label="Duración estimada" last>
                      {pipFormData.estimatedDuration
                        ? <Chip size="small" icon={<AccessTimeIcon sx={{ fontSize: 16 }} />} label={pipFormData.estimatedDuration}
                            sx={{ fontWeight: 600, bgcolor: '#eef3fb', color: '#1565c0' }} />
                        : <Pending>Sin definir</Pending>}
                      <NotPrinted text="No aparece en el PIPC; es referencia interna." />
                    </Row>
                  </Section>

                  <Section icon={<VerifiedUserIcon />} title="Acreditación y folios">
                    <Row label="Tercero acreditado">
                      <Typography variant="body2" sx={{ fontWeight: 600 }}>{terceroAcreditado.thirdPartyAccredited}</Typography>
                    </Row>
                    <Row label="Número de registro">
                      <Typography variant="body2" sx={{ fontFamily: 'monospace', fontWeight: 600, letterSpacing: 0.3 }}>{terceroAcreditado.registrationNumber}</Typography>
                    </Row>
                    <Row label="Folio interno" last>
                      {selectedWorkOrder?.orderNumber || pipFormData.internalFolio ? (
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
                          <Typography variant="body2" sx={{ fontFamily: 'monospace', fontWeight: 600 }}>
                            {selectedWorkOrder?.orderNumber || pipFormData.internalFolio}
                          </Typography>
                          <Typography variant="caption" sx={{ color: MUTED }}>Número de la orden de trabajo</Typography>
                        </Box>
                      ) : <Pending>Sin orden de trabajo</Pending>}
                    </Row>
                  </Section>
                </Box>
              );
            })()}

            {/* TAB 1: Datos del Inmueble por ente */}
            {pipActiveTab === 1 && (
              <Paper sx={{ p: 3, backgroundColor: '#f8f9fa', borderRadius: 3, border: '1px solid #e9ecef' }}>
                <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: 600, color: '#495057', display: 'flex', alignItems: 'center', gap: 1 }}>
                  🏠 Datos del Inmueble por Ente
                </Typography>
                {canEditEntityPip && (
                  <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                    Confirme o corrija estos datos por cada ente, según lo encontrado en sitio. Se guardan directo en el Prospecto/Sucursal correspondiente.
                  </Typography>
                )}
                {!canEditEntityPip && (
                  <Alert severity="info" sx={{ mb: 2 }}>
                    Estos campos son editables por el Coordinador de Operaciones y el Administrador. Aquí puedes consultarlos. La sección "Carta de Corresponsabilidad" sí la puedes editar.
                  </Alert>
                )}
                {workOrderSchedules.length === 0 ? (
                  <Box sx={{ p: 3, textAlign: 'center', backgroundColor: '#fff', borderRadius: 2, border: '1px dashed #ccc' }}>
                    <Typography variant="body2" color="text.secondary">No hay entes disponibles para esta orden</Typography>
                  </Box>
                ) : (
                  workOrderSchedules.map((schedule) => {
                    const panelId3 = `inmueble-${schedule.id}`;
                    const entry = entityPropertyData[schedule.id] || {};
                    const form = entry.data || {};
                    const qEdits = entityQuotationEdits[schedule.id] || {};
                    // Sub-pestañas: una sección a la vez para que nada quede al fondo del scroll.
                    // Estado: 'missing' = falta algo que piden los documentos; 'ok' = completo;
                    // null = todavía no se carga (sin color).
                    const hasVal = (v) => v != null && String(v).trim() !== '';
                    const cartaE = cartaEdits[schedule.id] || {};
                    const enteTabs = [
                      { key: 'INSPECCION', label: 'Inspección', status: null },
                      { key: 'INMUEBLE', label: 'Inmueble',
                        status: entry.loaded ? (['employeesCount', 'constructionArea', 'landArea', 'constructionLevels'].every(f => hasVal(form[f])) ? 'ok' : 'missing') : null },
                      { key: 'HORARIOS', label: 'Horarios y actividades',
                        status: entry.loaded ? (hasVal(form.operatingHoursStart) && hasVal(form.operatingHoursEnd) ? 'ok' : 'missing') : null },
                      { key: 'CARTA', label: 'Carta',
                        status: cartaData.byDetail[schedule.id] ? (hasVal(cartaE.holderName) && hasVal(cartaE.holderTitle) ? 'ok' : 'missing') : null },
                    ];
                    const enteTab = pipEnteTab[schedule.id]
                      || (enteTabs.find(t => t.status === 'missing')?.key ?? 'INSPECCION');
                    const showTab = (key) => (enteTab === key ? 'block' : 'none');
                    return (
                      <Accordion key={schedule.id} expanded={expandedInmuebleEntity === panelId3}
                        onChange={(_, isExp) => {
                          setExpandedInmuebleEntity(isExp ? panelId3 : false);
                          if (isExp) fetchEntityPropertyData(schedule);
                        }}
                        sx={{ mb: 1.5, borderRadius: '10px !important', '&:before': { display: 'none' }, border: '1px solid #e0e0e0', boxShadow: 'none', overflow: 'hidden' }}
                      >
                        <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={{ backgroundColor: '#f5f5f5', '&.Mui-expanded': { backgroundColor: '#eef1ff' } }}>
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, width: '100%' }}>
                            {schedule.entityType === 'MATRIZ'
                              ? <AccountBalanceIcon sx={{ color: '#4527a0', fontSize: 20 }} />
                              : <StoreIcon sx={{ color: '#01579b', fontSize: 20 }} />}
                            <Typography sx={{ fontWeight: 700, color: '#263238', flexGrow: 1 }}>
                              {schedule.entityName}
                            </Typography>
                            {schedule.entityType && (
                              <Chip
                                label={schedule.entityType === 'MATRIZ' ? 'Matriz' : 'Sucursal'}
                                size="small"
                                sx={{
                                  fontSize: '0.7rem', height: 20, fontWeight: 600,
                                  bgcolor: schedule.entityType === 'MATRIZ' ? '#ede7f6' : '#e1f5fe',
                                  color: schedule.entityType === 'MATRIZ' ? '#4527a0' : '#01579b',
                                }}
                              />
                            )}
                          </Box>
                        </AccordionSummary>
                        <AccordionDetails sx={{ p: 2 }}
                          onFocusCapture={() => {
                            if (!pipEnteTab[schedule.id]) setPipEnteTab(prev => ({ ...prev, [schedule.id]: enteTab }));
                          }}>
                          <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', mb: 2 }}>
                            {enteTabs.map(t => {
                              const active = t.key === enteTab;
                              const c = t.status === 'missing' ? { main: '#e65100', bg: '#fff3e0', border: '#ffb74d' }
                                : t.status === 'ok' ? { main: '#2e7d32', bg: '#e8f5e9', border: '#81c784' }
                                : { main: '#1565c0', bg: '#f5f8ff', border: '#c5d3f0' };
                              return (
                                <Box key={t.key} onClick={() => setPipEnteTab(prev => ({ ...prev, [schedule.id]: t.key }))}
                                  sx={{ px: 1.5, py: 0.6, borderRadius: 2, cursor: 'pointer', fontWeight: 700, fontSize: '0.85rem',
                                    bgcolor: active ? c.main : c.bg, color: active ? '#fff' : c.main,
                                    border: `2px solid ${active ? c.main : c.border}`, transition: 'all 0.15s', '&:hover': { borderColor: c.main } }}>
                                  {t.label}{t.status === 'missing' ? ' •' : t.status === 'ok' ? ' ✓' : ''}
                                </Box>
                              );
                            })}
                          </Box>
                          <Box sx={!canEditEntityPip ? { pointerEvents: 'none', opacity: 0.65 } : undefined}>
                          <Box id={`inspeccion-${schedule.id}`} sx={{ display: showTab('INSPECCION') }}>
                          {/* Info de perfil-riesgo/llenar-informacion (quotation_entities) editable
                              también aquí -- se guarda con el mismo endpoint que usa el cliente, así
                              que el valor siempre corresponde sin importar quién lo edite último. */}
                          <Box sx={{
                            mb: 2.5, p: 2, borderRadius: 2, border: '1px solid #e0e0e0',
                            bgcolor: qEdits.requiresPpe ? '#fffbf0' : '#fafafa',
                            ...(pipSchedulesSyncing && { pointerEvents: 'none', opacity: 0.55 }),
                          }}>
                            <Typography variant="overline" sx={{ color: '#78909c', fontWeight: 700, letterSpacing: 0.8, display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                              Información de la inspección (perfil-riesgo)
                              {pipSchedulesSyncing && <CircularProgress size={12} />}
                            </Typography>
                            <Grid container spacing={1.5}>
                              <Grid size={{ xs: 12 }}>
                                <TextField fullWidth size="small" required label="Persona que acompañará en el recorrido"
                                  value={qEdits.inspectorContact ?? ''}
                                  error={!(qEdits.inspectorContact || '').trim()}
                                  onChange={(e) => handleQuotationEditChange(schedule.id, 'inspectorContact', e.target.value)}
                                  inputProps={{ maxLength: FIELD_LIMITS.inspectorContact }}
                                  InputProps={{ startAdornment: <PersonIcon sx={{ mr: 1, color: 'text.secondary', fontSize: 18 }} /> }} />
                              </Grid>
                              {!canEditBasePip && (
                                <Grid size={{ xs: 12 }}>
                                  <Alert severity="info" sx={{ py: 0 }}>
                                    Fecha y hora asignadas por el Coordinador de Operaciones
                                    {schedule.scheduledByName ? <> (<strong>{schedule.scheduledByName}</strong>)</> : ''}. Si necesitas cambiarlas, pídeselo a Coordinación.
                                  </Alert>
                                </Grid>
                              )}
                              <Grid size={{ xs: 12, sm: 6 }}>
                                <TextField fullWidth size="small" type="date" label="Fecha de inicio de inspección"
                                  InputLabelProps={{ shrink: true }}
                                  disabled={!canEditBasePip}
                                  value={qEdits.scheduledDate ?? ''}
                                  onChange={(e) => handleQuotationEditChange(schedule.id, 'scheduledDate', e.target.value)} />
                              </Grid>
                              <Grid size={{ xs: 12, sm: 6 }}>
                                <TextField fullWidth size="small" type="time" label="Hora de inicio de inspección"
                                  InputLabelProps={{ shrink: true }}
                                  disabled={!canEditBasePip}
                                  value={qEdits.scheduledTimeStart ?? ''}
                                  onChange={(e) => handleQuotationEditChange(schedule.id, 'scheduledTimeStart', e.target.value)} />
                              </Grid>
                              <Grid size={{ xs: 12, sm: 6 }}>
                                <TextField fullWidth size="small" type="time" label="Hora de fin de inspección"
                                  InputLabelProps={{ shrink: true }}
                                  disabled={!canEditBasePip}
                                  value={qEdits.scheduledTimeEnd ?? ''}
                                  onChange={(e) => handleQuotationEditChange(schedule.id, 'scheduledTimeEnd', e.target.value)} />
                              </Grid>
                              <Grid size={{ xs: 12 }}>
                                <FormControlLabel
                                  control={
                                    <Switch checked={!!qEdits.requiresPpe} color="warning"
                                      onChange={(e) => handleQuotationEditChange(schedule.id, 'requiresPpe', e.target.checked)} />
                                  }
                                  label={
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                      <Warning sx={{ fontSize: 18, color: qEdits.requiresPpe ? 'warning.main' : 'text.secondary' }} />
                                      <Typography variant="body2" fontWeight={600}>¿Requiere equipo de protección personal (EPP)?</Typography>
                                    </Box>
                                  }
                                />
                                {qEdits.requiresPpe && (
                                  <TextField fullWidth size="small" multiline rows={2} sx={{ mt: 1 }}
                                    label="Especifique el equipo de protección requerido"
                                    value={qEdits.ppeDetails ?? ''}
                                    onChange={(e) => handleQuotationEditChange(schedule.id, 'ppeDetails', e.target.value)}
                  inputProps={{ maxLength: FIELD_LIMITS.ppeDetails }} />
                                )}
                              </Grid>
                            </Grid>
                            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 1.5 }}>
                              <Button variant="contained" size="small" disabled={pipSchedulesSyncing || savingQuotationInfo === schedule.id}
                                startIcon={savingQuotationInfo === schedule.id ? <CircularProgress size={16} color="inherit" /> : null}
                                onClick={() => handleSaveEntityQuotationInfo(schedule)}>
                                {savingQuotationInfo === schedule.id ? 'Guardando...' : 'Guardar'}
                              </Button>
                            </Box>
                          </Box>
                          </Box>

                          {entry.loading ? (
                            <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}><CircularProgress size={28} /></Box>
                          ) : entry.error ? (
                            <Box sx={{ p: 2, textAlign: 'center' }}>
                              <Typography variant="body2" color="error" sx={{ mb: 1 }}>{entry.error}</Typography>
                              <Button size="small" variant="outlined" onClick={() => fetchEntityPropertyData(schedule)}>Reintentar</Button>
                            </Box>
                          ) : entry.loaded ? (
                            <>
                              <Box sx={{ display: showTab('INMUEBLE') }}>
                              <Typography variant="overline" sx={{ color: '#78909c', fontWeight: 700, letterSpacing: 0.8, display: 'block', mb: 1 }}>
                                Datos Generales
                              </Typography>
                              {/* Mismo orden, apariencia y placeholders que "Datos del Inmueble" en
                                  Editar Empresa (CatalogoEmpresas.jsx) -- es el mismo dato, así que
                                  debe verse y validarse igual sin importar desde qué pantalla se edite. */}
                              <Grid container spacing={1.5} sx={{ mb: 2.5 }}>
                                <Grid size={{ xs: 12, sm: 4 }}>
                                  <TextField fullWidth size="small" type="number" label="Número de Empleados"
                                    placeholder="Ej: 50"
                                    value={form.employeesCount ?? ''}
                                    error={!!getPropertyFieldError('employeesCount', form.employeesCount)}
                                    helperText={propertyFieldHelperText('employeesCount', form.employeesCount)}
                                    onChange={(e) => handlePropertyFieldChange(schedule.id, 'employeesCount', e.target.value)} />
                                </Grid>
                                <Grid size={{ xs: 12, sm: 4 }}>
                                  <TextField fullWidth size="small" type="number" label="M² Construcción"
                                    placeholder="Ej: 500.50"
                                    InputProps={{ endAdornment: <InputAdornment position="end">m²</InputAdornment> }}
                                    value={form.constructionArea ?? ''}
                                    error={!!getPropertyFieldError('constructionArea', form.constructionArea)}
                                    helperText={propertyFieldHelperText('constructionArea', form.constructionArea)}
                                    onChange={(e) => handlePropertyFieldChange(schedule.id, 'constructionArea', e.target.value)} />
                                </Grid>
                                <Grid size={{ xs: 12, sm: 4 }}>
                                  <TextField fullWidth size="small" type="number" label="M² Terreno"
                                    placeholder="Ej: 800.75"
                                    InputProps={{ endAdornment: <InputAdornment position="end">m²</InputAdornment> }}
                                    value={form.landArea ?? ''}
                                    error={!!getPropertyFieldError('landArea', form.landArea)}
                                    helperText={propertyFieldHelperText('landArea', form.landArea)}
                                    onChange={(e) => handlePropertyFieldChange(schedule.id, 'landArea', e.target.value)} />
                                </Grid>
                                <Grid size={{ xs: 12, sm: 4 }}>
                                  <TextField fullWidth size="small" type="number" label="Niveles de Construcción"
                                    placeholder="Ej: 3"
                                    value={form.constructionLevels ?? ''}
                                    error={!!getPropertyFieldError('constructionLevels', form.constructionLevels)}
                                    helperText={propertyFieldHelperText('constructionLevels', form.constructionLevels)}
                                    onChange={(e) => handlePropertyFieldChange(schedule.id, 'constructionLevels', e.target.value)} />
                                </Grid>
                                <Grid size={{ xs: 12, sm: 4 }}>
                                  <TextField fullWidth size="small" type="number" label="Población Flotante"
                                    placeholder="Ej: 50"
                                    helperText="Opcional"
                                    value={form.floatingPopulation ?? ''}
                                    onChange={(e) => handlePropertyFieldChange(schedule.id, 'floatingPopulation', e.target.value)}
                  inputProps={{ maxLength: FIELD_LIMITS.floatingPopulation.digits }} />
                                </Grid>
                                <Grid size={{ xs: 12, sm: 4 }}>
                                  <TextField fullWidth size="small" type="number" label="Aforo Máximo"
                                    placeholder="Ej: 50"
                                    helperText="Opcional"
                                    value={form.maximumCapacity ?? ''}
                                    onChange={(e) => handlePropertyFieldChange(schedule.id, 'maximumCapacity', e.target.value)}
                  inputProps={{ maxLength: FIELD_LIMITS.maximumCapacity.digits }} />
                                </Grid>
                                <Grid size={{ xs: 12, sm: 4 }}>
                                  <FormControl fullWidth size="small">
                                    <InputLabel>Régimen de Propiedad</InputLabel>
                                    <Select
                                      label="Régimen de Propiedad"
                                      value={form.propertyRegime ?? ''}
                                      onChange={(e) => handlePropertyFieldChange(schedule.id, 'propertyRegime', e.target.value)}
                                    >
                                      <MenuItem value="">Sin especificar</MenuItem>
                                      <MenuItem value="PROPIO">Propio</MenuItem>
                                      <MenuItem value="ARRENDADO">Arrendado</MenuItem>
                                      <MenuItem value="COMODATO">Comodato</MenuItem>
                                      <MenuItem value="OTRO">Otro</MenuItem>
                                    </Select>
                                  </FormControl>
                                </Grid>
                              </Grid>
                              </Box>
                              <Box sx={{ display: showTab('HORARIOS') }}>
                              <Typography variant="overline" sx={{ color: '#78909c', fontWeight: 700, letterSpacing: 0.8, display: 'block', mb: 1 }}>
                                Horarios y actividades
                              </Typography>
                              <Grid container spacing={1.5} sx={{ mb: 2.5 }}>
                                <Grid size={{ xs: 12, sm: 4 }}>
                                  <TextField fullWidth size="small" type="time" label="Horario Operativo — Inicio"
                                    InputLabelProps={{ shrink: true }}
                                    value={form.operatingHoursStart ?? ''}
                                    onChange={(e) => handlePropertyFieldChange(schedule.id, 'operatingHoursStart', e.target.value)} />
                                </Grid>
                                <Grid size={{ xs: 12, sm: 4 }}>
                                  <TextField fullWidth size="small" type="time" label="Horario Operativo — Fin"
                                    InputLabelProps={{ shrink: true }}
                                    value={form.operatingHoursEnd ?? ''}
                                    onChange={(e) => handlePropertyFieldChange(schedule.id, 'operatingHoursEnd', e.target.value)} />
                                </Grid>
                                <Grid size={{ xs: 12, sm: 4 }}>
                                  <TextField fullWidth size="small" type="time" label="Horario Administrativo — Inicio"
                                    helperText="Opcional"
                                    InputLabelProps={{ shrink: true }}
                                    value={form.administrativeHoursStart ?? ''}
                                    onChange={(e) => handlePropertyFieldChange(schedule.id, 'administrativeHoursStart', e.target.value)} />
                                </Grid>
                                <Grid size={{ xs: 12, sm: 4 }}>
                                  <TextField fullWidth size="small" type="time" label="Horario Administrativo — Fin"
                                    helperText="Opcional"
                                    InputLabelProps={{ shrink: true }}
                                    value={form.administrativeHoursEnd ?? ''}
                                    onChange={(e) => handlePropertyFieldChange(schedule.id, 'administrativeHoursEnd', e.target.value)} />
                                </Grid>
                              </Grid>
                              {/* Fuera del Grid de columnas a propósito -- igual que en
                                  CatalogoEmpresas.jsx, como Grid item nunca se veía a ancho
                                  completo (compartía fila con Régimen aunque tuviera xs=12), se
                                  renderiza como bloque aparte para garantizar el 100% del ancho. */}
                              <Box sx={{ mb: 2.5 }}>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                                  <FormatListBulletedIcon sx={{ fontSize: 18, color: '#000000' }} />
                                  <Typography variant="subtitle2" sx={{ fontWeight: 700, color: '#000000' }}>
                                    Actividades Principales
                                  </Typography>
                                  <Typography variant="caption" sx={{ color: 'text.secondary' }}>(Opcional)</Typography>
                                </Box>
                                <TextField fullWidth multiline rows={4}
                                  placeholder="Ej: Venta al público de productos electrónicos, almacenamiento de mercancía en bodega trasera..."
                                  helperText={`${(form.mainActivities || '').length}/500 caracteres`}
                                  inputProps={{ maxLength: 500 }}
                                  value={form.mainActivities ?? ''}
                                  onChange={(e) => handlePropertyFieldChange(schedule.id, 'mainActivities', e.target.value)}
                                  sx={{
                                    width: '100%',
                                    '& .MuiOutlinedInput-root': { borderRadius: 2 },
                                  }} />
                              </Box>
                              </Box>

                              {/* Un solo guardado para Inmueble y Horarios (es el mismo registro) */}
                              <Box sx={{ display: enteTab === 'INMUEBLE' || enteTab === 'HORARIOS' ? 'flex' : 'none', justifyContent: 'flex-end', mt: 2.5, pt: 2, borderTop: '1px solid #e9ecef' }}>
                                <Button variant="contained" size="small" disabled={entry.saving}
                                  startIcon={entry.saving ? <CircularProgress size={16} color="inherit" /> : null}
                                  sx={{ textTransform: 'none', borderRadius: 2, px: 3, fontWeight: 600 }}
                                  onClick={() => handleSaveEntityPropertyData(schedule)}>
                                  {entry.saving ? 'Guardando...' : 'Guardar Datos'}
                                </Button>
                              </Box>
                            </>
                          ) : (
                            <Box sx={{ p: 2, textAlign: 'center' }}>
                              <Typography variant="caption" color="text.secondary">Expanda para cargar los datos.</Typography>
                            </Box>
                          )}
                          </Box>

                          {(() => {
                            const carta = cartaData.byDetail[schedule.id];
                            const cEdits = cartaEdits[schedule.id] || {};
                            const hasPlace = !!(carta?.municipality && carta?.state);
                            return (
                              <Box id={`carta-${schedule.id}`} sx={{ display: showTab('CARTA'), p: 2, borderRadius: 2, border: '1px solid #e0e0e0', bgcolor: '#fafafa' }}>
                                {cartaReturnWorkOrder && (
                                  <ReturnToValidationBanner autoReturn info={{ workOrderId: cartaReturnWorkOrder.id, orderNumber: cartaReturnWorkOrder.orderNumber }}
                                    onReturn={returnFromCartaToValidation} />
                                )}
                                <Typography variant="overline" sx={{ color: '#78909c', fontWeight: 700, letterSpacing: 0.8, display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                                  Carta de Corresponsabilidad
                                  {cartaData.loading && <CircularProgress size={12} />}
                                </Typography>
                                {cartaData.error ? (
                                  <Box sx={{ textAlign: 'center' }}>
                                    <Typography variant="body2" color="error" sx={{ mb: 1 }}>{cartaData.error}</Typography>
                                    <Button size="small" variant="outlined" onClick={fetchCartaData}>Reintentar</Button>
                                  </Box>
                                ) : !carta ? (
                                  <Typography variant="caption" color="text.secondary">
                                    {cartaData.loading ? 'Cargando...' : 'Sin datos para este ente.'}
                                  </Typography>
                                ) : (
                                  <>
                                    <Grid container spacing={1.5}>
                                      <Grid size={{ xs: 12, sm: 6 }}>
                                        <TextField fullWidth size="small" label="Control interno" value={carta.controlInterno || ''}
                                          InputProps={{ readOnly: true }} helperText="Automático (OT + ente)" />
                                      </Grid>
                                      <Grid size={{ xs: 12, sm: 6 }}>
                                        <TextField fullWidth size="small" label="Folio de la Secretaría Estatal"
                                          value={cEdits.stateSecretaryFolio ?? ''}
                                          inputProps={{ maxLength: 100 }}
                                          helperText="Opcional. Se usa en la Carta y en el PIPC de este ente"
                                          onChange={(e) => handleCartaEditChange(schedule.id, 'stateSecretaryFolio', e.target.value)} />
                                      </Grid>
                                      <Grid size={{ xs: 12 }}>
                                        <TextField fullWidth size="small" label="Municipio / Estado"
                                          value={hasPlace ? `${carta.municipality}, ${carta.state}` : ''}
                                          InputProps={{ readOnly: true }}
                                          error={!hasPlace}
                                          helperText={hasPlace
                                            ? 'Se toma del Catálogo de Empresas / Sucursales'
                                            : 'Falta municipio o estado; captúralo en Catálogo de Empresas / Sucursales para poder registrar al destinatario'} />
                                      </Grid>
                                      <Grid size={{ xs: 12, sm: 6 }}>
                                        <TextField fullWidth size="small" label="Destinatario — Nombre"
                                          value={cEdits.holderName ?? ''}
                                          disabled={!hasPlace}
                                          inputProps={{ maxLength: 200 }}
                                          sx={missingFieldSx(cEdits.holderName)}
                                          helperText={!String(cEdits.holderName ?? '').trim() ? 'Requerido para generar la Carta' : ' '}
                                          onChange={(e) => handleCartaEditChange(schedule.id, 'holderName', e.target.value)} />
                                      </Grid>
                                      <Grid size={{ xs: 12, sm: 6 }}>
                                        <TextField fullWidth size="small" label="Destinatario — Cargo"
                                          placeholder="Ej: Director Municipal de Protección Civil"
                                          value={cEdits.holderTitle ?? ''}
                                          disabled={!hasPlace}
                                          inputProps={{ maxLength: 200 }}
                                          sx={missingFieldSx(cEdits.holderTitle)}
                                          helperText={!String(cEdits.holderTitle ?? '').trim() ? 'Requerido para generar la Carta' : ' '}
                                          onChange={(e) => handleCartaEditChange(schedule.id, 'holderTitle', e.target.value)} />
                                      </Grid>
                                    </Grid>
                                    {hasPlace && (
                                      <Alert severity="info" sx={{ mt: 1.5, py: 0 }}>
                                        El destinatario aplica a todos los entes de {carta.municipality}, {carta.state}.
                                      </Alert>
                                    )}
                                    <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 1.5 }}>
                                      <Button variant="contained" size="small" disabled={savingCarta === schedule.id}
                                        startIcon={savingCarta === schedule.id ? <CircularProgress size={16} color="inherit" /> : null}
                                        onClick={() => handleSaveCartaData(schedule)}>
                                        {savingCarta === schedule.id ? 'Guardando...' : 'Guardar'}
                                      </Button>
                                    </Box>
                                  </>
                                )}
                              </Box>
                            );
                          })()}
                        </AccordionDetails>
                      </Accordion>
                    );
                  })
                )}
              </Paper>
            )}

            {/* TAB 2: Seguro por ente */}
            {pipActiveTab === 2 && (
              <Paper sx={{ p: 3, backgroundColor: '#f8f9fa', borderRadius: 3, border: '1px solid #e9ecef' }}>
                <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: 600, color: '#495057', display: 'flex', alignItems: 'center', gap: 1 }}>
                  📄 Seguro por Ente
                </Typography>
                {canEditEntityPip && (
                  <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                    Confirme o corrija estos datos por cada ente. Se guardan directo en el Prospecto/Sucursal correspondiente.
                  </Typography>
                )}
                {!canEditEntityPip && (
                  <Alert severity="info" sx={{ mb: 2 }}>
                    Estos campos son editables por el Coordinador de Operaciones y el Administrador. Aquí puedes consultarlos.
                  </Alert>
                )}
                {workOrderSchedules.length === 0 ? (
                  <Box sx={{ p: 3, textAlign: 'center', backgroundColor: '#fff', borderRadius: 2, border: '1px dashed #ccc' }}>
                    <Typography variant="body2" color="text.secondary">No hay entes disponibles para esta orden</Typography>
                  </Box>
                ) : (
                  workOrderSchedules.map((schedule) => {
                    const panelId4 = `seguro-${schedule.id}`;
                    const isMatriz = !schedule.branchId;
                    const entry = entityPropertyData[schedule.id] || {};
                    const form = entry.data || {};
                    const insuranceReadOnly = !isMatriz && companyInsuranceInfo.insuranceSameForBranches;
                    return (
                      <Accordion key={schedule.id} expanded={expandedSeguroEntity === panelId4}
                        onChange={(_, isExp) => {
                          setExpandedSeguroEntity(isExp ? panelId4 : false);
                          if (isExp) fetchEntityPropertyData(schedule);
                        }}
                        sx={{ mb: 1, borderRadius: '8px !important', '&:before': { display: 'none' }, border: '1px solid #e0e0e0', boxShadow: 'none' }}
                      >
                        <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={{ backgroundColor: '#f5f5f5', borderRadius: '8px' }}>
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, width: '100%' }}>
                            <Typography sx={{ fontWeight: 600, color: '#333', flexGrow: 1 }}>
                              {schedule.entityName}
                              {schedule.entityType && <Chip label={schedule.entityType} size="small" sx={{ ml: 1, fontSize: '0.7rem', height: 18 }} />}
                            </Typography>
                          </Box>
                        </AccordionSummary>
                        <AccordionDetails sx={{ p: 2, ...(!canEditEntityPip && { pointerEvents: 'none', opacity: 0.65 }) }}>
                          {entry.loading ? (
                            <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}><CircularProgress size={28} /></Box>
                          ) : entry.error ? (
                            <Box sx={{ p: 2, textAlign: 'center' }}>
                              <Typography variant="body2" color="error" sx={{ mb: 1 }}>{entry.error}</Typography>
                              <Button size="small" variant="outlined" onClick={() => fetchEntityPropertyData(schedule)}>Reintentar</Button>
                            </Box>
                          ) : entry.loaded ? (
                            <>
                              <Grid container spacing={1.5}>
<Grid size={{ xs: 12, sm: 6 }}>
                                  <TextField fullWidth size="small" label="Compañía de Seguros"
                                    value={insuranceReadOnly ? (companyInsuranceInfo.insuranceCompany || '—') : (form.insuranceCompany ?? '')}
                                    disabled={insuranceReadOnly}
                                    onChange={(e) => handlePropertyFieldChange(schedule.id, 'insuranceCompany', e.target.value)}
                  inputProps={{ maxLength: FIELD_LIMITS.insuranceCompany }} />
                                </Grid>
                                <Grid size={{ xs: 12, sm: 6 }}>
                                  <TextField fullWidth size="small" label="Número de Póliza"
                                    value={insuranceReadOnly ? (companyInsuranceInfo.insurancePolicyNumber || '—') : (form.insurancePolicyNumber ?? '')}
                                    disabled={insuranceReadOnly}
                                    onChange={(e) => handlePropertyFieldChange(schedule.id, 'insurancePolicyNumber', e.target.value)}
                  inputProps={{ maxLength: FIELD_LIMITS.insurancePolicyNumber }} />
                                </Grid>
                                <Grid size={{ xs: 12, sm: 6 }}>
                                  <TextField fullWidth size="small" type={insuranceReadOnly ? 'text' : 'date'} label="Vigencia de la Póliza"
                                    InputLabelProps={{ shrink: true }}
                                    value={insuranceReadOnly ? (companyInsuranceInfo.insurancePolicyValidity || '—') : (form.insurancePolicyValidity ?? '')}
                                    disabled={insuranceReadOnly}
                                    onChange={(e) => handlePropertyFieldChange(schedule.id, 'insurancePolicyValidity', e.target.value)} />
                                </Grid>
                                {insuranceReadOnly && (
                                  <Grid size={{ xs: 12 }}>
                                    <Typography variant="caption" color="text.secondary">
                                      La empresa usa la misma póliza para todas las sucursales — se edita desde la matriz.
                                    </Typography>
                                  </Grid>
                                )}
                              </Grid>

                              <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
                                <Button variant="contained" size="small" disabled={entry.saving}
                                  onClick={() => handleSaveEntityPropertyData(schedule)}>
                                  {entry.saving ? 'Guardando...' : 'Guardar'}
                                </Button>
                              </Box>
                            </>
                          ) : (
                            <Box sx={{ p: 2, textAlign: 'center' }}>
                              <Typography variant="caption" color="text.secondary">Expanda para cargar los datos.</Typography>
                            </Box>
                          )}
                        </AccordionDetails>
                      </Accordion>
                    );
                  })
                )}
              </Paper>
            )}

            {/* UIPC (antes TAB 3) removido de aquí -- ya existe la entrada directa "Captura UIPC"
                fuera de esta pantalla (Dialog uipcCaptureDialogOpen, mismo estado/handlers). */}

            {/* TAB 4: Documentos de cumplimiento por ente */}
            {pipActiveTab === 4 && (
              <Paper sx={{ p: 3, backgroundColor: '#f8f9fa', borderRadius: 3, border: '1px solid #e9ecef' }}>
                <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: 600, color: '#495057', display: 'flex', alignItems: 'center', gap: 1 }}>
                  <Folder sx={{ color: '#1976d2' }} /> Documentos de Cumplimiento por Ente
                </Typography>
                {canEditEntityPip && (
                  <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                    Mismo catálogo requerido para cada ente ({totalDocsRequired} documentos). Revise el avance y abra el
                    detalle para subir o reemplazar archivos de ese ente.
                  </Typography>
                )}
                {!canEditEntityPip && (
                  <Alert severity="info" sx={{ mb: 2 }}>
                    Estos campos son editables por el Coordinador de Operaciones y el Administrador. Aquí puedes consultarlos.
                  </Alert>
                )}
                {workOrderSchedules.length === 0 ? (
                  <Box sx={{ p: 3, textAlign: 'center', backgroundColor: '#fff', borderRadius: 2, border: '1px dashed #ccc' }}>
                    <Folder sx={{ fontSize: 40, color: '#ccc', mb: 1 }} />
                    <Typography variant="body2" color="text.secondary">No hay entes disponibles para esta orden</Typography>
                  </Box>
                ) : (
                  workOrderSchedules.map((schedule) => {
                    const panelId5 = `documentos-${schedule.id}`;
                    const summary = documentsSummaryByEntity[schedule.id] || {};
                    const isMatriz = schedule.entityType === 'MATRIZ';
                    return (
                      <Accordion key={schedule.id} expanded={expandedDocumentosEntity === panelId5}
                        onChange={(_, isExp) => {
                          setExpandedDocumentosEntity(isExp ? panelId5 : false);
                          if (isExp) fetchDocumentsSummary(schedule);
                        }}
                        sx={{ mb: 1, borderRadius: '8px !important', '&:before': { display: 'none' }, border: '1px solid #e0e0e0', boxShadow: 'none' }}
                      >
                        <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={{ backgroundColor: '#f5f5f5', borderRadius: '8px' }}>
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, width: '100%' }}>
                            {isMatriz
                              ? <AccountBalanceIcon sx={{ color: '#4527a0', fontSize: 20 }} />
                              : <StoreIcon sx={{ color: '#01579b', fontSize: 20 }} />}
                            <Typography sx={{ fontWeight: 600, color: '#333', flexGrow: 1 }}>
                              {schedule.entityName}
                            </Typography>
                            {schedule.entityType && (
                              <Chip
                                label={isMatriz ? 'Matriz' : 'Sucursal'}
                                size="small"
                                sx={{
                                  fontSize: '0.7rem', height: 20, fontWeight: 600, mr: 1,
                                  bgcolor: isMatriz ? '#ede7f6' : '#e1f5fe',
                                  color: isMatriz ? '#4527a0' : '#01579b',
                                }}
                              />
                            )}
                            {summary.loaded && (
                              <Chip
                                label={`${summary.uploadedCount}/${totalDocsRequired} subidos`}
                                size="small"
                                color={summary.uploadedCount >= totalDocsRequired ? 'success' : 'default'}
                                sx={{ mr: 1, fontWeight: 600 }}
                              />
                            )}
                            {summary.loaded && summary.expiredCount > 0 && (
                              <Chip label={`${summary.expiredCount} vencido${summary.expiredCount !== 1 ? 's' : ''}`} size="small" color="error" sx={{ mr: 1, fontWeight: 600 }} />
                            )}
                          </Box>
                        </AccordionSummary>
                        <AccordionDetails sx={{ p: 2, ...(!canEditEntityPip && { pointerEvents: 'none', opacity: 0.65 }) }}>
                          {summary.loading ? (
                            <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}><CircularProgress size={28} /></Box>
                          ) : summary.error ? (
                            <Box sx={{ p: 2, textAlign: 'center' }}>
                              <Typography variant="body2" color="error" sx={{ mb: 1 }}>{summary.error}</Typography>
                              <Button size="small" variant="outlined" onClick={() => fetchDocumentsSummary(schedule)}>Reintentar</Button>
                            </Box>
                          ) : summary.loaded ? (
                            <>
                              <Grid container spacing={1.5} sx={{ mb: 2 }}>
                                <Grid size={{ xs: 6, sm: 3 }}>
                                  <Box sx={{ p: 1.2, textAlign: 'center', backgroundColor: '#fff', borderRadius: 2, border: '1px solid #dbe4ff' }}>
                                    <Typography variant="h6" sx={{ fontWeight: 700, color: '#1976d2' }}>{totalDocsRequired}</Typography>
                                    <Typography variant="caption" color="text.secondary">Requeridos</Typography>
                                  </Box>
                                </Grid>
                                <Grid size={{ xs: 6, sm: 3 }}>
                                  <Box sx={{ p: 1.2, textAlign: 'center', backgroundColor: '#fff', borderRadius: 2, border: '1px solid #dbe4ff' }}>
                                    <Typography variant="h6" sx={{ fontWeight: 700, color: '#2e7d32' }}>{summary.uploadedCount}</Typography>
                                    <Typography variant="caption" color="text.secondary">Subidos</Typography>
                                  </Box>
                                </Grid>
                                <Grid size={{ xs: 6, sm: 3 }}>
                                  <Box sx={{ p: 1.2, textAlign: 'center', backgroundColor: '#fff', borderRadius: 2, border: '1px solid #dbe4ff' }}>
                                    <Typography variant="h6" sx={{ fontWeight: 700, color: '#616161' }}>{totalDocsRequired - summary.uploadedCount}</Typography>
                                    <Typography variant="caption" color="text.secondary">Faltantes</Typography>
                                  </Box>
                                </Grid>
                                <Grid size={{ xs: 6, sm: 3 }}>
                                  <Box sx={{ p: 1.2, textAlign: 'center', backgroundColor: '#fff', borderRadius: 2, border: '1px solid #dbe4ff' }}>
                                    <Typography variant="h6" sx={{ fontWeight: 700, color: summary.expiredCount > 0 ? '#c62828' : '#616161' }}>{summary.expiredCount}</Typography>
                                    <Typography variant="caption" color="text.secondary">Vencidos</Typography>
                                  </Box>
                                </Grid>
                              </Grid>
                              <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                <Button
                                  variant="contained" size="small" startIcon={<Folder sx={{ fontSize: 16 }} />}
                                  onClick={() => handleOpenUploadDialog(
                                    selectedWorkOrder,
                                    isMatriz ? null : { id: schedule.branchId, branchName: schedule.entityName, companyId: selectedWorkOrder.companyId }
                                  )}
                                >
                                  Abrir Documentos
                                </Button>
                              </Box>
                            </>
                          ) : (
                            <Box sx={{ p: 2, textAlign: 'center' }}>
                              <Typography variant="caption" color="text.secondary">Expanda para cargar el resumen.</Typography>
                            </Box>
                          )}
                        </AccordionDetails>
                      </Accordion>
                    );
                  })
                )}
              </Paper>
            )}
          </Box>
        </DialogContent>
        <DialogActions sx={{
          p: 2,
          gap: 1,
          backgroundColor: '#f8f9fa',
          borderTop: '2px solid #e9ecef',
          position: 'sticky',
          bottom: 0,
          zIndex: 10,
          justifyContent: 'space-between'
        }}>
          <Box sx={{ display: 'flex', gap: 1 }}>
            <Button disabled={getPipAvailableTabs().indexOf(pipActiveTab) <= 0} onClick={goToPreviousPipTab}
              variant="outlined" size="small" sx={{ textTransform: 'none', borderRadius: 2, minWidth: 100 }}>
              ← Anterior
            </Button>
            <Button disabled={getPipAvailableTabs().indexOf(pipActiveTab) >= getPipAvailableTabs().length - 1} onClick={goToNextPipTab}
              variant="outlined" size="small" color="primary" sx={{ textTransform: 'none', borderRadius: 2, minWidth: 100 }}>
              Siguiente →
            </Button>
          </Box>
          <Box sx={{ display: 'flex', gap: 1.5 }}>
          <Button
            onClick={() => {
              setPipDialogOpen(false);
              setPipActiveTab(0);
              setCartaReturnWorkOrder(null);
              refreshWorkOrderRow(selectedWorkOrder);
            }}
            variant="contained"
            sx={{ minWidth: 120, height: 40, borderRadius: 2, fontWeight: 600, textTransform: 'none', boxShadow: 'none' }}
          >
            Cerrar
          </Button>
          </Box>
        </DialogActions>
      </Dialog>

      {/* Diálogo "Captura UIPC" -- extraído del tab UIPC de "Editar PIPC" para tener una entrada
          directa y más chica, sin pasar por el resto del formulario del PIP. Mismo contenido /
          mismo estado (workOrderSchedules, entityUipcMembers, etc.) que el tab de antes. */}
      <Dialog open={!!correctionDialog} onClose={() => !entityPropertyData[correctionDialog?.schedule?.id]?.saving && setCorrectionDialog(null)}
        maxWidth="sm" fullWidth>
        <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1, color: '#e65100', fontWeight: 700 }}>
          <Warning /> Corrección de datos cotizados
        </DialogTitle>
        <DialogContent dividers>
          <Typography variant="body2" sx={{ mb: 1.5 }}>
            Estás corrigiendo datos con los que se cotizó <strong>{correctionDialog?.schedule?.entityName}</strong>
            {selectedWorkOrder?.orderNumber ? <> (OT <strong>{selectedWorkOrder.orderNumber}</strong>)</> : null}:
          </Typography>
          <Box sx={{ mb: 2, p: 1.5, borderRadius: 2, bgcolor: '#fff8e1', border: '1px solid #ffe082' }}>
            {(correctionDialog?.changes || []).map((c) => (
              <Typography key={c.label} variant="body2" sx={{ fontWeight: 600 }}>
                {c.label}: {c.from ?? '(vacío)'} → {c.to ?? '(vacío)'}
              </Typography>
            ))}
          </Box>
          <TextField fullWidth multiline rows={3} required autoFocus
            label="Motivo de la corrección"
            placeholder="Ej: En la visita se contaron 80 empleados; el cliente reportó 50."
            value={correctionDialog?.reason || ''}
            onChange={(e) => setCorrectionDialog(prev => ({ ...prev, reason: e.target.value }))}
            inputProps={{ maxLength: 500 }} />
          <Alert severity="info" sx={{ mt: 2 }}>
            Se avisará a <strong>Ventas y Administración</strong> para que revisen si la corrección impacta el costo de la cotización.
          </Alert>
        </DialogContent>
        <DialogActions sx={{ p: 2 }}>
          <Button onClick={() => setCorrectionDialog(null)} disabled={!!entityPropertyData[correctionDialog?.schedule?.id]?.saving}
            sx={{ textTransform: 'none' }}>
            Cancelar
          </Button>
          <Button variant="contained" color="warning" onClick={handleConfirmCorrection}
            disabled={!correctionDialog?.reason?.trim() || !!entityPropertyData[correctionDialog?.schedule?.id]?.saving}
            startIcon={entityPropertyData[correctionDialog?.schedule?.id]?.saving ? <CircularProgress size={16} color="inherit" /> : null}
            sx={{ textTransform: 'none', fontWeight: 600 }}>
            Guardar corrección y avisar
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={uipcCaptureDialogOpen}
        onClose={() => { setUipcCaptureDialogOpen(false); refreshWorkOrderRow(selectedWorkOrder); }}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 3,
            boxShadow: '0 20px 40px rgba(0,0,0,0.15)'
          }
        }}
      >
        <DialogTitle sx={{
          background: 'linear-gradient(135deg, #1976d2 0%, #1565c0 100%)',
          color: 'white',
          fontWeight: 'bold',
          fontSize: '1.3rem',
          p: 3,
          display: 'flex',
          alignItems: 'center',
          gap: 2,
          '&::before': {
            content: '"👥"',
            fontSize: '1.5em'
          }
        }}>
          Captura UIPC - {selectedWorkOrder?.companyName || selectedWorkOrder?.clientName}
        </DialogTitle>
        <DialogContent
          dividers
          sx={{
            p: 0,
            maxHeight: '78vh',
            overflowY: 'auto',
            '&::-webkit-scrollbar': { width: '6px' },
            '&::-webkit-scrollbar-track': { background: '#f1f1f1' },
            '&::-webkit-scrollbar-thumb': { background: '#bbb', borderRadius: '4px' },
            '&::-webkit-scrollbar-thumb:hover': { background: '#888' },
          }}
        >
          <Box sx={{ px: 3, pt: 2.5, pb: 1, backgroundColor: '#f0f4ff', borderBottom: '2px solid #c7d7fd' }}>
            <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr 1fr' }, gap: 1.5 }}>
              <Box sx={{ minWidth: 0, p: 1.5, backgroundColor: '#fff', borderRadius: 2, border: '1px solid #dbe4ff', textAlign: 'center' }}>
                <Typography variant="caption" color="text.secondary" display="block">N° Orden</Typography>
                <Typography variant="body2" sx={{ fontWeight: 700, color: '#1976d2' }}>
                  {selectedWorkOrder?.orderNumber || `OT-${String(selectedWorkOrder?.id || 0).padStart(4, '0')}`}
                </Typography>
              </Box>
              <Box sx={{ minWidth: 0, p: 1.5, backgroundColor: '#fff', borderRadius: 2, border: '1px solid #dbe4ff', textAlign: 'center' }}>
                <Typography variant="caption" color="text.secondary" display="block">Empresa</Typography>
                <Typography variant="body2" sx={{ fontWeight: 700, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                  {selectedWorkOrder?.companyName || selectedWorkOrder?.clientName || 'N/A'}
                </Typography>
              </Box>
              <Box sx={{ minWidth: 0, p: 1.5, backgroundColor: '#fff', borderRadius: 2, border: '1px solid #dbe4ff', textAlign: 'center' }}>
                <Typography variant="caption" color="text.secondary" display="block">Entes</Typography>
                <Typography variant="body2" sx={{ fontWeight: 700, color: workOrderSchedules.length === 0 ? '#6a1b9a' : '#2e7d32' }}>
                  {workOrderSchedules.length === 0 ? 'Sin entes activos' : `${workOrderSchedules.length} ente${workOrderSchedules.length !== 1 ? 's' : ''}`}
                </Typography>
              </Box>
            </Box>
          </Box>

          <Box sx={{ p: 3 }}>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
              Capture los miembros de brigada de cada ente. Cada miembro se guarda automáticamente al agregarlo o quitarlo (Enter en el nombre también agrega).
            </Typography>
            {workOrderSchedules.length === 0 ? (
              <Box sx={{ p: 3, textAlign: 'center', backgroundColor: '#fff', borderRadius: 2, border: '1px dashed #ccc' }}>
                <PeopleIcon sx={{ fontSize: 40, color: '#ccc', mb: 1 }} />
                <Typography variant="body2" color="text.secondary">No hay entes disponibles para esta orden</Typography>
              </Box>
            ) : (
              workOrderSchedules.map((schedule) => {
                const members = entityUipcMembers[schedule.id] || [];
                const newMember2 = newEntityUipcMember[schedule.id] || { workerName: '', brigadePosition: '' };
                const pendingCount = members.filter(m => m._pending).length;
                const errorCount = members.filter(m => m._error).length;
                const panelId2 = `uipc-dialog-entity-${schedule.id}`;
                return (
                  <Accordion key={schedule.id} expanded={expandedUipcEntity === panelId2}
                    onChange={(_, isExp) => setExpandedUipcEntity(isExp ? panelId2 : false)}
                    sx={{ mb: 1, borderRadius: '8px !important', '&:before': { display: 'none' }, border: '1px solid #e0e0e0', boxShadow: 'none' }}
                  >
                    <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={{ backgroundColor: '#f5f5f5', borderRadius: '8px' }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, width: '100%' }}>
                        <PeopleIcon sx={{ color: '#1976d2', fontSize: 20 }} />
                        <Typography sx={{ fontWeight: 600, color: '#333', flexGrow: 1 }}>
                          {schedule.entityName}
                          {schedule.entityType && <Chip label={schedule.entityType} size="small" sx={{ ml: 1, fontSize: '0.7rem', height: 18 }} />}
                        </Typography>
                        {uipcMembersLoading
                          ? <CircularProgress size={16} sx={{ mr: 1 }} />
                          : <Chip label={`${members.length} miembro${members.length !== 1 ? 's' : ''}`} size="small" color={members.length > 0 ? 'primary' : 'default'} sx={{ mr: 1 }} />}
                      </Box>
                    </AccordionSummary>
                    <AccordionDetails sx={{ p: 2 }}>
                      <Box sx={{ p: 2, mb: 2, backgroundColor: '#fafafa', borderRadius: 2, border: '1px solid #e8e8e8' }}>
                        <Typography variant="caption" sx={{ fontWeight: 600, color: '#666', display: 'block', mb: 1.5 }}>Agregar Miembro</Typography>
                        <Grid container spacing={1.5} alignItems="center">
                          <Grid size={{ xs: 12, md: 5 }}>
                            <TextField fullWidth size="small" label="Nombre del Trabajador"
                              value={newMember2.workerName}
                              onChange={(e) => handleEntityUipcMemberChange(schedule.id, 'workerName', e.target.value)}
                              onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); handleAddEntityUipcMember(schedule.id); } }}
                              placeholder="Ej: Juan Pérez"
                  inputProps={{ maxLength: FIELD_LIMITS.uipcWorkerName }} />
                          </Grid>
                          <Grid size={{ xs: 12, md: 5 }}>
                            <FormControl fullWidth size="small">
                              <InputLabel>Puesto en la Brigada</InputLabel>
                              <Select value={newMember2.brigadePosition}
                                onChange={(e) => handleEntityUipcMemberChange(schedule.id, 'brigadePosition', e.target.value)}
                                label="Puesto en la Brigada">
                                <MenuItem value="Coordinador de la Unidad Interna de Protección Civil">Coordinador de la Unidad Interna de Protección Civil</MenuItem>
                                <MenuItem value="Suplente del Coordinador de la UIPC">Suplente del Coordinador de la UIPC</MenuItem>
                                <MenuItem value="Jefe de Brigada de PPAA">Jefe de Brigada de PPAA</MenuItem>
                                <MenuItem value="Jefe de Brigada de Eva de In">Jefe de Brigada de Eva de In</MenuItem>
                                <MenuItem value="Jefe de Brigada de ByR">Jefe de Brigada de ByR</MenuItem>
                                <MenuItem value="Jefe de Brigada de PyCI">Jefe de Brigada de PyCI</MenuItem>
                                <MenuItem value="Jefe de Brigada Multifuncional">Jefe de Brigada Multifuncional</MenuItem>
                                <MenuItem value="Brigada de PPAA">Brigada de PPAA</MenuItem>
                                <MenuItem value="Brigada de Eva de In">Brigada de Eva de In</MenuItem>
                                <MenuItem value="Brigada de ByR">Brigada de ByR</MenuItem>
                                <MenuItem value="Brigada de PyCI">Brigada de PyCI</MenuItem>
                                <MenuItem value="Brigada Multifuncional">Brigada Multifuncional</MenuItem>
                              </Select>
                            </FormControl>
                          </Grid>
                          <Grid size={{ xs: 12, md: 2 }}>
                            <Button fullWidth variant="outlined" size="small" startIcon={<AddIcon />}
                              onClick={() => handleAddEntityUipcMember(schedule.id)} sx={{ height: '40px' }}>Agregar</Button>
                          </Grid>
                        </Grid>
                      </Box>
                      {members.length > 0 ? (
                        <TableContainer sx={{ mb: 2 }}>
                          <Table size="small">
                            <TableHead>
                              <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
                                <TableCell sx={{ fontWeight: 600, width: 40 }}>#</TableCell>
                                <TableCell sx={{ fontWeight: 600 }}>Nombre</TableCell>
                                <TableCell sx={{ fontWeight: 600 }}>Puesto</TableCell>
                                <TableCell align="center" sx={{ fontWeight: 600, width: 60 }}>Quitar</TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {members.map((m, idx) => (
                                <TableRow key={m.id} sx={{ '&:hover': { backgroundColor: '#f8f9fa' }, ...(m._error && { backgroundColor: '#fff4f4' }), opacity: m._pending ? 0.6 : 1 }}>
                                  <TableCell>{idx + 1}</TableCell>
                                  <TableCell sx={{ fontWeight: 500 }}>
                                    {m.workerName}
                                    {m._pending && <CircularProgress size={12} sx={{ ml: 1, verticalAlign: 'middle' }} />}
                                    {m._error && (
                                      <Chip label="Reintentar" size="small" color="error" variant="outlined" sx={{ ml: 1, height: 20, cursor: 'pointer' }}
                                        onClick={() => persistUipcMember(schedule.id, m)} />
                                    )}
                                  </TableCell>
                                  <TableCell><Chip label={m.brigadePosition} size="small" sx={{ backgroundColor: '#e3f2fd', color: '#1976d2' }} /></TableCell>
                                  <TableCell align="center">
                                    <IconButton size="small" disabled={m._pending} onClick={() => handleRemoveEntityUipcMember(schedule.id, m)} sx={{ color: '#d32f2f' }}>
                                      <DeleteIcon fontSize="small" />
                                    </IconButton>
                                  </TableCell>
                                </TableRow>
                              ))}
                            </TableBody>
                          </Table>
                        </TableContainer>
                      ) : uipcMembersLoading ? (
                        <Box sx={{ p: 2, mb: 2 }}>
                          <Skeleton variant="text" width="60%" />
                          <Skeleton variant="text" width="45%" />
                        </Box>
                      ) : (
                        <Box sx={{ p: 2, textAlign: 'center', border: '1px dashed #ccc', borderRadius: 2, mb: 2 }}>
                          <Typography variant="caption" color="text.secondary">Sin miembros aún. Agréguelos arriba.</Typography>
                        </Box>
                      )}

                      {/* D) Ya no hay botón "Guardar": cada alta/baja se guarda sola; esto solo informa el estado */}
                      <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: 0.75, mt: 1 }}>
                        {pendingCount > 0 ? (
                          <><CircularProgress size={14} /><Typography variant="caption" color="text.secondary">Guardando…</Typography></>
                        ) : errorCount > 0 ? (
                          <Typography variant="caption" sx={{ color: '#c62828', fontWeight: 600 }}>
                            {errorCount} miembro{errorCount !== 1 ? 's' : ''} sin guardar — usa "Reintentar"
                          </Typography>
                        ) : members.length > 0 ? (
                          <Typography variant="caption" sx={{ color: '#2e7d32', fontWeight: 600 }}>✓ Guardado automáticamente</Typography>
                        ) : null}
                      </Box>
                    </AccordionDetails>
                  </Accordion>
                );
              })
            )}
          </Box>
        </DialogContent>
        <DialogActions sx={{ p: 2 }}>
          <Button onClick={() => { setUipcCaptureDialogOpen(false); refreshWorkOrderRow(selectedWorkOrder); }}>Cerrar</Button>
        </DialogActions>
      </Dialog>

      {/* Modal de Subir Archivos */}
      <UploadDocumentosDialog
        open={uploadDialogOpen}
        onClose={handleCloseUploadDialog}
        workOrder={selectedQuotationForUpload}
        branch={uploadDialogBranch}
        onSuccess={() => setSnackbar({ open: true, message: '✅ Archivos subidos exitosamente a Dropbox', severity: 'success' })}
        onError={(msg) => setSnackbar({ open: true, message: msg, severity: 'error' })}
      />

      {/* Menú de selección de ente al descargar PIPC/Reporte con más de un ente */}
      <Menu
        anchorEl={docsMenu.anchorEl}
        open={Boolean(docsMenu.anchorEl)}
        onClose={closeDocsMenu}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <MenuItem disabled sx={{ opacity: '1 !important' }}>
          <Typography variant="caption" sx={{ fontWeight: 700, color: 'text.secondary' }}>
            {docsMenu.docLabel} — elige un ente
          </Typography>
        </MenuItem>
        <Divider />
        {docsMenu.items.map((doc, idx) => (
          <MenuItem
            key={idx}
            onClick={() => { downloadQuotationDoc(doc); closeDocsMenu(); }}
          >
            <ListItemIcon><Download fontSize="small" /></ListItemIcon>
            <ListItemText primary={doc.entityName} secondary={doc.filename} />
          </MenuItem>
        ))}
      </Menu>

      {/* Menú compacto de Notas (OT + por ente) -- reemplaza la fila de chips de la columna
          Acciones. Se muestra siempre (no depende de si el PIP ya inició), a diferencia del menú
          de Fase 1-4 de abajo. */}
      <Menu
        anchorEl={notesMenuAnchor}
        open={Boolean(notesMenuAnchor)}
        onClose={handleCloseNotesMenu}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        transformOrigin={{ vertical: 'top', horizontal: 'center' }}
        PaperProps={{ sx: { minWidth: 220, boxShadow: '0 4px 20px rgba(0,0,0,0.1)', borderRadius: 2, mt: 0.5 } }}
      >
        <MenuItem
          onClick={() => {
            const anchor = notesMenuAnchor;
            const wo = notesMenuWorkOrder;
            handleCloseNotesMenu();
            handleOpenNotesDialog(wo, anchor);
          }}
        >
          <ListItemIcon>
            <StickyNote2Icon fontSize="small" sx={{ color: '#e65100' }} />
          </ListItemIcon>
          <ListItemText primary="Nota de la OT" secondary="Toda la orden" primaryTypographyProps={{ fontWeight: 500 }} />
        </MenuItem>

        {(workOrderEntityMap[notesMenuWorkOrder?.id] || []).filter((entity) => entity.detailId).length > 0 && (
          <Divider sx={{ my: 0.5 }} />
        )}

        {(workOrderEntityMap[notesMenuWorkOrder?.id] || []).filter((entity) => entity.detailId).map((entity) => {
          const isMatriz = entity.type === 'MATRIZ';
          const displayName = isMatriz ? entity.name.replace(/\s*\(Matriz\)\s*$/i, '') : entity.name;
          return (
            <MenuItem
              key={entity.name}
              onClick={() => {
                const anchor = notesMenuAnchor;
                handleCloseNotesMenu();
                handleOpenEntityNotes(entity, anchor);
              }}
            >
              <ListItemIcon>
                <StickyNote2Icon fontSize="small" sx={{ color: '#1565c0' }} />
              </ListItemIcon>
              <ListItemText primary={displayName} secondary="Solo este ente" />
            </MenuItem>
          );
        })}
      </Menu>

      {/* Menú Desplegable de Acciones */}
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleCloseMenu}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{
          sx: {
            minWidth: 340,
            maxWidth: 420,
            boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
            borderRadius: 2,
            mt: 0.5
          }
        }}
      >
        {(() => {
          const wo = selectedWorkOrderForMenu;
          if (!wo) return null;
          const started = !!pipStatus[wo.quotationId];
          const notStartedBlock = pipStatusLoaded && !started;
          const flowLoaded = workflowStatus?.workOrderId === wo.id;
          // El menú se ve POR ENTE (como lo ve el Ejecutivo con su ente): con varios entes se
          // elige arriba cuál; el avance y las acciones del ente (evaluación, archivos, agenda)
          // son de ese ente.
          const allEntes = (progressEntities[wo.quotationId] || []).map((e) => ({
            name: (e.entityName || '').replace(/\s*\(Matriz\)\s*$/i, ''), branchId: e.branchId ?? null,
            asignado: e.asignado, uipc: e.uipc, evaluacion: e.evaluacion, acompanante: e.acompanante,
          }));
          const enteKey = (e) => String(e?.branchId ?? 'MATRIZ');
          const selectedEnte = allEntes.find((e) => enteKey(e) === String(menuEnteKey)) || allEntes[0] || null;
          const isSelected = (x) => !!selectedEnte && enteKey(x) === enteKey(selectedEnte);
          const statusAll = flowLoaded ? workflowStatus.data : null;
          const readinessAll = readinessData[wo.quotationId]?.entities || [];
          const enteStatus = statusAll && selectedEnte ? {
            ...statusAll,
            entities: (statusAll.entities || []).filter(isSelected),
            constancias: ((statusAll.entities || []).find(isSelected) || {}).constancias || statusAll.constancias,
          } : statusAll;
          const flow = buildWorkflowSteps({
            programStarted: started,
            programComplete: !!pipCompletionStatus[wo.quotationId],
            entes: selectedEnte ? [selectedEnte] : [],
            readiness: readinessAll.filter(isSelected),
            ricReady: readinessMap[wo.id]?.ricReady,
            pipcReady: readinessMap[wo.id]?.pipcReady,
            qaRound1Approved: hasQaRound1Approved(wo),
            workOrderCompleted: isWorkOrderCompleted(wo),
            status: enteStatus,
            permissions: { canPrepare: canEditBasePip || canEditUipcByEntity, canDeliver: canManageDeliveries(userRole) },
          });
          const enteReadiness = readinessAll.find(isSelected);
          const enteDocs = ((enteStatus?.entities || [])[0] || {}).documents || {};
          const ricReady = !!selectedEnte?.evaluacion;
          const pipcReady = !!enteReadiness?.pipcReady;
          const enteQaRound1 = ['REVISION_1_APROBADA', 'REVISION_2_APROBADA'].includes(enteDocs.PIPC?.qaStatus);
          // Acciones del ente elegido (el menú se abre desde su renglón)
          const ITEMS = {
            edit: { icon: Edit, color: '#ff9800', disabled: !canEditBasePip && !canEditUipcByEntity },
            captureUipc: { icon: PeopleIcon, color: '#1976d2', disabled: !canEditBasePip && !canEditUipcByEntity },
            assigned: { icon: EventIcon, color: '#5e35b1', disabled: false },
            evaluation: { icon: Assessment, color: '#9c27b0', disabled: notStartedBlock },
            validate: { icon: FactCheck, color: '#009688', disabled: notStartedBlock },
            files: { icon: AttachFile, color: '#ff9800', disabled: false },
            generateRic: { icon: Description, color: '#2e7d32', disabled: !ricReady },
            generatePipc: { icon: Assignment, color: '#1565c0', disabled: !pipcReady },
            generateActa: { icon: GavelIcon, color: '#bf360c', disabled: !enteQaRound1 },
            generateCarta: { icon: DraftsIcon, color: '#00796b', disabled: !enteQaRound1 },
            generateConstancias: { icon: CheckCircle, color: '#7b1fa2', disabled: notStartedBlock },
            download: { icon: Download, color: '#00bcd4', disabled: !enteDocs.PIPC },
            downloadReport: { icon: Download, color: '#4caf50', disabled: !enteDocs.REPORTE_INSPECCION },
            delivery: { icon: LocalShippingIcon, color: '#1976d2', disabled: !canManageDeliveries(userRole) },
          };
          const LABELS = {
            edit: 'Iniciar Programa', assigned: 'Asignado y programado', captureUipc: 'Captura UIPC', evaluation: 'Evaluación de Inspección',
            validate: 'Validar Campos', files: 'Subir Archivos', generateRic: 'Generar RIC', generatePipc: 'Generar PIPC',
            generateActa: 'Generar Acta Constitutiva', generateCarta: 'Generar Carta de Corresponsabilidad',
            generateConstancias: 'Generar Constancias', download: 'Descargar Archivo PIPC',
            downloadReport: 'Descargar Reporte de Inspección', delivery: 'Entrega al cliente',
          };
          const STATE_ICON = {
            done: <Tooltip title="Completado"><CheckCircle sx={{ fontSize: 18, color: '#2e7d32' }} /></Tooltip>,
            progress: <Tooltip title="En curso"><TimelapseIcon sx={{ fontSize: 18, color: '#ef6c00' }} /></Tooltip>,
            pending: <Tooltip title="Pendiente"><RadioButtonUnchecked sx={{ fontSize: 18, color: '#bdbdbd' }} /></Tooltip>,
            blocked: <Tooltip title="Aún no disponible"><LockIcon sx={{ fontSize: 16, color: '#bdbdbd' }} /></Tooltip>,
          };

          return [
            selectedEnte && (
              <Box key="ente" sx={{ px: 2, pt: 1, pb: 0.5, bgcolor: '#fafafa', borderBottom: '1px solid #eee' }}>
                <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                  Ente: <strong>{selectedEnte.name}</strong>{wo.orderNumber ? ` · ${wo.orderNumber}` : ''}
                </Typography>
              </Box>
            ),
            <Box key="next" sx={{ px: 2, py: 1.25, mb: 0.5, bgcolor: flow.next || !flow.allDone ? '#e3f2fd' : '#e8f5e9', borderBottom: '1px solid #e0e0e0' }}>
              <Typography variant="caption" sx={{ fontWeight: 700, color: flow.next || !flow.allDone ? '#1565c0' : '#2e7d32', textTransform: 'uppercase', letterSpacing: '0.06em', fontSize: '0.66rem' }}>
                {flow.next ? 'Siguiente paso' : flow.allDone ? 'Flujo completo' : 'En espera'}
              </Typography>
              <Typography variant="body2" sx={{ fontWeight: 700, color: '#263238' }}>
                {flow.next ? flow.next.label : flow.allDone ? 'Todo lo de esta orden está completado' : `${flow.waiting?.label || 'Pendiente'}${flow.waiting?.detail ? ` — ${flow.waiting.detail}` : ''}`}
              </Typography>
              {flow.next?.hint && (
                <Typography variant="caption" color="text.secondary" display="block">{flow.next.hint}</Typography>
              )}
              {!flowLoaded && (
                <Typography variant="caption" color="text.secondary" sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mt: 0.25 }}>
                  <CircularProgress size={10} /> Actualizando documentos y entrega…
                </Typography>
              )}
            </Box>,
            ...flow.sections.flatMap((section, idx) => {
              const keys = section.steps.filter((k) => flow.steps[k]);
              if (keys.length === 0) return [];
              return [
                idx > 0 ? <Divider key={`div-${section.key}`} sx={{ my: 0.5 }} /> : null,
                <Box key={`hdr-${section.key}`} sx={{ px: 2, pt: 0.5, pb: 0.5, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                  <Typography variant="caption" sx={{ fontWeight: 700, color: '#9e9e9e', textTransform: 'uppercase', letterSpacing: '0.08em', fontSize: '0.68rem' }}>
                    {section.label}
                  </Typography>
                  {section.total > 0 && (
                    <Typography variant="caption" sx={{ fontWeight: 700, fontSize: '0.68rem', color: section.done === section.total ? '#2e7d32' : '#9e9e9e' }}>
                      {section.done === section.total ? '✓ ' : ''}{section.done}/{section.total}
                    </Typography>
                  )}
                </Box>,
                ...keys.map((key) => {
                  const item = ITEMS[key];
                  const step = flow.steps[key];
                  const isNext = flow.next?.key === key;
                  const Icon = item.icon;
                  const secondary = (key === 'generateRic' || key === 'generatePipc') && step.state === 'pending' && item.readyHint
                    ? item.readyHint : step.detail;
                  return (
                    <MenuItem key={key} onClick={() => handleMenuAction(key)} disabled={item.disabled}
                      sx={{
                        borderLeft: `3px solid ${isNext ? '#1976d2' : 'transparent'}`,
                        bgcolor: isNext ? 'rgba(25, 118, 210, 0.06)' : undefined,
                        '&:hover': { bgcolor: `${item.color}14` },
                      }}>
                      <ListItemIcon>
                        <Icon fontSize="small" sx={{ color: item.disabled ? '#bdbdbd' : item.color }} />
                      </ListItemIcon>
                      <ListItemText
                        primary={LABELS[key]}
                        secondary={secondary || undefined}
                        primaryTypographyProps={{ fontWeight: isNext ? 700 : 500 }}
                        secondaryTypographyProps={{ fontSize: '0.7rem' }}
                      />
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, ml: 1.5 }}>
                        {isNext && <Chip label="Siguiente" size="small" color="primary" sx={{ height: 18, fontSize: '0.62rem', fontWeight: 700 }} />}
                        {STATE_ICON[step.state] || null}
                      </Box>
                    </MenuItem>
                  );
                }),
              ];
            }),
          ];
        })()}
      </Menu>

      <EntregaClienteDialog
        open={Boolean(deliveryWorkOrder)}
        workOrder={deliveryWorkOrder}
        onClose={() => setDeliveryWorkOrder(null)}
        onChanged={fetchWorkOrders}
      />

      {/* Popover de Notas -- historial por cotización, mismo componente que Estadísticas de Cotizaciones */}
      <Popover
        open={Boolean(notesAnchorEl)}
        anchorEl={notesAnchorEl}
        onClose={handleCloseNotesDialog}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
        PaperProps={{ sx: { width: 360, borderRadius: 3, boxShadow: '0 8px 32px rgba(0,0,0,0.18)', overflow: 'hidden' } }}
      >
        <Box sx={{ p: 2, bgcolor: '#f57c00', color: '#fff', display: 'flex', alignItems: 'center', gap: 1 }}>
          <StickyNote2Icon />
          <Box sx={{ flex: 1 }}>
            <Typography variant="subtitle2" sx={{ fontWeight: 700, lineHeight: 1.2 }}>Notas</Typography>
            {selectedWorkOrderForNotes && (
              <Typography variant="caption" sx={{ opacity: 0.85 }}>
                {selectedWorkOrderForNotes.orderNumber || selectedWorkOrderForNotes.order_number || `OT-${String(selectedWorkOrderForNotes.id).padStart(4, '0')}`}
              </Typography>
            )}
          </Box>
          <IconButton size="small" onClick={handleCloseNotesDialog} sx={{ color: '#fff', ml: 'auto' }}>
            <CloseIcon fontSize="small" />
          </IconButton>
        </Box>

        <Box sx={{ p: 2, maxHeight: 280, overflowY: 'auto' }}>
          {notesLoading ? (
            <Box sx={{ textAlign: 'center', py: 3 }}><CircularProgress size={24} sx={{ color: '#f57c00' }} /></Box>
          ) : notesList.length === 0 ? (
            <Typography variant="body2" color="text.secondary" sx={{ textAlign: 'center', py: 3 }}>
              Sin notas aún
            </Typography>
          ) : (
            notesList.map((note, idx) => (
              <Box key={note.id || idx} sx={{ mb: 1.5 }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
                  <Typography variant="caption" sx={{ color: '#f57c00', fontWeight: 700 }}>
                    {note.createdBy || 'Sistema'}
                  </Typography>
                  <Typography variant="caption" color="text.secondary">
                    {note.createdAt
                      ? new Date(note.createdAt).toLocaleString('es-MX', { dateStyle: 'short', timeStyle: 'short' })
                      : ''}
                  </Typography>
                </Box>
                <Typography variant="body2" sx={{ bgcolor: '#fff8e1', borderRadius: 1.5, p: 1, fontSize: '0.82rem' }}>
                  {note.content}
                </Typography>
                {idx < notesList.length - 1 && <Divider sx={{ mt: 1.5 }} />}
              </Box>
            ))
          )}
        </Box>

        <Divider />
        <Box sx={{ p: 1.5 }}>
          <TextField
            fullWidth
            size="small"
            multiline
            rows={2}
            placeholder="Escribe una nota..."
            value={noteInput}
            onChange={(e) => setNoteInput(e.target.value)}
            onKeyDown={(e) => { if (e.key === 'Enter' && e.ctrlKey) handleSaveNote(); }}
            sx={{ mb: 1 }}
          />
          <Button
            fullWidth
            variant="contained"
            size="small"
            disabled={notesSaving || !noteInput.trim()}
            onClick={handleSaveNote}
            startIcon={notesSaving ? <CircularProgress size={14} color="inherit" /> : <NoteAdd />}
            sx={{
              bgcolor: '#f57c00',
              '&:hover': { bgcolor: '#e65100' },
              textTransform: 'none',
              fontWeight: 600,
              borderRadius: 2
            }}
          >
            {notesSaving ? 'Guardando...' : 'Agregar nota'}
          </Button>
        </Box>
      </Popover>

      {/* Popover de Notas POR ENTE -- general_notes (note_type='ENTE'), independiente del de
          cotización de arriba. Azul en vez de naranja para distinguirlo a simple vista. */}
      <Popover
        open={Boolean(entityNotesAnchorEl)}
        anchorEl={entityNotesAnchorEl}
        onClose={handleCloseEntityNotes}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
        PaperProps={{ sx: { width: 360, borderRadius: 3, boxShadow: '0 8px 32px rgba(0,0,0,0.18)', overflow: 'hidden' } }}
      >
        <Box sx={{ p: 2, bgcolor: '#1976d2', color: '#fff', display: 'flex', alignItems: 'center', gap: 1 }}>
          <StickyNote2Icon />
          <Box sx={{ flex: 1 }}>
            <Typography variant="subtitle2" sx={{ fontWeight: 700, lineHeight: 1.2 }}>Notas del ente</Typography>
            {selectedEntityForNotes && (
              <Typography variant="caption" sx={{ opacity: 0.85 }}>
                {selectedEntityForNotes.name}
              </Typography>
            )}
          </Box>
          <IconButton size="small" onClick={handleCloseEntityNotes} sx={{ color: '#fff', ml: 'auto' }}>
            <CloseIcon fontSize="small" />
          </IconButton>
        </Box>

        <Box sx={{ p: 2, maxHeight: 280, overflowY: 'auto' }}>
          {entityNotesLoading ? (
            <Box sx={{ textAlign: 'center', py: 3 }}><CircularProgress size={24} sx={{ color: '#1976d2' }} /></Box>
          ) : entityNotesList.length === 0 ? (
            <Typography variant="body2" color="text.secondary" sx={{ textAlign: 'center', py: 3 }}>
              Sin notas aún
            </Typography>
          ) : (
            entityNotesList.map((note, idx) => (
              <Box key={note.id || idx} sx={{ mb: 1.5 }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
                  <Typography variant="caption" sx={{ color: '#1976d2', fontWeight: 700 }}>
                    {note.createdBy || 'Sistema'}
                  </Typography>
                  <Typography variant="caption" color="text.secondary">
                    {note.createdAt
                      ? new Date(note.createdAt).toLocaleString('es-MX', { dateStyle: 'short', timeStyle: 'short' })
                      : ''}
                  </Typography>
                </Box>
                <Typography variant="body2" sx={{ bgcolor: '#e3f2fd', borderRadius: 1.5, p: 1, fontSize: '0.82rem' }}>
                  {note.content}
                </Typography>
                {idx < entityNotesList.length - 1 && <Divider sx={{ mt: 1.5 }} />}
              </Box>
            ))
          )}
        </Box>

        <Divider />
        <Box sx={{ p: 1.5 }}>
          <TextField
            fullWidth
            size="small"
            multiline
            rows={2}
            placeholder="Escribe una nota..."
            value={entityNoteInput}
            onChange={(e) => setEntityNoteInput(e.target.value)}
            onKeyDown={(e) => { if (e.key === 'Enter' && e.ctrlKey) handleSaveEntityNote(); }}
            sx={{ mb: 1 }}
          />
          <Button
            fullWidth
            variant="contained"
            size="small"
            disabled={entityNotesSaving || !entityNoteInput.trim()}
            onClick={handleSaveEntityNote}
            startIcon={entityNotesSaving ? <CircularProgress size={14} color="inherit" /> : <NoteAdd />}
            sx={{
              bgcolor: '#1976d2',
              '&:hover': { bgcolor: '#1565c0' },
              textTransform: 'none',
              fontWeight: 600,
              borderRadius: 2
            }}
          >
            {entityNotesSaving ? 'Guardando...' : 'Agregar nota'}
          </Button>
        </Box>
      </Popover>

      {/* Diálogo de avance PIPC */}
      <PipcProgressDialog
        open={progressDialogOpen}
        onClose={() => {
          setProgressDialogOpen(false);
          setSelectedWorkOrderForProgress(null);
        }}
        quotationId={selectedWorkOrderForProgress?.quotationId}
        companyName={selectedWorkOrderForProgress?.companyName}
      />

      {/* Diálogo de Validación de Campos por Orden de Trabajo */}
      <Dialog
        open={validationDialogOpen}
        onClose={() => {
          setValidationDialogOpen(false);
          setValidationData(null);
          setSelectedWorkOrderForValidation(null);
        }}
        maxWidth="md"
        fullWidth
        PaperProps={{ sx: { borderRadius: 3, maxHeight: '85vh' } }}
      >
        <DialogTitle sx={{ 
          bgcolor: '#009688', color: 'white', fontWeight: 700,
          display: 'flex', alignItems: 'center', gap: 1
        }}>
          <FactCheck />
          Validación de Campos — {selectedWorkOrderForValidation?.orderNumber || ''}
          {selectedWorkOrderForValidation?.companyName ? ` · ${selectedWorkOrderForValidation.companyName}` : ''}
        </DialogTitle>
        <DialogContent sx={{ p: 0 }}>
          {validationLoading ? (
            <Box sx={{ p: 2 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', py: 1.5 }}>
                <CircularProgress size={24} sx={{ color: '#009688' }} />
                <Typography sx={{ ml: 2, fontWeight: 600 }}>Calculando el detalle exacto con los datos actuales…</Typography>
              </Box>
              {/* Vista preliminar: el resumen que ya tenía la tabla (puede tener unos segundos).
                  Solo porcentajes y conteos; la lista de lo que falta sale únicamente del cálculo
                  exacto de arriba, para no mostrar como faltante algo que ya se capturó. */}
              {(readinessData[selectedWorkOrderForValidation?.quotationId]?.entities || []).length > 0 && (
                <Box sx={{ mt: 1, p: 1.5, bgcolor: '#f5f5f5', borderRadius: 2, opacity: 0.85 }}>
                  <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 1 }}>
                    Vista preliminar (último resumen de la tabla, no es el resultado final):
                  </Typography>
                  {readinessData[selectedWorkOrderForValidation.quotationId].entities.map((r) => (
                    <Box key={r.branchId ?? 'matriz'} sx={{ display: 'flex', gap: 2, alignItems: 'center', flexWrap: 'wrap', py: 0.5 }}>
                      <Typography variant="body2" sx={{ fontWeight: 600, minWidth: 200 }}>{r.entityName}</Typography>
                      <Typography variant="body2" color="text.secondary">Campos PIPC: {r.pipcReady ? 'completos' : `${r.pipcPercentage ?? 0}%`}</Typography>
                      <Typography variant="body2" color="text.secondary">Documentos: {r.docsUploaded ?? 0}/{r.docsRequired ?? 0}</Typography>
                    </Box>
                  ))}
                </Box>
              )}
            </Box>
          ) : validationData ? (
            <Box sx={{ p: 2 }}>
              {/* Info general */}
              <Box sx={{ mb: 2, p: 1.5, bgcolor: '#f5f5f5', borderRadius: 2 }}>
                <Typography variant="body2"><strong>Empresa:</strong> {validationData.companyName}</Typography>
                <Typography variant="body2"><strong>Folio:</strong> {validationData.folio || 'N/A'}</Typography>
                <Typography variant="body2">
                  <strong>Entidades:</strong>{' '}
                  {(validationData.hiddenEntities || []).length > 0
                    ? `${validationData.totalEntities} de ${validationData.totalEntitiesInOrder} (solo tus entes asignados)`
                    : `${validationData.totalEntities} (${validationData.matriz ? '1 Matriz' : 'sin Matriz'} + ${(validationData.branches || []).length} Sucursales)`}
                </Typography>
              </Box>

              <Alert
                severity={validationData.dropboxCheckFailed ? 'warning' : validationData.dropboxVerified ? 'success' : 'info'}
                sx={{ mb: 2, alignItems: 'center' }}
                action={
                  <Button size="small" color="inherit" sx={{ textTransform: 'none', whiteSpace: 'nowrap' }}
                    onClick={() => handleValidateFields(selectedWorkOrderForValidation, { verifyDropbox: true })}>
                    Verificar contra Dropbox
                  </Button>
                }
              >
                {validationData.dropboxCheckFailed
                  ? 'No se pudo consultar Dropbox (límite de peticiones o conexión). Los archivos se tomaron como registrados en el sistema; intenta verificar de nuevo en unos minutos.'
                  : validationData.dropboxVerified
                    ? 'Archivos verificados contra Dropbox.'
                    : 'Verificación contra Dropbox desactivada: los archivos se toman como registrados en el sistema.'}
              </Alert>

              {/* Banner: listo para generar */}
              {(readinessMap[selectedWorkOrderForValidation?.id]?.ricReady || readinessMap[selectedWorkOrderForValidation?.id]?.pipcReady) && (
                <Box sx={{ mb: 2, p: 1.5, bgcolor: '#e8f5e9', border: '1px solid #4caf50', borderRadius: 2, display: 'flex', alignItems: 'flex-start', gap: 1.5 }}>
                  <CheckCircle sx={{ color: '#4caf50', fontSize: 22, mt: 0.2 }} />
                  <Box>
                    {readinessMap[selectedWorkOrderForValidation?.id]?.ricReady && (
                      <Typography variant="body2" fontWeight={700} color="#2e7d32">
                        Listo para generar RIC ({getGenerationScopeLabel(selectedWorkOrderForValidation?.id, 'ric')})
                      </Typography>
                    )}
                    {readinessMap[selectedWorkOrderForValidation?.id]?.pipcReady && (
                      <Typography variant="body2" fontWeight={700} color="#2e7d32">
                        Listo para generar PIPC ({getGenerationScopeLabel(selectedWorkOrderForValidation?.id, 'pipc')})
                      </Typography>
                    )}
                    <Typography variant="caption" color="#388e3c">Puedes generar el documento desde el menú de acciones; solo se genera para los entes que ya están completos.</Typography>
                  </Box>
                </Box>
              )}

              {/* === MATRIZ === */}
              {validationData.matriz && (() => {
                const m = validationData.matriz;
                const mRicPct = m.ric?.completionPercentage ?? 0;
                const mPipcPct = m.pipc?.completionPercentage ?? 0;
                const mDocsPct = m.documentos?.completionPercentage ?? 0;
                const mCartaPct = m.carta?.completionPercentage ?? 0;
                const mActaPct = m.acta?.completionPercentage ?? 0;
                const mComplete = mRicPct === 100 && mPipcPct === 100 && mDocsPct === 100 && mCartaPct === 100 && mActaPct === 100;
                return (
                  <Paper elevation={0} sx={{ mb: 2, overflow: 'hidden', border: '2px solid #00695c', borderRadius: 2 }}>
                    <Box
                      sx={{ px: 2, py: 1.5, bgcolor: '#00695c', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}
                      onClick={() => toggleEntityExpanded('matriz')}
                    >
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                        <Assignment sx={{ color: '#fff', fontSize: 20 }} />
                        <Box>
                          <Typography variant="subtitle2" fontWeight={700} sx={{ color: '#fff', lineHeight: 1.2 }}>
                            {m.entityName}
                            {m.assignedUserName && (
                              <Typography component="span" variant="caption" sx={{ color: 'rgba(255,255,255,0.75)', fontWeight: 400, ml: 1 }}>
                                · {m.assignedUserName}
                              </Typography>
                            )}
                          </Typography>
                          <Typography variant="caption" sx={{ color: 'rgba(255,255,255,0.75)' }}>
                            RIC {mRicPct}% · PIPC {mPipcPct}% · Carta {mCartaPct}% · Acta {mActaPct}% · Documentos {mDocsPct}%
                          </Typography>
                        </Box>
                      </Box>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        {mComplete
                          ? <Chip label="Completo" size="small" sx={{ bgcolor: '#a5d6a7', color: '#1b5e20', fontWeight: 700, fontSize: '0.7rem' }} />
                          : <Chip label="Pendiente" size="small" sx={{ bgcolor: '#ffcc80', color: '#e65100', fontWeight: 700, fontSize: '0.7rem' }} />}
                        <Typography variant="caption" sx={{ color: 'rgba(255,255,255,0.8)' }}>
                          {expandedEntities.matriz ? '▲' : '▼'}
                        </Typography>
                      </Box>
                    </Box>
                    <Collapse in={expandedEntities.matriz}>
                      <Box sx={{ p: 2 }}>
                        {renderEntityDocTabs(m, 'matriz')}
                      </Box>
                    </Collapse>
                  </Paper>
                );
              })()}

              {/* === SUCURSALES === */}
              {(validationData.branches || []).map((branch, idx) => {
                const bRicPct = branch.ric?.completionPercentage ?? 0;
                const bPipcPct = branch.pipc?.completionPercentage ?? 0;
                const bDocsPct = branch.documentos?.completionPercentage ?? 0;
                const bCartaPct = branch.carta?.completionPercentage ?? 0;
                const bActaPct = branch.acta?.completionPercentage ?? 0;
                const bComplete = bRicPct === 100 && bPipcPct === 100 && bDocsPct === 100 && bCartaPct === 100 && bActaPct === 100;
                return (
                  <Paper key={idx} elevation={0} sx={{ mb: 2, overflow: 'hidden', border: '2px solid #1565c0', borderRadius: 2 }}>
                    <Box
                      sx={{ px: 2, py: 1.5, bgcolor: '#1565c0', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}
                      onClick={() => toggleEntityExpanded(`branch_${idx}`)}
                    >
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                        <Folder sx={{ color: '#fff', fontSize: 20 }} />
                        <Box>
                          <Typography variant="subtitle2" fontWeight={700} sx={{ color: '#fff', lineHeight: 1.2 }}>
                            {branch.entityName}
                            {branch.assignedUserName && (
                              <Typography component="span" variant="caption" sx={{ color: 'rgba(255,255,255,0.75)', fontWeight: 400, ml: 1 }}>
                                · {branch.assignedUserName}
                              </Typography>
                            )}
                          </Typography>
                          <Typography variant="caption" sx={{ color: 'rgba(255,255,255,0.75)' }}>
                            RIC {bRicPct}% · PIPC {bPipcPct}% · Carta {bCartaPct}% · Acta {bActaPct}% · Documentos {bDocsPct}%
                          </Typography>
                        </Box>
                      </Box>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        {bComplete
                          ? <Chip label="Completo" size="small" sx={{ bgcolor: '#90caf9', color: '#0d47a1', fontWeight: 700, fontSize: '0.7rem' }} />
                          : <Chip label="Pendiente" size="small" sx={{ bgcolor: '#ffcc80', color: '#e65100', fontWeight: 700, fontSize: '0.7rem' }} />}
                        <Typography variant="caption" sx={{ color: 'rgba(255,255,255,0.8)' }}>
                          {expandedEntities[`branch_${idx}`] ? '▲' : '▼'}
                        </Typography>
                      </Box>
                    </Box>
                    <Collapse in={expandedEntities[`branch_${idx}`]}>
                      <Box sx={{ p: 2 }}>
                        {renderEntityDocTabs(branch, `branch_${idx}`)}
                      </Box>
                    </Collapse>
                  </Paper>
                );
              })}

              {(validationData.hiddenEntities || []).length > 0 ? (
                <Alert severity="info" sx={{ mt: 1 }}>
                  Esta OT tiene {validationData.hiddenEntities.length} ente{validationData.hiddenEntities.length > 1 ? 's' : ''} más
                  {' '}asignado{validationData.hiddenEntities.length > 1 ? 's' : ''} a otro ejecutivo; aquí solo ves los tuyos:
                  {validationData.hiddenEntities.map((h, i) => (
                    <Box key={i} component="span" sx={{ display: 'block', ml: 1 }}>
                      • <strong>{h.entityName}</strong> ({h.entityType === 'MATRIZ' ? 'Matriz' : 'Sucursal'}) — {h.assignedUserName || 'sin asignar'}
                    </Box>
                  ))}
                </Alert>
              ) : (validationData.branches || []).length === 0 && (
                <Alert severity="info" sx={{ mt: 1 }}>
                  No hay sucursales vinculadas a esta cotización. Solo se valida la Matriz.
                </Alert>
              )}
            </Box>
          ) : null}
        </DialogContent>
        <DialogActions sx={{ p: 2 }}>
          <Button 
            onClick={() => {
              setValidationDialogOpen(false);
              setValidationData(null);
              setSelectedWorkOrderForValidation(null);
            }}
            variant="contained"
            sx={{ bgcolor: '#009688', '&:hover': { bgcolor: '#00796b' }, borderRadius: 2 }}
          >
            Cerrar
          </Button>
        </DialogActions>
      </Dialog>

      {/* Confirmación previa a "Generar Constancias" -- muestra qué entes la recibirán antes
          de ejecutar la generación real, respetando la misma restricción por rol del backend. */}
      <Dialog
        open={constanciasSummaryDialogOpen}
        onClose={constanciasGenerating ? undefined : handleCloseConstanciasSummary}
        maxWidth="xs"
        fullWidth
        PaperProps={{ sx: { borderRadius: 3 } }}
      >
        <DialogTitle sx={{ fontWeight: 700, display: 'flex', alignItems: 'center', gap: 1 }}>
          <Description sx={{ color: '#7b1fa2' }} />
          Generar Constancias
        </DialogTitle>
        <DialogContent dividers>
          {constanciasSummaryLoading ? (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, py: 2 }}>
              <CircularProgress size={20} />
              <Typography variant="body2">Calculando qué entes recibirán constancias...</Typography>
            </Box>
          ) : constanciasSummary.length === 0 ? (
            <Typography variant="body2" color="text.secondary">
              Esta orden de trabajo no tiene entes registrados.
            </Typography>
          ) : (() => {
            const includedItems = constanciasSummary.filter(i => i.included);
            const excludedItems = constanciasSummary.filter(i => !i.included);
            return (
              <>
                {includedItems.length > 0 ? (
                  <>
                    <Typography variant="body2" sx={{ mb: 1.5 }}>
                      Se generarán constancias para:
                    </Typography>
                    {includedItems.map((item, idx) => (
                      <Box
                        key={idx}
                        sx={{
                          display: 'flex', alignItems: 'flex-start', gap: 1, py: 0.75,
                          borderBottom: idx < includedItems.length - 1 ? '1px solid #f0f0f0' : 'none'
                        }}
                      >
                        {item.hasTraining
                          ? <CheckCircle sx={{ color: '#4caf50', fontSize: 20, mt: 0.2 }} />
                          : <Warning sx={{ color: '#ed6c02', fontSize: 20, mt: 0.2 }} />}
                        <Box sx={{ flex: 1 }}>
                          <Typography variant="body2" fontWeight={600}>
                            {item.entityLabel} — {item.memberCount} integrante{item.memberCount === 1 ? '' : 's'}
                          </Typography>
                          {!item.hasTraining && (
                            <Typography variant="caption" color="#ed6c02">
                              Sin capacitación registrada
                            </Typography>
                          )}
                        </Box>
                      </Box>
                    ))}
                  </>
                ) : (
                  <Typography variant="body2" color="#ed6c02" fontWeight={600} sx={{ mb: 1.5 }}>
                    No se generará ninguna constancia — ver los motivos abajo.
                  </Typography>
                )}

                {excludedItems.length > 0 && (
                  <Box sx={{ mt: includedItems.length > 0 ? 2 : 0 }}>
                    <Typography variant="caption" fontWeight={700} color="text.secondary" sx={{ textTransform: 'uppercase', letterSpacing: 0.3 }}>
                      No se generarán para:
                    </Typography>
                    {excludedItems.map((item, idx) => (
                      <Box
                        key={idx}
                        sx={{
                          display: 'flex', alignItems: 'flex-start', gap: 1, py: 0.75,
                          borderBottom: idx < excludedItems.length - 1 ? '1px solid #f0f0f0' : 'none'
                        }}
                      >
                        <RemoveCircleOutlineIcon sx={{ color: '#9e9e9e', fontSize: 20, mt: 0.2 }} />
                        <Box sx={{ flex: 1 }}>
                          <Typography variant="body2" fontWeight={600} color="text.secondary">
                            {item.entityLabel}
                          </Typography>
                          <Typography variant="caption" color="text.secondary">
                            {item.reason}
                          </Typography>
                        </Box>
                      </Box>
                    ))}
                  </Box>
                )}

                {constanciasGenerating && (
                  <Box sx={{ mt: 2 }}>
                    <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                      Generando y subiendo las constancias a Dropbox…
                    </Typography>
                    <LinearProgress variant="determinate" value={constanciasProgress.progressPct} sx={{ height: 8, borderRadius: 4 }} />
                    <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 1, textAlign: 'center' }}>
                      Esto puede tomar unos minutos…
                    </Typography>
                  </Box>
                )}

                {includedItems.length > 0 && (
                  <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1, mt: 2, p: 1.5, bgcolor: '#f5f5f5', borderRadius: 2 }}>
                    <Folder sx={{ color: '#757575', fontSize: 18, mt: 0.2 }} />
                    <Typography variant="caption" color="text.secondary">
                      Podrás consultar las constancias generadas en Servicios &gt; Gestión Documental.
                    </Typography>
                  </Box>
                )}
              </>
            );
          })()}
        </DialogContent>
        <DialogActions sx={{ p: 2 }}>
          <Button onClick={handleCloseConstanciasSummary} disabled={constanciasGenerating}>
            Cancelar
          </Button>
          <Button
            onClick={handleConfirmGenerateConstancias}
            variant="contained"
            disabled={constanciasSummaryLoading || constanciasGenerating || !constanciasSummary.some(i => i.included)}
            sx={{ bgcolor: '#7b1fa2', '&:hover': { bgcolor: '#6a1b9a' }, borderRadius: 2 }}
          >
            {constanciasGenerating ? 'Generando...' : 'Confirmar y generar'}
          </Button>
        </DialogActions>
      </Dialog>

    </Box>
  );
};

export default Programas;
